import es from "react-intl/locale-data/es";
import { config } from "./domainConfig";

export let Videos360 = [
  /*{
    id: 2,
    contents: 24,
    categoryName: {
      en: "Adventure",
      fr: "Aventure",
      de: "Abenteuer",
      be: "Avontuur",
      tr: "Macera",
      pt: "Aventura",
      no: "Eventyr",
      cy: "Авантура",
      ee: "Seiklus",
      th: "การผจญภัย",
      ar: "مغامرة",
      gr: "Περιπέτεια",
      es: "Aventura",
      it: "Avventura",
      id: "Petualangan",
      si: "Avantura",
      pl: "Przygoda",
    },
    videos: [
      {
        duration: 279,
        id: 30,
        name: {
          en: "One Day in Bali",
          fr: "One Day in Bali",
          be: "One Day in Bali",
          tr: "One Day in Bali",
          de: "One Day in Bali",
          ar: "One Day in Bali",
          id: "One Day in Bali",
          si: "En dan na Baliju",
          pl: "Jeden dzień na Bali",
          th: "หนึ่งวันในบาหลี",
          es: "Un día en Bali",
          cy: "Један дан на Балију",
        },
        preview: "https://cdn.mobio360.com/Adventure/One+Day+in+Bali.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Adventure/One+Day+in+Bali.mp4",
      },
      {
        duration: 21334,
        id: 200,
        name: {
          en: "One Day in Ecuador's Shoreline",
          fr: "One Day in Ecuador's Shoreline",
          be: "One Day in Ecuador's Shoreline",
          tr: "One Day in Ecuador's Shoreline",
          de: "One Day in Ecuador's Shoreline",
          ar: "One Day in Ecuador's Shoreline",
          id: "One Day in Ecuador's Shoreline",
          si: "En dan na obali Ekvadorja",
          pl: "Jeden dzień na wybrzeżu Ekwadoru",
          th: "หนึ่งวันที่ชายฝั่งเอกวาดอร์",
          es: "Un día en la costa de Ecuador",
          cy: "Један дан на обали Еквадора",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Ecuador%E2%80%99s+Shoreline.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Ecuador%E2%80%99s+Shoreline.mp4",
      },
      {
        duration: 21334,
        id: 201,
        name: {
          en: "One Day in Galway & Cliffs of Moher",
          fr: "One Day in Galway & Cliffs of Moher",
          be: "One Day in Galway & Cliffs of Moher",
          tr: "One Day in Galway & Cliffs of Moher",
          de: "One Day in Galway & Cliffs of Moher",
          ar: "One Day in Galway & Cliffs of Moher",
          id: "One Day in Galway & Cliffs of Moher",
          si: "En dan v Galwayju in na klifih Moher",
          pl: "Jeden dzień w Galway i na Klifach Moheru",
          th: "หนึ่งวันที่กัลเวย์และหน้าผาโมเฮอร์",
          es: "Un día en Galway y los acantilados de Moher",
          cy: "Један дан у Голвеју и литицама Мохер",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Galway+_+Cliffs+of+Moher-001.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Galway+_+Cliffs+of+Moher-001.mp4",
      },
      {
        duration: 21334,
        id: 202,
        name: {
          en: "One Day in Iceland",
          fr: "One Day in Iceland",
          be: "One Day in Iceland",
          tr: "One Day in Iceland",
          de: "One Day in Iceland",
          ar: "One Day in Iceland",
          id: "One Day in Iceland",
          si: "En dan na Islandiji",
          pl: "Jeden dzień w Islandii",
          th: "หนึ่งวันในไอซ์แลนด์",
          es: "Un día en Islandia",
          cy: "Један дан на Исланду",
        },
        preview: "https://cdn.mobio360.com/Adventure/One+Day+in+Iceland.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Adventure/One+Day+in+Iceland.mp4",
      },
      {
        duration: 21334,
        id: 203,
        name: {
          en: "One Day in Madeira, Portugal",
          fr: "One Day in Madeira, Portugal",
          be: "One Day in Madeira, Portugal",
          tr: "One Day in Madeira, Portugal",
          de: "One Day in Madeira, Portugal",
          ar: "One Day in Madeira, Portugal",
          id: "One Day in Madeira, Portugal",
          si: "En dan na Madeiri, Portugalska",
          pl: "Jeden dzień na Maderze, Portugalia",
          th: "หนึ่งวันในมาเดรา ประเทศโปรตุเกส",
          es: "Un día en Madeira, Portugal",
          cy: "Један дан на Мадеири, Португал",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Madeira%2C+Portugal-003.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Madeira%2C+Portugal-003.mp4",
      },
      {
        duration: 21335,
        id: 204,
        name: {
          en: "One Day in Malta's Beaches",
          fr: "One Day in Malta's Beaches",
          be: "One Day in Malta's Beaches",
          tr: "One Day in Malta's Beaches",
          de: "One Day in Malta's Beaches",
          ar: "One Day in Malta's Beaches",
          id: "One Day in Malta's Beaches",
          si: "En dan na plažah Malte",
          pl: "Jeden dzień na plażach Malty",
          th: "หนึ่งวันบนชายหาดของมอลตา",
          es: "Un día en las playas de Malta",
          cy: "Један дан на плажама Малте",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Malta%E2%80%99s+Beaches.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Malta%E2%80%99s+Beaches.mp4",
      },
      {
        duration: 21336,
        id: 205,
        name: {
          en: "One Day in Santorini, Greece",
          fr: "One Day in Santorini, Greece",
          be: "One Day in Santorini, Greece",
          tr: "One Day in Santorini, Greece",
          de: "One Day in Santorini, Greece",
          ar: "One Day in Santorini, Greece",
          id: "One Day in Santorini, Greece",
          si: "En dan na Santoriniju, Grčija",
          pl: "Jeden dzień na Santorini, Grecja",
          th: "หนึ่งวันในซานโตรินี ประเทศกรีซ",
          es: "Un día en Santorini, Grecia",
          cy: "Један дан на Санторинију, Грчка",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Santorini%2C+Greece.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Santorini%2C+Greece.mp4",
      },
    ],
  },
  {
    id: 17,
    contents: 3,
    categoryName: {
      en: "City Tour",
      fr: "City Tour",
      de: "City Tour",
      be: "City Tour",
      tr: "City Tour",
      pt: "City Tour",
      no: "City Tour",
      cy: "City Tour",
      ee: "City Tour",
      th: "ซิตี้ทัวร์",
      gr: "City Tour",
      es: "Tour por la ciudad",
      it: "City Tour",
      ar: "City Tour",
      id: "Tur Kota",
      si: "Mestna tura",
      pl: "Wycieczka po mieście",
      cy: "Обилазак града",
    },
    videos: [
      {
        duration: 21334,
        id: 228,
        name: {
          en: "One Day in Bangkok",
          fr: "One Day in Bangkok",
          be: "One Day in Bangkok",
          tr: "One Day in Bangkok",
          de: "One Day in Bangkok",
          ar: "One Day in Bangkok",
          id: "One Day in Bangkok",
          si: "En dan v Bangkoku",
          pl: "Jeden dzień w Bangkoku",
          th: "หนึ่งวันในกรุงเทพฯ",
          es: "Un día en Bangkok",
          cy: "Један дан у Бангкоку",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bangkok.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bangkok.mp4",
      },
      {
        duration: 21334,
        id: 229,
        name: {
          en: "One Day in Bogota",
          fr: "One Day in Bogota",
          be: "One Day in Bogota",
          tr: "One Day in Bogota",
          de: "One Day in Bogota",
          ar: "One Day in Bogota",
          id: "One Day in Bogota",
          pl: "Jeden dzień w Bogocie",
          th: "หนึ่งวันในโบโกตา",
          es: "Un día en Bogotá",
          cy: "Један дан у Боготи",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bogota.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bogota.mp4",
      },
      {
        duration: 21334,
        id: 230,
        name: {
          en: "One Day in Cairo",
          fr: "One Day in Cairo",
          be: "One Day in Cairo",
          tr: "One Day in Cairo",
          de: "One Day in Cairo",
          ar: "One Day in Cairo",
          id: "One Day in Cairo",
          si: "En dan v Bogoti",
          pl: "Jeden dzień w Kairze",
          th: "หนึ่งวันในไคโร",
          es: "Un día en El Cairo",
          cy: "Један дан у Каиру",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Cairo.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Cairo.mp4",
      },
      {
        duration: 21334,
        id: 231,
        name: {
          en: "One Day in Jerusalem",
          fr: "One Day in Jerusalem",
          be: "One Day in Jerusalem",
          tr: "One Day in Jerusalem",
          de: "One Day in Jerusalem",
          ar: "One Day in Jerusalem",
          id: "One Day in Jerusalem",
          si: "En dan v Jeruzalemu",
          pl: "Jeden dzień w Jerozolimie",
          th: "หนึ่งวันในเยรูซาเล็ม",
          es: "Un día en Jerusalén",
          cy: "Један дан у Јерусалиму",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Jerusalem.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Jerusalem.mp4",
      },
      {
        duration: 21334,
        id: 232,
        name: {
          en: "One Day in London",
          fr: "One Day in London",
          be: "One Day in London",
          tr: "One Day in London",
          de: "One Day in London",
          ar: "One Day in London",
          id: "One Day in London",
          si: "En dan v Londonu",
          pl: "Jeden dzień w Londynie",
          th: "หนึ่งวันในลอนดอน",
          es: "Un día en Londres",
          cy: "Један дан у Лондону",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+London.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+London.mp4",
      },
      {
        duration: 2133,
        id: 238,
        name: {
          en: "One Day in Marrakech",
          fr: "One Day in Marrakech",
          be: "One Day in Marrakech",
          tr: "One Day in Marrakech",
          de: "One Day in Marrakech",
          ar: "One Day in Marrakech",
          id: "One Day in Marrakech",
          si: "En dan v Marakešu",
          pl: "Jeden dzień w Marrakeszu",
          th: "หนึ่งวันในมาร์ราเกช",
          es: "Un día en Marrakech",
          cy: "Један дан у Маракешу",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Marrakech.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Marrakech.mp4",
      },
      {
        duration: 2133,
        id: 239,
        name: {
          en: "One Day in New York City",
          fr: "One Day in New York City",
          be: "One Day in New York City",
          tr: "One Day in New York City",
          de: "One Day in New York City",
          ar: "One Day in New York City",
          id: "One Day in New York City",
          si: "En dan v New Yorku",
          pl: "Jeden dzień w Nowym Jorku",
          th: "หนึ่งวันในนิวยอร์กซิตี้",
          es: "Un día en la ciudad de Nueva York",
          cy: "Један дан у Њујорку",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+New+York+City.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+New+York+City.mp44",
      },
      {
        duration: 2133,
        id: 246,
        name: {
          en: "One Day in Paris",
          fr: "One Day in Paris",
          be: "One Day in Paris",
          tr: "One Day in Paris",
          de: "One Day in Paris",
          ar: "One Day in Paris",
          id: "One Day in Paris",
          si: "En dan v Parizu",
          pl: "Jeden dzień w Paryżu",
          th: "หนึ่งวันในปารีส",
          es: "Un día en París",
          cy: "Један дан у Паризу",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Paris.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Paris.mp4",
      },
      {
        duration: 2133,
        id: 247,
        name: {
          en: "One Day in Rome",
          fr: "One Day in Rome",
          be: "One Day in Rome",
          tr: "One Day in Rome",
          de: "One Day in Rome",
          ar: "One Day in Rome",
          id: "One Day in Rome",
          si: "En dan v Rimu",
          pl: "Jeden dzień w Rzymie",
          th: "หนึ่งวันในโรม",
          es: "Un día en Roma",
          cy: "Један дан у Риму",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Rome+4K.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Rome+4K.mp4",
      },
      {
        duration: 2133,
        id: 248,
        name: {
          en: "One Day in Singapore",
          fr: "One Day in Singapore",
          be: "One Day in Singapore",
          tr: "One Day in Singapore",
          de: "One Day in Singapore",
          ar: "One Day in Singapore",
          id: "One Day in Singapore",
          si: "En dan v Singapurju",
          pl: "Jeden dzień w Singapurze",
          th: "หนึ่งวันในสิงคโปร์",
          es: "Un día en Singapur",
          cy: "Један дан у Сингапуру",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Singapore.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/City+Tour/One+Day+in+Singapore.mp4",
      },
    ],
  },
  {
    id: 18,
    contents: 3,
    categoryName: {
      en: "Documentary",
      fr: "Documentary",
      de: "Documentary",
      be: "Documentary",
      tr: "Documentary",
      pt: "Documentary",
      no: "Documentary",
      cy: "Documentary",
      ee: "Documentary",
      th: "สารคดี",
      gr: "Documentary",
      es: "Documental",
      it: "Documentary",
      ar: "Documentary",
      id: "Dokumenter",
      si: "Dokumentarec",
      pl: "Dokument",
      cy: "Документарни",
    },
    videos: [
      {
        duration: 21334,
        id: 233,
        name: {
          en: "One Day in Siem Reap",
          fr: "One Day in Siem Reap",
          be: "One Day in Siem Reap",
          tr: "One Day in Siem Reap",
          de: "One Day in Siem Reap",
          ar: "One Day in Siem Reap",
          id: "One Day in Siem Reap",
          si: "En dan v Siem Reapu",
          pl: "Jeden dzień w Siem Reap",
          th: "หนึ่งวันในเสียมเรียบ",
          es: "Un día en Siem Reap",
          cy: "Један дан у Сијем Реапу",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/One+Day+in+Siem+Reap.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Documentary/One+Day+in+Siem+Reap.mp4",
      },
      {
        duration: 21334,
        id: 234,
        name: {
          en: "One Day in the Republic of Congo",
          fr: "One Day in the Republic of Congo",
          be: "One Day in the Republic of Congo",
          tr: "One Day in the Republic of Congo",
          de: "One Day in the Republic of Congo",
          ar: "One Day in the Republic of Congo",
          id: "One Day in the Republic of Congo",
          si: "En dan v Republiki Kongo",
          pl: "Jeden dzień w Republice Konga",
          th: "หนึ่งวันในสาธารณรัฐคองโก",
          es: ' "Un día en la República del Congo",',
          cy: "Један дан у Републици Конго",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/One+Day+in+the+Republic+of+Congo.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Documentary/One+Day+in+the+Republic+of+Congo.mp4",
      },
      {
        duration: 21334,
        id: 235,
        name: {
          en: "Holi Festival in India",
          fr: "Holi Festival in India",
          be: "Holi Festival in India",
          tr: "Holi Festival in India",
          de: "Holi Festival in India",
          ar: "Holi Festival in India",
          id: "Holi Festival in India",
          si: "Festival Holi v Indiji",
          pl: "Festiwal Holi w Indiach",
          th: "เทศกาลโฮลีในอินเดีย",
          es: "Festival Holi en India",
          cy: "Фестивал Холи у Индији",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/Holi+Festival+in+India.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Documentary/Holi+Festival+in+India.mp4",
      },
      {
        duration: 21334,
        id: 236,
        name: {
          en: "Explore Agra",
          fr: "Explore Agra",
          be: "Explore Agra",
          tr: "Explore Agra",
          de: "Explore Agra",
          ar: "Explore Agra",
          id: "Explore Agra",
          si: "Raziskovanje Agre",
          pl: "Poznaj Agrę",
          th: "สำรวจอักรา",
          es: "Explorar Agra",
          cy: "Истражите Агру",
        },
        preview: "https://cdn.mobio360.com/Documentary/Explore+Agra.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Documentary/Explore+Agra.mp4",
      },
      {
        duration: 21334,
        id: 237,
        name: {
          en: "One Day with a Figure Skater",
          fr: "One Day with a Figure Skater",
          be: "One Day with a Figure Skater",
          tr: "One Day with a Figure Skater",
          de: "One Day with a Figure Skater",
          ar: "One Day with a Figure Skater",
          id: "One Day with a Figure Skater",
          si: "En dan s figuralnim drsalcem",
          pl: "Jeden dzień z łyżwiarzem figurowym",
          th: "หนึ่งวันกับนักสเก็ตลีลา",
          es: "Un día con un patinador artístico",
          cy: "Један дан са клизачем",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/One+Day+with+a+Figure+Skater.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Documentary/One+Day+with+a+Figure+Skater.mp4",
      },
      {
        duration: 21334,
        id: 249,
        name: {
          en: "Figure Skating Routine",
          fr: "Figure Skating Routine",
          be: "Figure Skating Routine",
          tr: "Figure Skating Routine",
          de: "Figure Skating Routine",
          ar: "Figure Skating Routine",
          id: "Figure Skating Routine",
          si: "Rutina umetnostnega drsanja",
          pl: "Rutyna łyżwiarska",
          th: "ท่ารำสเก็ตลีลา",
          es: "Rutina de patinaje artístico",
          cy: "Програм уметничког клизања",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/Figure+Skating+Routine.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Documentary/Figure+Skating+Routine.mp4",
      },
    ],
  },
  {
    id: 16,
    contents: 4,
    categoryName: {
      en: "Meditation",
      fr: "Meditation",
      de: "Meditation",
      be: "Meditation",
      tr: "Meditation",
      pt: "Meditation",
      no: "Meditation",
      cy: "Медитација",
      ee: "Meditation",
      th: "การทำสมาธิ",
      ar: "Meditation",
      gr: "Meditation",
      es: "Meditación",
      id: "Meditasi",
      si: "Meditacija",
      pl: "Medytacja",
    },
    videos: [
      {
        duration: 21334,
        id: 220,
        name: {
          en: "Meditation in Bali",
          fr: "Meditation in Bali",
          be: "Meditation in Bali",
          tr: "Meditation in Bali",
          de: "Meditation in Bali",
          ar: "Meditation in Bali",
          id: "Meditation in Bali",
          si: "Meditacija na Baliju",
          pl: "Medytacja na Bali",
          th: "การทำสมาธิในบาหลี",
          es: "Meditación en Bali",
          cy: "Медитација на Балију",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Meditation+in+Bali-004.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Meditation+in+Bali-004.mp4",
      },
      {
        duration: 21334,
        id: 221,
        name: {
          en: "Guided Meditation in the Azores Islands",
          fr: "Guided Meditation in the Azores Islands",
          be: "Guided Meditation in the Azores Islands",
          tr: "Guided Meditation in the Azores Islands",
          de: "Guided Meditation in the Azores Islands",
          ar: "Guided Meditation in the Azores Islands",
          id: "Guided Meditation in the Azores Islands",
          si: "Vodenje meditacije na Azorskih otokih",
          pl: "Medytacja z przewodnikiem na Wyspach Azorach",
          th: "การทำสมาธิแบบมีผู้แนะนำที่หมู่เกาะอะซอเรส",
          es: "Meditación guiada en las Islas Azores",
          cy: "Вођена медитација на Азорским острвима",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Guided+Meditation+in+the+Azores+Islands-002.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Guided+Meditation+in+the+Azores+Islands-002.mp4",
      },
      {
        duration: 21334,
        id: 222,
        name: {
          en: "Box breathing in Nature",
          fr: "Box breathing in Nature",
          be: "Box breathing in Nature",
          tr: "Box breathing in Nature",
          de: "Box breathing in Nature",
          ar: "Box breathing in Nature",
          id: "Box breathing in Nature",
          si: "Dihanje v obliki škatle v naravi",
          pl: "Oddychanie pudełkowe w naturze",
          th: "การหายใจแบบกล่องในธรรมชาติ",
          es: "Respiración en caja en la naturaleza",
          cy: "Квадратно дисање у природи",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Box+breathing+in+Nature.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Box+breathing+in+Nature.mp4",
      },
      {
        duration: 21334,
        id: 223,
        name: {
          en: "Cliff and waves meditation",
          fr: "Cliff and waves meditation",
          be: "Cliff and waves meditation",
          tr: "Cliff and waves meditation",
          de: "Cliff and waves meditation",
          ar: "Cliff and waves meditation",
          id: "Cliff and waves meditation",
          si: "Meditacija na klifu in ob valovih",
          pl: "Medytacja na klifie i falach",
          th: "การทำสมาธิบนหน้าผาและเกลียวคลื่น",
          es: "Meditación en acantilados y olas",
          cy: "Медитација уз литице и таласе",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Cliff+and+waves+meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Cliff+and+waves+meditation.mp4",
      },
      {
        duration: 21334,
        id: 224,
        name: {
          en: "Beach with shells meditation",
          fr: "Beach with shells meditation",
          be: "Beach with shells meditation",
          tr: "Beach with shells meditation",
          de: "Beach with shells meditation",
          ar: "Beach with shells meditation",
          id: "Beach with shells meditation",
          si: "Meditacija na plaži s školjkami",
          pl: "Medytacja na plaży z muszlami",
          th: "การทำสมาธิบนชายหาดที่มีเปลือกหอย",
          es: "Meditación en la playa con conchas",
          cy: "Медитација на плажи са шкољкама",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Beach+with+shells+meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Beach+with+shells+meditation.mp4",
      },
      {
        duration: 21334,
        id: 225,
        name: {
          en: "Coast ocean Meditation",
          fr: "Coast ocean Meditation",
          be: "Coast ocean Meditation",
          tr: "Coast ocean Meditation",
          de: "Coast ocean Meditation",
          ar: "Coast ocean Meditation",
          id: "Coast ocean Meditation",
          si: "Meditacija ob morju",
          pl: "Medytacja nad oceanem",
          th: "การทำสมาธิริมชายฝั่งมหาสมุทร",
          es: "Meditación en la costa del océano",
          cy: "Медитација на обали океана",
        },
        preview:
          "https://cdn.mobio360.com/Meditation/Coast+Ocean+Meditation.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Meditation/Coast+Ocean+Meditation.mp4",
      },
      {
        duration: 21334,
        id: 226,
        name: {
          en: "Cliff meditation",
          fr: "Cliff meditation",
          be: "Cliff meditation",
          tr: "Cliff meditation",
          de: "Cliff meditation",
          ar: "Cliff meditation",
          id: "Cliff meditation",
          si: "Meditacija na klifu",
          pl: "Medytacja na klifie",
          th: "การทำสมาธิบนหน้าผา",
          es: "Meditación en acantilados",
          cy: "Медитација на литици",
        },
        preview: "https://cdn.mobio360.com/Meditation/Cliffs+Meditation.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Meditation/Cliffs+Meditation.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 227,
      //   name: {
      //     en: "Views From Machu Picchu Peru South America",
      //     fr: "Vues du Machu Picchu Pérou Amérique du Sud",
      //     be: "Uitzichten Van Machu Picchu Peru Zuid-Amerika",
      //     tr: "Views From Machu Picchu Peru South America",
      //     de: "Ansichten von Machu Picchu Peru Südamerika",
      //     ar: "مناظر من ماتشو بيتشو بيرو أمريكا الجنوبية",
      //     id: "Pemandangan dari Machu Picchu Peru Amerika Selatan"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Mountain+and+Sea/Views+From+Machu+Picchu+Peru+South+America.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Mountain+and+Sea/Views+From+Machu+Picchu+Peru+South+America.mp4",
      // },
    ],
  },
  {
    id: 13,
    contents: 10,
    categoryName: {
      en: "Nature",
      fr: "Nature",
      de: "Natur",
      be: "Natuur",
      tr: "Doğa",
      pt: "Natureza",
      no: "Natur",
      cy: "Природа",
      ee: "Loodus",
      th: "ธรรมชาติ",
      gr: "Φύση",
      ar: "طبيعة سجية",
      es: "Naturaleza",
      it: "Natura",
      id: "Alam",
      si: "Narava",
      pl: "Przyroda",
    },
    videos: [
      {
        duration: 21334,
        id: 204,
        name: {
          en: "Collections: Panoramic Nature Views",
          fr: "Collections: Panoramic Nature Views",
          be: "Collections: Panoramic Nature Views",
          tr: "Collections: Panoramic Nature Views",
          de: "Collections: Panoramic Nature Views",
          ar: "Collections: Panoramic Nature Views",
          id: "Collections: Panoramic Nature Views",
          si: "Kolekcije: Panoramski pogledi na naravo",
          pl: "Kolekcje: Panoramiczne widoki przyrody",
          th: "คอลเลกชัน: วิวธรรมชาติแบบพาโนรามา",
          es: "Colecciones: Vistas panorámicas de la naturaleza",
          cy: "Колекције: Панорамски погледи на природу",
        },
        preview:
          "https://cdn.mobio360.com/Nature/Collections_+Panoramic+Nature+Views.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Nature/Collections_+Panoramic+Nature+Views.mp4",
      },
      {
        duration: 21334,
        id: 205,
        name: {
          en: "Collections: Stunning Beaches",
          fr: "Collections: Stunning Beaches",
          be: "Collections: Stunning Beaches",
          tr: "Collections: Stunning Beaches",
          de: "Collections: Stunning Beaches",
          ar: "Collections: Stunning Beaches",
          id: "Collections: Stunning Beaches",
          pl: "Kolekcje: Oszałamiające plaże",
          th: "คอลเลกชัน: ชายหาดที่สวยงามตระการตา",
          es: "Colecciones: Playas impresionantes",
          cy: "Колекције: Задивљујуће плаже",
        },
        preview:
          "https://cdn.mobio360.com/Nature/Collections_+Stunning+Beaches.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Nature/Collections_+Stunning+Beaches.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 206,
      //   name: {
      //     en: "Diamondback Rattlesnake In The Arid Desert 2021",
      //     fr: "Crotale à dos de diamant dans le désert aride 2021",
      //     be: "Diamantrug ratelslang in de dorre woestijn 2021",
      //     tr: "Diamondback Rattlesnake In The Arid Desert 2021",
      //     de: "Diamantrücken-Klapperschlange in der Ödlandwüste 2021",
      //     ar: "أفعى الجرسية ذات الظهر الماسي في الصحراء القاحلة 2021",
      //     id: "Ular berbisa Diamondback di Gurun Kering 2021"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Diamondback+Rattlesnake+In+The+Arid+Desert+2021.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Diamondback+Rattlesnake+In+The+Arid+Desert+2021.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 207,
      //   name: {
      //     en: "Gentoo Penguins Antarctica",
      //     fr: "Manchots Gentoo en Antarctique",
      //     be: "Ezelspinguïns op Antarctica",
      //     tr: "Gentoo Penguins Antarctica",
      //     de: "Eselspinguine in der Antarktis",
      //     ar: "طيور البطريق جينتو أنتاركتيكا",
      //     id: "Penguin Gentoo Antartika"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Gentoo+Penguins+Antarctica.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Gentoo+Penguins+Antarctica.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 208,
      //   name: {
      //     en: "Playful Capuchin Monkeys In The Jungle 2021",
      //     fr: "Singes capucins enjoués dans la jungle 2021",
      //     be: "Speelse kapucijneraapjes in de jungle 2021",
      //     tr: "Playful Capuchin Monkeys In The Jungle 2021",
      //     de: "Verspielte Kapuzineräffchen im Dschungel 2021",
      //     ar: "قرود كابوشين مرحة في الغابة 2021",
      //     id: "Monyet Capuchin yang Penuh Main di Hutan 2021"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Playful+Capuchin+Monkeys+In+The+Jungle+2021.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Playful+Capuchin+Monkeys+In+The+Jungle+2021.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 209,
      //   name: {
      //     en: "Schrainbach Waterfall Konigssee Lake Berchtesgaden National Park Bavaria Germany Europe",
      //     fr: "Cascade de Schrainbach Lac de Konigssee Parc national de Berchtesgaden Bavière Allemagne Europe",
      //     be: "Schrainbach Waterval Konigssee Meer Berchtesgaden Nationaal Park Bavaria Duitsland Europa",
      //     tr: "Schrainbach Waterfall Konigssee Lake Berchtesgaden National Park Bavaria Germany Europe",
      //     de: "Schrainbach Wasserfall Königssee Nationalpark Berchtesgadener Land Bayern Deutschland Europa",
      //     ar: " شلال سخرينباش كونغسه و بحيرة بيرختجادين ناشونال بارك في بافاريا ألمانيا في أوروبا",
      //     id: "Air Terjun Schrainbach Danau Konigssee Taman Nasional Berchtesgaden Bavaria Jerman Eropa"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/Schrainbach+Waterfall+Konigssee+Lake+Berchtesgaden+National+Park+Bavaria+Germany+Europe.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/Schrainbach+Waterfall+Konigssee+Lake+Berchtesgaden+National+Park+Bavaria+Germany+Europe.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 210,
      //   name: {
      //     en: "View Over Cliff Edge Victoria Falls Zambezi River Africa",
      //     fr: "Vue sur le bord de la falaise Chutes Victoria Fleuve Zambèze Afrique",
      //     be: "Uitzicht over klifrand Victoria Falls Zambezi Rivier Afrika",
      //     tr: "View Over Cliff Edge Victoria Falls Zambezi River Africa",
      //     de: "Blick über den Klippenrand Victoria Falls Sambesi Fluss Afrika",
      //     ar: "منظر على كليف إيدج فيكتوريا فولز نهر زامبيزي أفريقيا",
      //     id: "Pemandangan di tepi jurang Victoria Falls Sungai Zambezi Afrika"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Nature/View+Over+Cliff+Edge+Victoria+Falls+Zambezi+River+Africa.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Nature/View+Over+Cliff+Edge+Victoria+Falls+Zambezi+River+Africa.mp4",
      // },
    ],
  },
  {
    id: 14,
    contents: 10,
    categoryName: {
      en: "Animals",
      fr: "Animals",
      de: "Animals",
      be: "Animals",
      tr: "Animals",
      pt: "Animals",
      no: "Animals",
      cy: "Животиње",
      ee: "Animals",
      th: "สัตว์",
      gr: "Animals",
      es: "Animales",
      it: "Animals",
      ar: "Animals",
      id: "Hewan",
      si: "Živali",
      pl: "Zwierzęta",
    },
    videos: [
      {
        duration: 21334,
        id: 211,
        name: {
          en: "Animals Up Close",
          fr: "Animals Up Close",
          be: "Animals Up Close",
          tr: "Animals Up Close",
          de: "Animals Up Close",
          ar: "Animals Up Close",
          id: "Animals Up Close",
          si: "Živali od blizu",
          pl: "Zwierzęta z bliska",
          th: "สัตว์ในระยะใกล้",
          es: "Animales de cerca",
          cy: "Животиње из близине",
        },
        preview: "https://cdn.mobio360.com/Animals/Animals+Up+Close.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Animals/Animals+Up+Close.mp4",
      },
      {
        duration: 21334,
        id: 212,
        name: {
          en: "Farm Animals",
          fr: "Farm Animals",
          be: "Farm Animals",
          tr: "Farm Animals",
          de: "Farm Animals",
          ar: "Farm Animals",
          id: "Farm Animals",
          si: "Kmetijske živali",
          pl: "Zwierzęta gospodarskie",
          th: "สัตว์ในฟาร์ม",
          es: "Animales de granja",
          cy: "Домаће животиње",
        },
        preview: "https://cdn.mobio360.com/Animals/Farm+Animals-001.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Animals/Farm+Animals-001.mp4",
      },
      {
        duration: 21334,
        id: 213,
        name: {
          en: "Animals in the Zoo",
          fr: "Animals in the Zoo",
          be: "Animals in the Zoo",
          tr: "Animals in the Zoo",
          de: "Animals in the Zoo",
          ar: "Animals in the Zoo",
          id: "Animals in the Zoo",
          si: "Živali v živalskem vrtu",
          pl: "Zwierzęta w zoo",
          th: "สัตว์ในสวนสัตว์",
          es: ' "Animales en el zoológico",',
          cy: "Животиње у зоолошком врту",
        },
        preview: "https://cdn.mobio360.com/Animals/Animals+in+the+Zoo.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Animals/Animals+in+the+Zoo.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 214,
      //   name: {
      //     en: "One Day In Cairo English Voiceover",
      //     fr: "Un jour au Caire Voix off en anglais",
      //     be: "Een dag in Caïro Engelse Voice-over",
      //     tr: "One Day In Berlin English Voiceover",
      //     de: "Ein Tag in Kairo Englisch Voice-over",
      //     ar: "يوم واحد في الصوتية الإنجليزية القاهرة",
      //     id: "Satu Hari di Kairo Voiceover Bahasa Indonesia"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Cairo+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Cairo+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 215,
      //   name: {
      //     en: "One Day In Kuala-Lumpur English Voiceover",
      //     fr: "Un jour à Kuala-Lumpur Voix off en anglais",
      //     be: "Een Dag In Kuala-Lumpur Engelse Voice-over",
      //     tr: "One Day In Kuala-Lumpur English Voiceover",
      //     de: "Ein Tag in Kuala-Lumpur Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي باللغة الإنجليزية في كوالالمبور ",
      //     id: "Satu Hari di Kuala Lumpur Voiceover Bahasa Indonesia"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Kuala-Lumpur+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Kuala-Lumpur+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 216,
      //   name: {
      //     en: "One Day In London English Voiceover",
      //     fr: "Un jour à Londre Voix off en anglais",
      //     be: "Een Dag In Londen Engelse Voice-over",
      //     tr: "One Day In London English Voiceover",
      //     de: "Ein Tag in London Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي الإنجليزي في لندن",
      //     id: "Satu Hari di London Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+London+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+London+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 217,
      //   name: {
      //     en: "One Day In Madrid English Voiceover",
      //     fr: "Un jour à Madrid Voix off en anglais",
      //     be: "Een Dag In Madrid Engelse Voice-over",
      //     tr: "One Day In Madrid English Voiceover",
      //     de: "Ein Tag in Madrid Englisch Voice-over",
      //     ar: "يوم واحد في صناديق التعليق الصوتي للمدريد",
      //     id: "Satu Hari di Madrid Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Madrid+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Madrid+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 218,
      //   name: {
      //     en: "One Day In New-York City English Voiceover",
      //     fr: "Un jour à New-York Voix off anglaise",
      //     be: "Een Dag In New-York City Engelse Voice-over",
      //     tr: "One Day In New-York City English Voiceover",
      //     de: "Ein Tag in New York City Englisch Voice-over",
      //     ar: "يوم واحد في صناديق الصوتية الإنجليزية في مدينة نيويورك",
      //     id: "Satu Hari di Kota New York Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+New-York+City+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+New-York+City+English+Voiceover.mp4",
      // },
      // {
      //   duration: 21334,
      //   id: 219,
      //   name: {
      //     en: "One Day In Paris English Voiceover",
      //     fr: "Un jour à Paris Voix off en anglais",
      //     be: "Een Dag In Parijs Engelse Voice-over",
      //     tr: "One Day In Paris English Voiceover",
      //     de: "Ein Tag in Paris Englisch Voice-over",
      //     ar: "يوم واحد في التعليق الصوتي الإنجليزي باريس",
      //     id: "Satu Hari di Paris Suara Bahasa Inggris"
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Paris+English+Voiceover.jpg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Tourist+Attraction/One+Day+In+Paris+English+Voiceover.mp4",
      // },
    ],
  },
  {
    id: 15,
    contents: 7,
    categoryName: {
      en: "Music",
      id: "Musik",
      si: "Glasba",
      pl: "Muzyka",
      th: "ดนตรี",
      es: "Música",
      cy: "Музика",
    },
    videos: [
      {
        duration: 21334,
        id: 800,
        name: {
          en: "Turkish March - Wolfgang Amadeus Mozart",
          id: "Turkish March - Wolfgang Amadeus Mozart",
          si: "Turška marša - Wolfgang Amadeus Mozart",
          pl: "Marsz turecki – Wolfgang Amadeusz Mozart",
          th: "เพลงเดินตุรกี - โวล์ฟกัง อมาเดอุส โมซาร์ท",
          es: "Marcha Turca - Wolfgang Amadeus Mozart",
          cy: "Турски марш – Волфганг Амадеус Моцарт",
        },
        preview:
          "https://cdn.mobio360.com/Music/Turkish+March+-+Wolfgang+Amadeus+Mozart.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Music/Turkish+March+-+Wolfgang+Amadeus+Mozart.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        duration: 21334,
        id: 801,
        name: {
          en: "Storm - Antonio Vivaldi",
          id: "Storm - Antonio Vivaldi",
          si: "Nevihta - Antonio Vivaldi",
          pl: "Burza – Antonio Vivaldi",
          th: "พายุ - อันโตนิโอ วิวัลดี",
          es: "Tormenta - Antonio Vivaldi",
          cy: "Олуја – Антонио Вивалди",
        },
        preview: "https://cdn.mobio360.com/Music/Storm+-+Antonio+Vivaldi.png",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Music/Storm+-+Antonio+Vivaldi.mp4",
      },
      {
        duration: 21334,
        id: 802,
        name: {
          en: "Preludium C major - Johann Sebastian Bach",
          id: "Preludium C major - Johann Sebastian Bach",
          si: "Preludij C dur - Johann Sebastian Bach",
          pl: "Preludium C-dur – Johann Sebastian Bach",
          th: "พรีลูด C เมเจอร์ - โยฮันน์ เซบาสเตียน บาค",
          es: "Preludio en Do mayor - Johann Sebastian Bach",
          cy: "Прелудијум у Це-дуру – Јохан Себастијан Бах",
        },
        preview:
          "https://cdn.mobio360.com/Music/Preludium+C+major+-+Johann+Sebastian+Bach.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Music/Preludium+C+major+-+Johann+Sebastian+Bach.mp4",
      },
      {
        duration: 21334,
        id: 803,
        name: {
          en: "Bugatti Step - Jaroslav Ježek",
          id: "Bugatti Step - Jaroslav Ježek",
          si: "Bugatti korak - Jaroslav Ježek",
          pl: "Bugatti Step – Jaroslav Ježek",
          th: "บูกัตติ สเต็ป - ยาโรสลาฟ เยเช็ค",
          es: "Paso Bugatti - Jaroslav Ježek",
          cy: "Бугати степ – Јарослав Јежек",
        },
        preview:
          "https://cdn.mobio360.com/Music/Bugatti+Step+-+Jaroslav+Jez%CC%8Cek.png",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Music/Bugatti+Step+-+Jaroslav+Jez%CC%8Cek.mp4",
      },
    ],
  },*/
  {
    id: 1,
    contents: 18,
    categoryName: {
      en: "Travel",
      fr: "Voyage",
      de: "Reisen",
      be: "Reizen",
      tr: "Seyahat",
      pt: "Viagem",
      no: "Reise",
      cy: "Путовање",
      ee: "Reisimine",
      th: "ท่องเที่ยว",
      ar: "سفر",
      gr: "Ταξίδι",
      es: "Viajes",
      it: "Viaggio",
      id: "Perjalanan",
      si: "Potovanje",
      pl: "Podróże",
    },
    videos: [
      {
        duration: 279,
        id: 101,
        name: {
          en: "One Day in Bogota",
          fr: "Un jour à Bogotá",
          de: "Ein Tag in Bogotá",
          be: "Een dag in Bogota",
          tr: "Bogota'da Bir Gün",
          pt: "Um Dia em Bogotá",
          no: "En Dag i Bogotá",
          cy: "Један дан у Боготи",
          ee: "Üks päev Bogotás",
          th: "หนึ่งวันในโบโกตา",
          ar: "يوم واحد في بوغوتا",
          gr: "Μια μέρα στην Μπογκοτά",
          es: "Un día en Bogotá",
          it: "Un giorno a Bogotá",
          id: "Satu Hari di Bogota",
          si: "En dan v Bogoti",
          pl: "Jeden dzień w Bogocie",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Bogota.png",
        desc: {
          en: "Spend a day exploring Bogotá’s vibrant streets, landmarks, and rich cultural atmosphere.",
          fr: "Passez une journée à explorer les rues animées, les monuments et la riche atmosphère culturelle de Bogotá.",
          de: "Verbringen Sie einen Tag mit der Erkundung von Bogotás lebendigen Straßen, Sehenswürdigkeiten und reicher kultureller Atmosphäre.",
          be: "Breng een dag door met het verkennen van Bogotá's levendige straten, bezienswaardigheden en rijke culturele sfeer.",
          tr: "Bogotá'nın canlı sokaklarını, simge yapılarını ve zengin kültürel atmosferini keşfederek bir gün geçirin.",
          pt: "Passe um dia a explorar as ruas vibrantes, os monumentos e a rica atmosfera cultural de Bogotá.",
          no: "Tilbring en dag med å utforske Bogotás livlige gater, severdigheter og rike kulturelle atmosfære.",
          cy: "Проведите дан истражујући живописне улице Боготе, знаменитости и богату културну атмосферу.",
          ee: "Veetke päev Bogotá elava tänavaelu, vaatamisväärsuste ja rikkaliku kultuuriatmosfääriga tutvudes.",
          th: "ใช้เวลาหนึ่งวันสำรวจถนนที่มีชีวิตชีวา สถานที่สำคัญ และบรรยากาศทางวัฒนธรรมอันล้ำค่าของโบโกตา",
          ar: "اقضِ يومًا في استكشاف شوارع بوغوتا النابضة بالحياة ومعالمها وأجوائها الثقافية الغنية.",
          gr: "Περάστε μια μέρα εξερευνώντας τους ζωντανούς δρόμους, τα αξιοθέατα και τη πλούσια πολιτιστική ατμόσφαιρα της Μπογκοτά.",
          es: "Pasa un día explorando las vibrantes calles, monumentos y la rica atmósfera cultural de Bogotá.",
          it: "Trascorri una giornata esplorando le vivaci strade, i monumenti e la ricca atmosfera culturale di Bogotá.",
          id: "Habiskan sehari menjelajahi jalanan Bogotá yang semarak, landmark, dan suasana budayanya yang kaya.",
          si: "Preživite dan raziskujoč živahne ulice, znamenitosti in bogato kulturno vzdušje Bogote.",
          pl: "Spędź dzień na odkrywaniu tętniących życiem ulic Bogoty, jej zabytków i bogatej atmosfery kulturowej.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Travel/bagota.mp4",
      },
      {
        duration: 21334,
        id: 102,
        name: {
          en: "One Day in Bali",
          fr: "Un jour à Bali",
          de: "Ein Tag in Bali",
          be: "Een dag op Bali",
          tr: "Bali'de Bir Gün",
          pt: "Um Dia em Bali",
          no: "En Dag på Bali",
          cy: "Један дан на Балију",
          ee: "Üks päev Balil",
          th: "หนึ่งวันในบาหลี",
          ar: "يوم واحد في بالي",
          gr: "Μια μέρα στο Μπαλί",
          es: "Un día en Bali",
          it: "Un giorno a Bali",
          id: "Satu Hari di Bali",
          si: "En dan na Baliju",
          pl: "Jeden dzień na Bali",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Bali.png",
        desc: {
          en: "Experience a day in Bali, from its serene landscapes to its distinctive local culture.",
          fr: "Vivez une journée à Bali, entre paysages sereins et culture locale distinctive.",
          de: "Erleben Sie einen Tag auf Bali, von seinen ruhigen Landschaften bis zu seiner unverwechselbaren lokalen Kultur.",
          be: "Beleef een dag op Bali, van sereen landschap tot een kenmerkende lokale cultuur.",
          tr: "Bali'de huzurlu manzaralarından kendine özgü yerel kültürüne uzanan bir gün yaşayın.",
          pt: "Viva um dia em Bali, das suas paisagens serenas à sua cultura local distinta.",
          no: "Opplev en dag på Bali, fra dets fredelige landskap til dets særegne lokale kultur.",
          cy: "Доживите дан на Балију, од његових мирних пејзажа до препознатљиве локалне културе.",
          ee: "Kogege päeva Balil, alates rahulikest maastikest kuni omanäolise kohaliku kultuurini.",
          th: "สัมผัสหนึ่งวันในบาหลี ตั้งแต่ทิวทัศน์อันสงบไปจนถึงวัฒนธรรมท้องถิ่นที่โดดเด่น",
          ar: "عِش يومًا في بالي، من مناظرها الطبيعية الهادئة إلى ثقافتها المحلية المميزة.",
          gr: "Ζήστε μια μέρα στο Μπαλί, από τα γαλήνια τοπία του μέχρι τη μοναδική τοπική του κουλτούρα.",
          es: "Vive un día en Bali, desde sus paisajes serenos hasta su distintiva cultura local.",
          it: "Vivi una giornata a Bali, dai suoi paesaggi sereni alla sua distintiva cultura locale.",
          id: "Rasakan sehari di Bali, dari lanskapnya yang tenang hingga budaya lokalnya yang khas.",
          si: "Doživite dan na Baliju, od njegovih mirnih pokrajin do njegove prepoznavne lokalne kulture.",
          pl: "Przeżyj dzień na Bali, od spokojnych krajobrazów po charakterystyczną lokalną kulturę.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/bali.mp4",
      },
      {
        duration: 21334,
        id: 103,
        name: {
          en: "One Day in Bangkok",
          fr: "Un jour à Bangkok",
          de: "Ein Tag in Bangkok",
          be: "Een dag in Bangkok",
          tr: "Bangkok'ta Bir Gün",
          pt: "Um Dia em Bangkok",
          no: "En Dag i Bangkok",
          cy: "Један дан у Бангкоку",
          ee: "Üks päev Bangkokis",
          th: "หนึ่งวันในกรุงเทพฯ",
          ar: "يوم واحد في بانكوك",
          gr: "Μια μέρα στην Μπανγκόκ",
          es: "Un día en Bangkok",
          it: "Un giorno a Bangkok",
          id: "Satu Hari di Bangkok",
          si: "En dan v Bangkoku",
          pl: "Jeden dzień w Bangkoku",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+Bangkok.png",
        desc: {
          en: "Discover Bangkok’s lively streets, famous sights, and energetic city atmosphere in one immersive journey.",
          fr: "Découvrez les rues animées, les sites célèbres et l'atmosphère énergique de Bangkok en un voyage immersif.",
          de: "Entdecken Sie Bangkoks lebendige Straßen, berühmte Sehenswürdigkeiten und energiegeladene Stadtatmosphäre auf einer eindrucksvollen Reise.",
          be: "Ontdek Bangkoks levendige straten, beroemde bezienswaardigheden en energieke stadssfeer tijdens een meeslepende reis.",
          tr: "Bangkok'un hareketli sokaklarını, ünlü mekanlarını ve enerjik şehir atmosferini tek bir yolculukta keşfedin.",
          pt: "Descubra as ruas animadas de Bangkok, os locais famosos e a atmosfera energética da cidade numa viagem envolvente.",
          no: "Oppdag Bangkoks livlige gater, kjente severdigheter og energiske byatmosfære på én oppslukende reise.",
          cy: "Откријте живописне улице Бангкока, познате знаменитости и енергичну градску атмосферу у једном узбудљивом путовању.",
          ee: "Avastage Bangkoki elavaid tänavaid, kuulsaid vaatamisväärsusi ja energilist linnaatmosfääri ühel kaasahaaraval teekonnal.",
          th: "ค้นพบถนนที่คึกคักของกรุงเทพฯ สถานที่ท่องเที่ยวชื่อดัง และบรรยากาศเมืองที่เต็มไปด้วยพลังในการเดินทางครั้งเดียว",
          ar: "اكتشف شوارع بانكوك النابضة بالحياة ومعالمها الشهيرة وأجواءها المفعمة بالطاقة في رحلة غامرة واحدة.",
          gr: "Ανακαλύψτε τους ζωντανούς δρόμους, τα διάσημα αξιοθέατα και την ενεργητική ατμόσφαιρα της Μπανγκόκ σε ένα συναρπαστικό ταξίδι.",
          es: "Descubre las animadas calles de Bangkok, sus lugares famosos y su enérgica atmósfera urbana en un viaje inmersivo.",
          it: "Scopri le vivaci strade di Bangkok, i luoghi famosi e l'energica atmosfera cittadina in un viaggio coinvolgente.",
          id: "Temukan jalanan Bangkok yang ramai, tempat-tempat terkenal, dan suasana kota yang energik dalam satu perjalanan yang mendalam.",
          si: "Odkrijte živahne ulice Bangkoka, znane znamenitosti in energično mestno vzdušje na enem doživetju.",
          pl: "Odkryj tętniące życiem ulice Bangkoku, słynne miejsca i energiczną atmosferę miasta w jednej wciągającej podróży.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/bangkok.mp4",
      },
      {
        duration: 21334,
        id: 104,
        name: {
          en: "One Day in Cairo",
          fr: "Un jour au Caire",
          de: "Ein Tag in Kairo",
          be: "Een dag in Caïro",
          tr: "Kahire'de Bir Gün",
          pt: "Um Dia no Cairo",
          no: "En Dag i Kairo",
          cy: "Један дан у Каиру",
          ee: "Üks päev Kairos",
          th: "หนึ่งวันในไคโร",
          ar: "يوم واحد في القاهرة",
          gr: "Μια μέρα στο Κάιρο",
          es: "Un día en El Cairo",
          it: "Un giorno al Cairo",
          id: "Satu Hari di Kairo",
          si: "En dan v Kairu",
          pl: "Jeden dzień w Kairze",
        },
        preview: "https://cdn.mobio360.com/City+Tour/One+Day+in+Cairo.png",
        desc: {
          en: "Explore Cairo’s historic landmarks, bustling streets, and timeless character over the course of a day.",
          fr: "Explorez les monuments historiques, les rues animées et le caractère intemporel du Caire le temps d'une journée.",
          de: "Erkunden Sie Kairos historische Sehenswürdigkeiten, geschäftige Straßen und zeitlosen Charakter im Laufe eines Tages.",
          be: "Verken Caïro's historische bezienswaardigheden, drukke straten en tijdloze karakter gedurende één dag.",
          tr: "Kahire'nin tarihi simge yapılarını, hareketli sokaklarını ve zamansız karakterini bir gün boyunca keşfedin.",
          pt: "Explore os monumentos históricos do Cairo, as ruas movimentadas e o seu caráter atemporal ao longo de um dia.",
          no: "Utforsk Kairos historiske severdigheter, travle gater og tidløse karakter i løpet av en dag.",
          cy: "Истражите историјске знаменитости Каира, ужурбане улице и безвременски карактер током једног дана.",
          ee: "Uurige Kairo ajaloolisi vaatamisväärsusi, elavaid tänavaid ja ajatut iseloomu ühe päeva jooksul.",
          th: "สำรวจสถานที่สำคัญทางประวัติศาสตร์ของไคโร ถนนที่คึกคัก และเอกลักษณ์อันเหนือกาลเวลาตลอดทั้งวัน",
          ar: "استكشف معالم القاهرة التاريخية وشوارعها الصاخبة وطابعها الخالد على مدار يوم كامل.",
          gr: "Εξερευνήστε τα ιστορικά αξιοθέατα, τους πολυσύχναστους δρόμους και τον διαχρονικό χαρακτήρα του Καΐρου μέσα σε μια μέρα.",
          es: "Explora los monumentos históricos de El Cairo, sus bulliciosas calles y su carácter atemporal a lo largo de un día.",
          it: "Esplora i monumenti storici del Cairo, le strade movimentate e il suo carattere senza tempo nell'arco di una giornata.",
          id: "Jelajahi landmark bersejarah Kairo, jalanan yang ramai, dan karakternya yang abadi sepanjang hari.",
          si: "Raziščite zgodovinske znamenitosti Kaira, vrvljive ulice in brezčasni značaj v enem dnevu.",
          pl: "Poznaj historyczne zabytki Kairu, gwarne ulice i ponadczasowy charakter w ciągu jednego dnia.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Travel/cairo.mp4",
      },
      {
        duration: 21334,
        id: 105,
        name: {
          en: "One Day in Congo",
          fr: "Un jour au Congo",
          de: "Ein Tag im Kongo",
          be: "Een dag in Congo",
          tr: "Kongo'da Bir Gün",
          pt: "Um Dia no Congo",
          no: "En Dag i Kongo",
          cy: "Један дан у Конгу",
          ee: "Üks päev Kongos",
          th: "หนึ่งวันในคองโก",
          ar: "يوم واحد في الكونغو",
          gr: "Μια μέρα στο Κονγκό",
          es: "Un día en el Congo",
          it: "Un giorno in Congo",
          id: "Satu Hari di Kongo",
          si: "En dan v Kongu",
          pl: "Jeden dzień w Kongu",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/One+Day+in+the+Republic+of+Congo.png",
        desc: {
          en: "Journey through the Congo and experience its remarkable landscapes, wildlife, and natural beauty.",
          fr: "Voyagez à travers le Congo et découvrez ses paysages remarquables, sa faune et sa beauté naturelle.",
          de: "Reisen Sie durch den Kongo und erleben Sie seine bemerkenswerten Landschaften, seine Tierwelt und seine natürliche Schönheit.",
          be: "Reis door Congo en beleef de opmerkelijke landschappen, wilde dieren en natuurlijke schoonheid.",
          tr: "Kongo'da yolculuk edin ve olağanüstü manzaralarını, vahşi yaşamını ve doğal güzelliğini deneyimleyin.",
          pt: "Viaje pelo Congo e viva as suas paisagens notáveis, a vida selvagem e a beleza natural.",
          no: "Reis gjennom Kongo og opplev dets bemerkelsesverdige landskap, dyreliv og naturskjønnhet.",
          cy: "Путујте кроз Конго и доживите његове изузетне пејзаже, дивље животиње и природну лепоту.",
          ee: "Reisige läbi Kongo ja kogege selle märkimisväärseid maastikke, loomastikku ja loodusilu.",
          th: "เดินทางผ่านคองโกและสัมผัสทิวทัศน์อันน่าทึ่ง สัตว์ป่า และความงามตามธรรมชาติ",
          ar: "سافر عبر الكونغو واختبر مناظرها الطبيعية الرائعة وحياتها البرية وجمالها الطبيعي.",
          gr: "Ταξιδέψτε στο Κονγκό και ζήστε τα εντυπωσιακά τοπία, την άγρια ζωή και τη φυσική ομορφιά του.",
          es: "Viaja por el Congo y vive sus notables paisajes, fauna y belleza natural.",
          it: "Viaggia attraverso il Congo e vivi i suoi straordinari paesaggi, la fauna selvatica e la bellezza naturale.",
          id: "Jelajahi Kongo dan rasakan lanskapnya yang luar biasa, satwa liar, dan keindahan alamnya.",
          si: "Potujte skozi Kongo in doživite njegove izjemne pokrajine, divje živali in naravno lepoto.",
          pl: "Podróżuj przez Kongo i doświadcz jego niezwykłych krajobrazów, dzikiej przyrody i naturalnego piękna.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/congo.mp4",
      },
      {
        duration: 21335,
        id: 106,
        name: {
          en: "One Day in Ecuador",
          fr: "Un jour en Équateur",
          de: "Ein Tag in Ecuador",
          be: "Een dag in Ecuador",
          tr: "Ekvador'da Bir Gün",
          pt: "Um Dia no Equador",
          no: "En Dag i Ecuador",
          cy: "Један дан у Еквадору",
          ee: "Üks päev Ecuadoris",
          th: "หนึ่งวันในเอกวาดอร์",
          ar: "يوم واحد في الإكوادور",
          gr: "Μια μέρα στον Ισημερινό",
          es: "Un día en Ecuador",
          it: "Un giorno in Ecuador",
          id: "Satu Hari di Ekuador",
          si: "En dan v Ekvadorju",
          pl: "Jeden dzień w Ekwadorze",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Ecuador%E2%80%99s+Shoreline.png",
        desc: {
          en: "Discover Ecuador’s diverse scenery, local culture, and memorable destinations in a single day.",
          fr: "Découvrez les paysages variés, la culture locale et les destinations mémorables de l'Équateur en une seule journée.",
          de: "Entdecken Sie Ecuadors vielfältige Landschaften, lokale Kultur und unvergessliche Orte an einem einzigen Tag.",
          be: "Ontdek Ecuadors gevarieerde landschap, lokale cultuur en gedenkwaardige bestemmingen op één dag.",
          tr: "Ekvador'un çeşitli manzaralarını, yerel kültürünü ve unutulmaz destinasyonlarını tek bir günde keşfedin.",
          pt: "Descubra a paisagem diversa, a cultura local e os destinos memoráveis do Equador num só dia.",
          no: "Oppdag Ecuadors mangfoldige natur, lokale kultur og minneverdige reisemål på én dag.",
          cy: "Откријте разноврсне пределе, локалну културу и незаборавне дестинације Еквадора за само један дан.",
          ee: "Avastage Ecuadori mitmekesist loodust, kohalikku kultuuri ja meeldejäävaid sihtkohti ühe päevaga.",
          th: "ค้นพบทิวทัศน์อันหลากหลาย วัฒนธรรมท้องถิ่น และจุดหมายปลายทางที่น่าจดจำของเอกวาดอร์ในวันเดียว",
          ar: "اكتشف تنوع مناظر الإكوادور الطبيعية وثقافتها المحلية ووجهاتها التي لا تُنسى في يوم واحد.",
          gr: "Ανακαλύψτε τα ποικίλα τοπία, την τοπική κουλτούρα και τους αξέχαστους προορισμούς του Ισημερινού σε μία μόνο μέρα.",
          es: "Descubre los diversos paisajes, la cultura local y los destinos memorables de Ecuador en un solo día.",
          it: "Scopri i paesaggi variegati, la cultura locale e le destinazioni memorabili dell'Ecuador in un solo giorno.",
          id: "Temukan beragam pemandangan, budaya lokal, dan destinasi tak terlupakan di Ekuador dalam satu hari.",
          si: "Odkrijte raznoliko pokrajino, lokalno kulturo in nepozabne destinacije Ekvadorja v enem dnevu.",
          pl: "Odkryj zróżnicowane krajobrazy, lokalną kulturę i niezapomniane miejsca Ekwadoru w ciągu jednego dnia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/ecuador.mp4",
      },
      {
        duration: 21336,
        id: 107,
        name: {
          en: "One Day in Galway",
          fr: "Un jour à Galway",
          de: "Ein Tag in Galway",
          be: "Een dag in Galway",
          tr: "Galway'de Bir Gün",
          pt: "Um Dia em Galway",
          no: "En Dag i Galway",
          cy: "Један дан у Голвеју",
          ee: "Üks päev Galways",
          th: "หนึ่งวันในกัลเวย์",
          ar: "يوم واحد في غالواي",
          gr: "Μια μέρα στο Γκόλγουεϊ",
          es: "Un día en Galway",
          it: "Un giorno a Galway",
          id: "Satu Hari di Galway",
          si: "En dan v Galwayju",
          pl: "Jeden dzień w Galway",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Galway+_+Cliffs+of+Moher-001.png",
        desc: {
          en: "Spend a day exploring Galway’s colourful streets, coastal charm, and welcoming Irish atmosphere.",
          fr: "Passez une journée à explorer les rues colorées de Galway, son charme côtier et son ambiance irlandaise accueillante.",
          de: "Verbringen Sie einen Tag mit der Erkundung von Galways bunten Straßen, dem Küstencharme und der einladenden irischen Atmosphäre.",
          be: "Breng een dag door met het verkennen van Galways kleurrijke straten, kustcharme en gastvrije Ierse sfeer.",
          tr: "Galway'in renkli sokaklarını, sahil çekiciliğini ve sıcak İrlanda atmosferini keşfederek bir gün geçirin.",
          pt: "Passe um dia a explorar as ruas coloridas de Galway, o charme costeiro e a acolhedora atmosfera irlandesa.",
          no: "Tilbring en dag med å utforske Galways fargerike gater, kystsjarm og imøtekommende irske atmosfære.",
          cy: "Проведите дан истражујући шарене улице Голвеја, обалски шарм и гостољубиву ирску атмосферу.",
          ee: "Veetke päev Galway värviküllaste tänavate, ranniku võlu ja sõbraliku Iiri atmosfääriga tutvudes.",
          th: "ใช้เวลาหนึ่งวันสำรวจถนนสีสันสดใสของกัลเวย์ เสน่ห์ชายฝั่ง และบรรยากาศไอริชที่อบอุ่น",
          ar: "اقضِ يومًا في استكشاف شوارع غالواي الملونة وسحرها الساحلي وأجوائها الأيرلندية الترحيبية.",
          gr: "Περάστε μια μέρα εξερευνώντας τους πολύχρωμους δρόμους του Γκόλγουεϊ, τη παράκτια γοητεία και τη φιλόξενη ιρλανδική ατμόσφαιρα.",
          es: "Pasa un día explorando las coloridas calles de Galway, su encanto costero y su acogedora atmósfera irlandesa.",
          it: "Trascorri una giornata esplorando le strade colorate di Galway, il suo fascino costiero e l'accogliente atmosfera irlandese.",
          id: "Habiskan sehari menjelajahi jalanan Galway yang penuh warna, pesona pesisirnya, dan suasana Irlandia yang hangat.",
          si: "Preživite dan raziskujoč barvite ulice Galwaya, obalni šarm in gostoljubno irsko vzdušje.",
          pl: "Spędź dzień na odkrywaniu kolorowych ulic Galway, nadmorskiego uroku i przyjaznej irlandzkiej atmosfery.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/galway.mp4",
      },
      {
        duration: 21336,
        id: 108,
        name: {
          en: "One Day in Iceland",
          fr: "Un jour en Islande",
          de: "Ein Tag in Island",
          be: "Een dag op IJsland",
          tr: "İzlanda'da Bir Gün",
          pt: "Um Dia na Islândia",
          no: "En Dag på Island",
          cy: "Један дан на Исланду",
          ee: "Üks päev Islandil",
          th: "หนึ่งวันในไอซ์แลนด์",
          ar: "يوم واحد في آيسلندا",
          gr: "Μια μέρα στην Ισλανδία",
          es: "Un día en Islandia",
          it: "Un giorno in Islanda",
          id: "Satu Hari di Islandia",
          si: "En dan na Islandiji",
          pl: "Jeden dzień w Islandii",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Iceland.png",
        desc: {
          en: "Experience Iceland’s dramatic landscapes, natural wonders, and otherworldly beauty in an unforgettable day.",
          fr: "Vivez les paysages spectaculaires, les merveilles naturelles et la beauté hors du commun de l'Islande en une journée inoubliable.",
          de: "Erleben Sie Islands dramatische Landschaften, Naturwunder und außergewöhnliche Schönheit an einem unvergesslichen Tag.",
          be: "Beleef IJslands indrukwekkende landschappen, natuurwonderen en buitengewone schoonheid tijdens een onvergetelijke dag.",
          tr: "İzlanda'nın çarpıcı manzaralarını, doğal harikalarını ve olağanüstü güzelliğini unutulmaz bir günde yaşayın.",
          pt: "Viva as paisagens dramáticas, as maravilhas naturais e a beleza extraordinária da Islândia num dia inesquecível.",
          no: "Opplev Islands dramatiske landskap, naturunder og enestående skjønnhet på en uforglemmelig dag.",
          cy: "Доживите драматичне пределе, природна чуда и изузетну лепоту Исланда током незаборавног дана.",
          ee: "Kogege Islandi dramaatilisi maastikke, looduse imesid ja erakordset ilu unustamatul päeval.",
          th: "สัมผัสทิวทัศน์อันตระการตา สิ่งมหัศจรรย์ทางธรรมชาติ และความงามพิเศษของไอซ์แลนด์ในวันที่น่าจดจำ",
          ar: "عِش المناظر الطبيعية المذهلة وعجائب الطبيعة والجمال الخارق في آيسلندا خلال يوم لا يُنسى.",
          gr: "Ζήστε τα εντυπωσιακά τοπία, τα φυσικά θαύματα και την ξεχωριστή ομορφιά της Ισλανδίας σε μια αξέχαστη μέρα.",
          es: "Vive los paisajes dramáticos, las maravillas naturales y la belleza extraordinaria de Islandia en un día inolvidable.",
          it: "Vivi i paesaggi drammatici, le meraviglie naturali e la straordinaria bellezza dell'Islanda in una giornata indimenticabile.",
          id: "Rasakan lanskap dramatis, keajaiban alam, dan keindahan luar biasa Islandia dalam sehari yang tak terlupakan.",
          si: "Doživite dramatične pokrajine, naravna čudesa in izjemno lepoto Islandije na nepozaben dan.",
          pl: "Przeżyj dramatyczne krajobrazy, cuda natury i niezwykłe piękno Islandii w niezapomniany dzień.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/iceland.mp4",
      },
      {
        duration: 21336,
        id: 109,
        name: {
          en: "One Day in Jerusalem",
          fr: "Un jour à Jérusalem",
          de: "Ein Tag in Jerusalem",
          be: "Een dag in Jeruzalem",
          tr: "Kudüs'te Bir Gün",
          pt: "Um Dia em Jerusalém",
          no: "En Dag i Jerusalem",
          cy: "Један дан у Јерусалиму",
          ee: "Üks päev Jeruusalemmas",
          th: "หนึ่งวันในเยรูซาเล็ม",
          ar: "يوم واحد في القدس",
          gr: "Μια μέρα στην Ιερουσαλήμ",
          es: "Un día en Jerusalén",
          it: "Un giorno a Gerusalemme",
          id: "Satu Hari di Yerusalem",
          si: "En dan v Jeruzalemu",
          pl: "Jeden dzień w Jerozolimie",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+Jerusalem.png",
        desc: {
          en: "Explore Jerusalem’s ancient landmarks, vibrant streets, and rich layers of history and culture.",
          fr: "Explorez les monuments antiques, les rues animées et les riches couches d'histoire et de culture de Jérusalem.",
          de: "Erkunden Sie Jerusalems antike Sehenswürdigkeiten, lebendige Straßen und reichen Schichten von Geschichte und Kultur.",
          be: "Verken Jeruzalems oude bezienswaardigheden, levendige straten en rijke lagen van geschiedenis en cultuur.",
          tr: "Kudüs'ün antik simge yapılarını, canlı sokaklarını ve zengin tarih ve kültür katmanlarını keşfedin.",
          pt: "Explore os monumentos antigos de Jerusalém, as ruas vibrantes e as ricas camadas de história e cultura.",
          no: "Utforsk Jerusalems eldgamle severdigheter, livlige gater og rike lag av historie og kultur.",
          cy: "Истражите древне знаменитости Јерусалима, живописне улице и богате слојеве историје и културе.",
          ee: "Uurige Jeruusalemma iidseid vaatamisväärsusi, elavaid tänavaid ning rikkalikke ajaloo- ja kultuurikihte.",
          th: "สำรวจสถานที่สำคัญโบราณของเยรูซาเล็ม ถนนที่มีชีวิตชีวา และชั้นเชิงประวัติศาสตร์และวัฒนธรรมอันล้ำค่า",
          ar: "استكشف معالم القدس القديمة وشوارعها النابضة بالحياة وطبقاتها الغنية من التاريخ والثقافة.",
          gr: "Εξερευνήστε τα αρχαία αξιοθέατα, τους ζωντανούς δρόμους και τα πλούσια στρώματα ιστορίας και κουλτούρας της Ιερουσαλήμ.",
          es: "Explora los monumentos antiguos, las calles vibrantes y las ricas capas de historia y cultura de Jerusalén.",
          it: "Esplora gli antichi monumenti di Gerusalemme, le strade vivaci e i ricchi strati di storia e cultura.",
          id: "Jelajahi landmark kuno Yerusalem, jalanan yang semarak, dan lapisan sejarah serta budaya yang kaya.",
          si: "Raziščite starodavne znamenitosti Jeruzalema, živahne ulice in bogate plasti zgodovine in kulture.",
          pl: "Poznaj starożytne zabytki Jerozolimy, tętniące życiem ulice i bogate warstwy historii i kultury.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/jerusalem.mp4",
      },
      {
        duration: 21336,
        id: 110,
        name: {
          en: "One Day in London",
          fr: "Un jour à Londres",
          de: "Ein Tag in London",
          be: "Een dag in Londen",
          tr: "Londra'da Bir Gün",
          pt: "Um Dia em Londres",
          no: "En Dag i London",
          cy: "Један дан у Лондону",
          ee: "Üks päev Londonis",
          th: "หนึ่งวันในลอนดอน",
          ar: "يوم واحد في لندن",
          gr: "Μια μέρα στο Λονδίνο",
          es: "Un día en Londres",
          it: "Un giorno a Londra",
          id: "Satu Hari di London",
          si: "En dan v Londonu",
          pl: "Jeden dzień w Londynie",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+London.png",
        desc: {
          en: "Take in London’s iconic sights, lively neighbourhoods, and unmistakable city atmosphere in one day.",
          fr: "Découvrez les sites emblématiques, les quartiers animés et l'atmosphère unique de Londres en une journée.",
          de: "Erleben Sie Londons ikonische Sehenswürdigkeiten, lebendige Viertel und unverwechselbare Stadtatmosphäre an einem Tag.",
          be: "Neem Londens iconische bezienswaardigheden, levendige buurten en onmiskenbare stadssfeer in je op tijdens één dag.",
          tr: "Londra'nın ikonik manzaralarını, hareketli mahallelerini ve eşsiz şehir atmosferini bir günde deneyimleyin.",
          pt: "Aprecie os pontos turísticos icónicos, os bairros animados e a inconfundível atmosfera de Londres num dia.",
          no: "Ta inn Londons ikoniske severdigheter, livlige bydeler og unike byatmosfære på én dag.",
          cy: "Уживајте у препознатљивим знаменитостима, живим четвртима и јединственој атмосфери Лондона за један дан.",
          ee: "Nautige Londoni kultuslikke vaatamisväärsusi, elavaid linnaosi ja äratuntavat linnaatmosfääri ühel päeval.",
          th: "ดื่มด่ำกับสถานที่สำคัญอันเป็นสัญลักษณ์ ย่านที่มีชีวิตชีวา และบรรยากาศเมืองที่ไม่เหมือนใครของลอนดอนในวันเดียว",
          ar: "استمتع بمعالم لندن الشهيرة وأحيائها الحيوية وأجوائها المدينية المميزة في يوم واحد.",
          gr: "Απολαύστε τα εμβληματικά αξιοθέατα, τις ζωντανές γειτονιές και τη ξεχωριστή ατμόσφαιρα του Λονδίνου σε μία μέρα.",
          es: "Disfruta de los lugares emblemáticos, los animados barrios y la inconfundible atmósfera de Londres en un día.",
          it: "Ammira i luoghi iconici, i vivaci quartieri e l'inconfondibile atmosfera di Londra in una giornata.",
          id: "Nikmati landmark ikonik, lingkungan yang ramai, dan suasana kota London yang khas dalam satu hari.",
          si: "Uživajte v prepoznavnih znamenitostih, živahnih soseskah in edinstvenem vzdušju Londona v enem dnevu.",
          pl: "Poznaj kultowe zabytki, tętniące życiem dzielnice i niepowtarzalną atmosferę Londynu w ciągu jednego dnia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/london.mp4",
      },
      {
        duration: 21336,
        id: 111,
        name: {
          en: "One Day in Madeira",
          fr: "Un jour à Madère",
          de: "Ein Tag auf Madeira",
          be: "Een dag op Madeira",
          tr: "Madeira'da Bir Gün",
          pt: "Um Dia na Madeira",
          no: "En Dag på Madeira",
          cy: "Један дан на Мадеири",
          ee: "Üks päev Madeiral",
          th: "หนึ่งวันในมาเดรา",
          ar: "يوم واحد في ماديرا",
          gr: "Μια μέρα στη Μαδέιρα",
          es: "Un día en Madeira",
          it: "Un giorno a Madeira",
          id: "Satu Hari di Madeira",
          si: "En dan na Madeiri",
          pl: "Jeden dzień na Maderze",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Madeira%2C+Portugal-003.png",
        desc: {
          en: "Discover Madeira’s lush landscapes, dramatic coastline, and relaxed island charm in a day.",
          fr: "Découvrez les paysages luxuriants, le littoral spectaculaire et le charme insulaire de Madère en une journée.",
          de: "Entdecken Sie Madeiras üppige Landschaften, dramatische Küste und entspannten Inselcharme an einem Tag.",
          be: "Ontdek Madeira's weelderige landschap, dramatische kustlijn en ontspannen eilandsfeer op één dag.",
          tr: "Madeira'nın yemyeşil manzaralarını, çarpıcı kıyı şeridini ve rahat ada çekiciliğini bir günde keşfedin.",
          pt: "Descubra as paisagens exuberantes, a costa dramática e o charme relaxante da ilha da Madeira num dia.",
          no: "Oppdag Madeiras frodige landskap, dramatiske kystlinje og avslappede øycharme på én dag.",
          cy: "Откријте бујне пределе, драматичну обалу и опуштен шарм острва Мадеире за један дан.",
          ee: "Avastage Madeira lopsakat loodust, dramaatilist rannikut ja lõõgastavat saarevõlu ühe päevaga.",
          th: "ค้นพบทิวทัศน์อันเขียวชอุ่ม ชายฝั่งอันตระการตา และเสน่ห์เกาะที่ผ่อนคลายของมาเดราในวันเดียว",
          ar: "اكتشف مناظر ماديرا الخصبة وساحلها المذهل وسحرها الجزري الهادئ في يوم واحد.",
          gr: "Ανακαλύψτε τα καταπράσινα τοπία, την εντυπωσιακή ακτογραμμή και τη χαλαρή νησιωτική γοητεία της Μαδέιρα σε μία μέρα.",
          es: "Descubre los exuberantes paisajes, la impresionante costa y el relajado encanto insular de Madeira en un día.",
          it: "Scopri i paesaggi rigogliosi, la costa spettacolare e il rilassante fascino insulare di Madeira in una giornata.",
          id: "Temukan lanskap Madeira yang subur, garis pantai yang dramatis, dan pesona pulau yang menenangkan dalam satu hari.",
          si: "Odkrijte bujno pokrajino, dramatično obalo in sproščen otoški šarm Madeire v enem dnevu.",
          pl: "Odkryj bujne krajobrazy, dramatyczną linię brzegową i relaksujący urok wyspy Madery w ciągu jednego dnia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/madeira.mp4",
      },
      {
        duration: 21336,
        id: 112,
        name: {
          en: "One Day in Malta",
          fr: "Un jour à Malte",
          de: "Ein Tag auf Malta",
          be: "Een dag op Malta",
          tr: "Malta'da Bir Gün",
          pt: "Um Dia em Malta",
          no: "En Dag på Malta",
          cy: "Један дан на Малти",
          ee: "Üks päev Maltal",
          th: "หนึ่งวันในมอลตา",
          ar: "يوم واحد في مالطا",
          gr: "Μια μέρα στη Μάλτα",
          es: "Un día en Malta",
          it: "Un giorno a Malta",
          id: "Satu Hari di Malta",
          si: "En dan na Malti",
          pl: "Jeden dzień na Malcie",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Malta%E2%80%99s+Beaches.png",
        desc: {
          en: "Experience Malta’s historic streets, Mediterranean scenery, and distinctive island culture in one day.",
          fr: "Vivez les rues historiques, les paysages méditerranéens et la culture insulaire distinctive de Malte en une journée.",
          de: "Erleben Sie Maltas historische Straßen, mediterrane Landschaften und unverwechselbare Inselkultur an einem Tag.",
          be: "Beleef Malta's historische straten, mediterraan landschap en kenmerkende eilandcultuur op één dag.",
          tr: "Malta'nın tarihi sokaklarını, Akdeniz manzarasını ve kendine özgü ada kültürünü bir günde yaşayın.",
          pt: "Viva as ruas históricas, a paisagem mediterrânica e a cultura insular distinta de Malta num dia.",
          no: "Opplev Maltas historiske gater, middelhavsnatur og særegne øykultur på én dag.",
          cy: "Доживите историјске улице, медитерански пејзаж и препознатљиву острвску културу Малте за један дан.",
          ee: "Kogege Malta ajaloolisi tänavaid, Vahemere maastikku ja omanäolist saarekultuuri ühe päevaga.",
          th: "สัมผัสถนนประวัติศาสตร์ ทิวทัศน์เมดิเตอร์เรเนียน และวัฒนธรรมเกาะอันโดดเด่นของมอลตาในวันเดียว",
          ar: "عِش شوارع مالطا التاريخية ومناظرها المتوسطية وثقافتها الجزرية المميزة في يوم واحد.",
          gr: "Ζήστε τους ιστορικούς δρόμους, το μεσογειακό τοπίο και τη ξεχωριστή νησιωτική κουλτούρα της Μάλτας σε μία μέρα.",
          es: "Vive las calles históricas, el paisaje mediterráneo y la distintiva cultura insular de Malta en un día.",
          it: "Vivi le strade storiche, il paesaggio mediterraneo e la distintiva cultura insulare di Malta in una giornata.",
          id: "Rasakan jalanan bersejarah, pemandangan Mediterania, dan budaya pulau khas Malta dalam satu hari.",
          si: "Doživite zgodovinske ulice, sredozemsko pokrajino in prepoznavno otoško kulturo Malte v enem dnevu.",
          pl: "Przeżyj historyczne ulice, śródziemnomorski krajobraz i charakterystyczną kulturę wyspiarską Malty w ciągu jednego dnia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/malta.mp4",
      },
      {
        duration: 21336,
        id: 113,
        name: {
          en: "One Day in Marrakech",
          fr: "Un jour à Marrakech",
          de: "Ein Tag in Marrakesch",
          be: "Een dag in Marrakech",
          tr: "Marakeş'te Bir Gün",
          pt: "Um Dia em Marraquexe",
          no: "En Dag i Marrakech",
          cy: "Један дан у Маракешу",
          ee: "Üks päev Marrakechis",
          th: "หนึ่งวันในมาร์ราเกช",
          ar: "يوم واحد في مراكش",
          gr: "Μια μέρα στο Μαρακές",
          es: "Un día en Marrakech",
          it: "Un giorno a Marrakech",
          id: "Satu Hari di Marrakesh",
          si: "En dan v Marakešu",
          pl: "Jeden dzień w Marrakeszu",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+Marrakech.png",
        desc: {
          en: "Wander through Marrakech’s colourful markets, historic streets, and captivating Moroccan atmosphere.",
          fr: "Flânez dans les marchés colorés, les rues historiques et l'atmosphère envoûtante de Marrakech.",
          de: "Schlendern Sie durch Marrakeschs bunte Märkte, historische Straßen und faszinierende marokkanische Atmosphäre.",
          be: "Dwaal door Marrakechs kleurrijke markten, historische straten en betoverende Marokkaanse sfeer.",
          tr: "Marakeş'in renkli pazarlarında, tarihi sokaklarında ve büyüleyici Fas atmosferinde dolaşın.",
          pt: "Passeie pelos mercados coloridos, ruas históricas e cativante atmosfera marroquina de Marraquexe.",
          no: "Vandre gjennom Marrakechs fargerike markeder, historiske gater og fengslende marokkanske atmosfære.",
          cy: "Прошетајте шареним пијацама, историјским улицама и очаравајућом мароканском атмосфером Маракеша.",
          ee: "Ekslege Marrakechi värvikirevatel turgudel, ajaloolistel tänavatel ja köitvas Maroko atmosfääris.",
          th: "เดินเล่นท่ามกลางตลาดสีสันสดใส ถนนประวัติศาสตร์ และบรรยากาศโมร็อกโกอันน่าหลงใหลของมาร์ราเกช",
          ar: "تجوّل بين أسواق مراكش الملونة وشوارعها التاريخية وأجوائها المغربية الساحرة.",
          gr: "Περιπλανηθείτε στις πολύχρωμες αγορές, τους ιστορικούς δρόμους και τη γοητευτική μαροκινή ατμόσφαιρα του Μαρακές.",
          es: "Recorre los coloridos mercados, las calles históricas y la cautivadora atmósfera marroquí de Marrakech.",
          it: "Passeggia tra i mercati colorati, le strade storiche e l'affascinante atmosfera marocchina di Marrakech.",
          id: "Jelajahi pasar-pasar berwarna-warni, jalanan bersejarah, dan suasana Maroko yang memikat di Marrakech.",
          si: "Sprehodite se po barvitih tržnicah, zgodovinskih ulicah in očarljivem marokanskem vzdušju Marakeša.",
          pl: "Spaceruj po kolorowych targowiskach, historycznych ulicach i urzekającej marokańskiej atmosferze Marrakeszu.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/marrakech.mp4",
      },
      {
        duration: 21336,
        id: 114,
        name: {
          en: "One Day in NYC",
          fr: "Un jour à New York",
          de: "Ein Tag in New York",
          be: "Een dag in New York",
          tr: "New York'ta Bir Gün",
          pt: "Um Dia em Nova York",
          no: "En Dag i New York",
          cy: "Један дан у Њујорку",
          ee: "Üks päev New Yorgis",
          th: "หนึ่งวันในนิวยอร์ก",
          ar: "يوم واحد في نيويورك",
          gr: "Μια μέρα στη Νέα Υόρκη",
          es: "Un día en Nueva York",
          it: "Un giorno a New York",
          id: "Satu Hari di New York",
          si: "En dan v New Yorku",
          pl: "Jeden dzień w Nowym Jorku",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+New+York+City.png",
        desc: {
          en: "Spend a day discovering New York City’s iconic landmarks, energetic streets, and unforgettable skyline.",
          fr: "Passez une journée à découvrir les monuments emblématiques, les rues animées et le panorama inoubliable de New York.",
          de: "Verbringen Sie einen Tag mit der Entdeckung von New Yorks ikonischen Sehenswürdigkeiten, energiegeladenen Straßen und unvergesslicher Skyline.",
          be: "Breng een dag door met het ontdekken van New Yorks iconische bezienswaardigheden, energieke straten en onvergetelijke skyline.",
          tr: "New York'un ikonik simge yapılarını, enerjik sokaklarını ve unutulmaz silüetini keşfederek bir gün geçirin.",
          pt: "Passe um dia a descobrir os pontos turísticos icónicos, as ruas energéticas e o horizonte inesquecível de Nova York.",
          no: "Tilbring en dag med å oppdage New Yorks ikoniske severdigheter, energiske gater og uforglemmelige skyline.",
          cy: "Проведите дан откривајући препознатљиве знаменитости Њујорка, енергичне улице и незаборавну панораму града.",
          ee: "Veetke päev New Yorgi kultuslike vaatamisväärsuste, energiliste tänavate ja unustamatu linnasiluetiga tutvudes.",
          th: "ใช้เวลาหนึ่งวันค้นพบสถานที่สำคัญอันเป็นสัญลักษณ์ของนิวยอร์ก ถนนที่เต็มไปด้วยพลัง และเส้นขอบฟ้าที่น่าจดจำ",
          ar: "اقضِ يومًا في اكتشاف معالم نيويورك الشهيرة وشوارعها النابضة بالحياة وأفقها الذي لا يُنسى.",
          gr: "Περάστε μια μέρα ανακαλύπτοντας τα εμβληματικά αξιοθέατα, τους ενεργητικούς δρόμους και τον αξέχαστο ορίζοντα της Νέας Υόρκης.",
          es: "Pasa un día descubriendo los monumentos emblemáticos, las enérgicas calles y el inolvidable horizonte de Nueva York.",
          it: "Trascorri una giornata scoprendo i monumenti iconici, le strade energiche e lo skyline indimenticabile di New York.",
          id: "Habiskan sehari menemukan landmark ikonik New York City, jalanan yang energik, dan cakrawala yang tak terlupakan.",
          si: "Preživite dan odkrivajoč prepoznavne znamenitosti New Yorka, energične ulice in nepozabno panoramo mesta.",
          pl: "Spędź dzień na odkrywaniu kultowych zabytków Nowego Jorku, energicznych ulic i niezapomnianej panoramy miasta.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/nyc.mp4",
      },
      {
        duration: 21336,
        id: 115,
        name: {
          en: "One Day in Paris",
          fr: "Un jour à Paris",
          de: "Ein Tag in Paris",
          be: "Een dag in Parijs",
          tr: "Paris'te Bir Gün",
          pt: "Um Dia em Paris",
          no: "En Dag i Paris",
          cy: "Један дан у Паризу",
          ee: "Üks päev Pariisis",
          th: "หนึ่งวันในปารีส",
          ar: "يوم واحد في باريس",
          gr: "Μια μέρα στο Παρίσι",
          es: "Un día en París",
          it: "Un giorno a Parigi",
          id: "Satu Hari di Paris",
          si: "En dan v Parizu",
          pl: "Jeden dzień w Paryżu",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+Paris.png",
        desc: {
          en: "Explore Paris through its elegant streets, celebrated landmarks, and timeless romantic atmosphere.",
          fr: "Explorez Paris à travers ses rues élégantes, ses monuments célèbres et son atmosphère romantique intemporelle.",
          de: "Erkunden Sie Paris mit seinen eleganten Straßen, berühmten Sehenswürdigkeiten und zeitlos romantischer Atmosphäre.",
          be: "Verken Parijs via zijn elegante straten, beroemde bezienswaardigheden en tijdloos romantische sfeer.",
          tr: "Paris'i zarif sokakları, ünlü simge yapıları ve zamansız romantik atmosferiyle keşfedin.",
          pt: "Explore Paris através das suas ruas elegantes, monumentos célebres e atmosfera romântica intemporal.",
          no: "Utforsk Paris gjennom dets elegante gater, kjente severdigheter og tidløst romantiske atmosfære.",
          cy: "Истражите Париз кроз његове елегантне улице, чувене знаменитости и безвремену романтичну атмосферу.",
          ee: "Avastage Pariisi läbi selle elegantsete tänavate, kuulsate vaatamisväärsuste ja ajatult romantilise atmosfääri.",
          th: "สำรวจปารีสผ่านถนนอันสง่างาม สถานที่สำคัญที่มีชื่อเสียง และบรรยากาศโรแมนติกที่ไม่มีวันเลือนหาย",
          ar: "استكشف باريس عبر شوارعها الأنيقة ومعالمها الشهيرة وأجوائها الرومانسية الخالدة.",
          gr: "Εξερευνήστε το Παρίσι μέσα από τους κομψούς δρόμους, τα διάσημα αξιοθέατα και τη διαχρονικά ρομαντική ατμόσφαιρά του.",
          es: "Explora París a través de sus elegantes calles, sus célebres monumentos y su atmósfera románticamente atemporal.",
          it: "Esplora Parigi attraverso le sue eleganti strade, i celebri monumenti e l'atmosfera romantica senza tempo.",
          id: "Jelajahi Paris melalui jalanan elegannya, landmark terkenal, dan suasana romantis yang abadi.",
          si: "Raziščite Pariz skozi njegove elegantne ulice, slavne znamenitosti in brezčasno romantično vzdušje.",
          pl: "Odkryj Paryż poprzez jego eleganckie ulice, słynne zabytki i ponadczasowo romantyczną atmosferę.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/paris.mp4",
      },
      {
        duration: 21336,
        id: 116,
        name: {
          en: "One Day in Rome",
          fr: "Un jour à Rome",
          de: "Ein Tag in Rom",
          be: "Een dag in Rome",
          tr: "Roma'da Bir Gün",
          pt: "Um Dia em Roma",
          no: "En Dag i Roma",
          cy: "Један дан у Риму",
          ee: "Üks päev Roomas",
          th: "หนึ่งวันในโรม",
          ar: "يوم واحد في روما",
          gr: "Μια μέρα στη Ρώμη",
          es: "Un día en Roma",
          it: "Un giorno a Roma",
          id: "Satu Hari di Roma",
          si: "En dan v Rimu",
          pl: "Jeden dzień w Rzymie",
        },
        preview:
          "https://cdn.mobio360.com/City+Tour/One+Day+in+Rome+4K.png",
        desc: {
          en: "Experience a day in Rome among ancient landmarks, lively streets, and classic Italian charm.",
          fr: "Vivez une journée à Rome parmi ses monuments antiques, ses rues animées et son charme italien classique.",
          de: "Erleben Sie einen Tag in Rom zwischen antiken Sehenswürdigkeiten, lebendigen Straßen und klassischem italienischem Charme.",
          be: "Beleef een dag in Rome tussen oude bezienswaardigheden, levendige straten en klassieke Italiaanse charme.",
          tr: "Roma'da antik simge yapılar, hareketli sokaklar ve klasik İtalyan çekiciliği arasında bir gün yaşayın.",
          pt: "Viva um dia em Roma entre monumentos antigos, ruas animadas e o charme italiano clássico.",
          no: "Opplev en dag i Roma blant eldgamle severdigheter, livlige gater og klassisk italiensk sjarm.",
          cy: "Доживите дан у Риму међу древним знаменитостима, живим улицама и класичним италијанским шармом.",
          ee: "Kogege päeva Roomas iidsete vaatamisväärsuste, elavate tänavate ja klassikalise Itaalia võlu keskel.",
          th: "สัมผัสหนึ่งวันในโรมท่ามกลางสถานที่สำคัญโบราณ ถนนที่มีชีวิตชีวา และเสน่ห์อิตาเลียนคลาสสิก",
          ar: "عِش يومًا في روما بين معالمها القديمة وشوارعها النابضة بالحياة وسحرها الإيطالي الكلاسيكي.",
          gr: "Ζήστε μια μέρα στη Ρώμη ανάμεσα σε αρχαία αξιοθέατα, ζωντανούς δρόμους και κλασική ιταλική γοητεία.",
          es: "Vive un día en Roma entre monumentos antiguos, calles animadas y el clásico encanto italiano.",
          it: "Vivi una giornata a Roma tra monumenti antichi, strade vivaci e il classico fascino italiano.",
          id: "Rasakan sehari di Roma di antara landmark kuno, jalanan yang ramai, dan pesona klasik Italia.",
          si: "Doživite dan v Rimu med starodavnimi znamenitostmi, živahnimi ulicami in klasičnim italijanskim šarmom.",
          pl: "Przeżyj dzień w Rzymie wśród starożytnych zabytków, tętniących życiem ulic i klasycznego włoskiego uroku.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/rome.mp4",
      },
      {
        duration: 21336,
        id: 117,
        name: {
          en: "One Day in Santorini",
          fr: "Un jour à Santorin",
          de: "Ein Tag auf Santorin",
          be: "Een dag op Santorini",
          tr: "Santorini'de Bir Gün",
          pt: "Um Dia em Santorini",
          no: "En Dag på Santorini",
          cy: "Један дан на Санторинију",
          ee: "Üks päev Santorinil",
          th: "หนึ่งวันในซานโตรินี",
          ar: "يوم واحد في سانتوريني",
          gr: "Μια μέρα στη Σαντορίνη",
          es: "Un día en Santorini",
          it: "Un giorno a Santorini",
          id: "Satu Hari di Santorini",
          si: "En dan na Santoriniju",
          pl: "Jeden dzień na Santorini",
        },
        preview:
          "https://cdn.mobio360.com/Adventure/One+Day+in+Santorini%2C+Greece.png",
        desc: {
          en: "Discover Santorini’s whitewashed villages, dramatic sea views, and serene island atmosphere.",
          fr: "Découvrez les villages blancs, les vues spectaculaires sur la mer et l'atmosphère sereine de Santorin.",
          de: "Entdecken Sie Santorins weiß getünchte Dörfer, dramatische Meerblicke und ruhige Inselatmosphäre.",
          be: "Ontdek Santorini's witgekalkte dorpjes, dramatische zeezichten en serene eilandsfeer.",
          tr: "Santorini'nin beyaz badanalı köylerini, çarpıcı deniz manzaralarını ve sakin ada atmosferini keşfedin.",
          pt: "Descubra as aldeias caiadas de branco, as vistas dramáticas sobre o mar e a serena atmosfera insular de Santorini.",
          no: "Oppdag Santorinis hvitkalkede landsbyer, dramatiske havutsikt og fredelige øyatmosfære.",
          cy: "Откријте бела села, драматичне погледе на море и мирну острвску атмосферу Санторинија.",
          ee: "Avastage Santorini valgeks lubjatud külasid, dramaatilisi merevaateid ja rahulikku saareatmosfääri.",
          th: "ค้นพบหมู่บ้านสีขาว วิวทะเลอันตระการตา และบรรยากาศเกาะอันสงบของซานโตรินี",
          ar: "اكتشف قرى سانتوريني البيضاء ومناظرها البحرية المذهلة وأجواءها الجزرية الهادئة.",
          gr: "Ανακαλύψτε τα ασβεστωμένα λευκά χωριά, τις εντυπωσιακές θέες στη θάλασσα και τη γαλήνια νησιωτική ατμόσφαιρα της Σαντορίνης.",
          es: "Descubre los pueblos encalados, las impresionantes vistas al mar y la serena atmósfera insular de Santorini.",
          it: "Scopri i villaggi imbiancati a calce, le spettacolari viste sul mare e la serena atmosfera insulare di Santorini.",
          id: "Temukan desa-desa berdinding putih, pemandangan laut yang dramatis, dan suasana pulau yang tenang di Santorini.",
          si: "Odkrijte pobeljene vasice, dramatične poglede na morje in mirno otoško vzdušje Santorinija.",
          pl: "Odkryj pobielone wioski, dramatyczne widoki na morze i spokojną atmosferę wyspy Santorini.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/santorini.mp4",
      },
      {
        duration: 21336,
        id: 118,
        name: {
          en: "One Day in Siem Reap",
          fr: "Un jour à Siem Reap",
          de: "Ein Tag in Siem Reap",
          be: "Een dag in Siem Reap",
          tr: "Siem Reap'te Bir Gün",
          pt: "Um Dia em Siem Reap",
          no: "En Dag i Siem Reap",
          cy: "Један дан у Сијем Реапу",
          ee: "Üks päev Siem Reapis",
          th: "หนึ่งวันในเสียมเรียบ",
          ar: "يوم واحد في سيام ريب",
          gr: "Μια μέρα στο Σιεμ Ριπ",
          es: "Un día en Siem Reap",
          it: "Un giorno a Siem Reap",
          id: "Satu Hari di Siem Reap",
          si: "En dan v Siem Reapu",
          pl: "Jeden dzień w Siem Reap",
        },
        preview:
          "https://cdn.mobio360.com/Documentary/One+Day+in+Siem+Reap.png",
        desc: {
          en: "Explore Siem Reap’s vibrant local culture, atmospheric streets, and remarkable historic surroundings.",
          fr: "Explorez la culture locale vivante, les rues pittoresques et les remarquables sites historiques de Siem Reap.",
          de: "Erkunden Sie Siem Reaps lebendige lokale Kultur, stimmungsvolle Straßen und bemerkenswerte historische Umgebung.",
          be: "Verken Siem Reaps levendige lokale cultuur, sfeervolle straten en opmerkelijke historische omgeving.",
          tr: "Siem Reap'in canlı yerel kültürünü, atmosferik sokaklarını ve dikkat çekici tarihi çevresini keşfedin.",
          pt: "Explore a vibrante cultura local, as ruas cheias de atmosfera e o notável ambiente histórico de Siem Reap.",
          no: "Utforsk Siem Reaps livlige lokale kultur, stemningsfulle gater og bemerkelsesverdige historiske omgivelser.",
          cy: "Истражите живу локалну културу, атмосферичне улице и изузетно историјско окружење Сијем Реапа.",
          ee: "Uurige Siem Reapi elavat kohalikku kultuuri, meeleolukaid tänavaid ja märkimisväärset ajaloolist keskkonda.",
          th: "สำรวจวัฒนธรรมท้องถิ่นอันมีชีวิตชีวา ถนนที่เปี่ยมบรรยากาศ และสภาพแวดล้อมทางประวัติศาสตร์อันน่าทึ่งของเสียมเรียบ",
          ar: "استكشف ثقافة سيام ريب المحلية النابضة بالحياة وشوارعها المفعمة بالأجواء ومحيطها التاريخي اللافت.",
          gr: "Εξερευνήστε τη ζωντανή τοπική κουλτούρα, τους γεμάτους ατμόσφαιρα δρόμους και το αξιοσημείωτο ιστορικό περιβάλλον του Σιεμ Ριπ.",
          es: "Explora la vibrante cultura local, las atmosféricas calles y el notable entorno histórico de Siem Reap.",
          it: "Esplora la vivace cultura locale, le suggestive strade e il notevole ambiente storico di Siem Reap.",
          id: "Jelajahi budaya lokal Siem Reap yang hidup, jalanan yang penuh suasana, dan lingkungan bersejarah yang luar biasa.",
          si: "Raziščite živahno lokalno kulturo, vzdušne ulice in izjemno zgodovinsko okolje Siem Reapa.",
          pl: "Poznaj żywą lokalną kulturę, pełne atmosfery ulice i niezwykłe historyczne otoczenie Siem Reap.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Travel/siem_reap.mp4",
      },
    ],
  },
  {
    id: 2,
    contents: 4,
    categoryName: {
      en: "Music",
      fr: "Musique",
      de: "Musik",
      be: "Muziek",
      tr: "Müzik",
      pt: "Música",
      no: "Musikk",
      cy: "Музика",
      ee: "Muusika",
      th: "ดนตรี",
      ar: "موسيقى",
      gr: "Μουσική",
      es: "Música",
      it: "Musica",
      id: "Musik",
      si: "Glasba",
      pl: "Muzyka",
    },
    videos: [
      {
        duration: 279,
        id: 201,
        name: {
          en: "Prelude in C Major by Johann Sebastian Bach at the Beach",
          fr: "Prélude en ut majeur de Johann Sebastian Bach à la plage",
          de: "Präludium C-Dur von Johann Sebastian Bach am Strand",
          be: "Prelude in C majeur van Johann Sebastian Bach aan het strand",
          tr: "Sahilde Johann Sebastian Bach'ın Do Majör Prelüdü",
          pt: "Prelúdio em Dó Maior de Johann Sebastian Bach na Praia",
          no: "Preludium i C-dur av Johann Sebastian Bach på stranden",
          cy: "Прелудијум у Ц-дуру Јохана Себастијана Баха на плажи",
          ee: "Johann Sebastian Bachi prelüüd C-duur rannas",
          th: "พรีลูดในคีย์ซีเมเจอร์ โดยโยฮันน์ เซบาสเตียน บาค ที่ชายหาด",
          ar: "بريلود دو الكبير ليوهان سيباستيان باخ على الشاطئ",
          gr: "Πρελούδιο σε Ντο Μείζονα του Γιόχαν Σεμπάστιαν Μπαχ στην παραλία",
          es: "Preludio en Do Mayor de Johann Sebastian Bach en la playa",
          it: "Preludio in Do Maggiore di Johann Sebastian Bach in spiaggia",
          id: "Prelude dalam C Mayor oleh Johann Sebastian Bach di Pantai",
          si: "Preludij v C-duru Johanna Sebastiana Bacha na plaži",
          pl: "Preludium C-dur Johanna Sebastiana Bacha na plaży",
        },
        preview: "https://cdn.mobio360.com/new+videos/Music/PreludeinCMajorbyJohannSebastianBachattheBeach.png",
        desc: {
          en: "Enjoy Bach’s timeless Prelude in C Major accompanied by peaceful seaside scenery.",
          fr: "Profitez du Prélude en ut majeur intemporel de Bach, accompagné d'un paysage côtier apaisant.",
          de: "Genießen Sie Bachs zeitloses Präludium in C-Dur begleitet von friedlicher Küstenlandschaft.",
          be: "Geniet van Bachs tijdloze Prelude in C majeur, begeleid door een rustig kustlandschap.",
          tr: "Bach'ın zamansız Do Majör Prelüdünü huzurlu bir sahil manzarası eşliğinde dinleyin.",
          pt: "Desfrute do intemporal Prelúdio em Dó Maior de Bach, acompanhado por uma paisagem costeira tranquila.",
          no: "Nyt Bachs tidløse Preludium i C-dur ledsaget av fredelig kystnatur.",
          cy: "Уживајте у безвременом Прелудијуму у Ц-дуру Јохана Себастијана Баха уз миран приморски пејзаж.",
          ee: "Nautige Bachi ajatut prelüüdi C-duur, mida saadab rahulik rannikumaastik.",
          th: "เพลิดเพลินกับพรีลูดในคีย์ซีเมเจอร์อันเป็นอมตะของบาค พร้อมทิวทัศน์ชายฝั่งอันสงบ",
          ar: "استمتع ببريلود باخ الخالد في دو الكبير برفقة مناظر ساحلية هادئة.",
          gr: "Απολαύστε το διαχρονικό Πρελούδιο σε Ντο Μείζονα του Μπαχ, συνοδευόμενο από γαλήνιο παραθαλάσσιο τοπίο.",
          es: "Disfruta del atemporal Preludio en Do Mayor de Bach acompañado de un tranquilo paisaje costero.",
          it: "Goditi l'intramontabile Preludio in Do Maggiore di Bach accompagnato da un tranquillo paesaggio costiero.",
          id: "Nikmati Prelude dalam C Mayor karya Bach yang abadi, diiringi pemandangan pantai yang tenang.",
          si: "Uživajte v brezčasnem Preludiju v C-duru Johanna Sebastiana Bacha ob mirni obalni pokrajini.",
          pl: "Ciesz się ponadczasowym Preludium C-dur Bacha w towarzystwie spokojnego nadmorskiego krajobrazu.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Music/BeachSide-JohannSebastianBach-PreludeinCMajor.mp4",
      },
      {
        duration: 21334,
        id: 202,
        name: {
          en: "Bugatti Step by Jaroslav Ježek in the Rainforest",
          fr: "Bugatti Step de Jaroslav Ježek dans la forêt tropicale",
          de: "Bugatti Step von Jaroslav Ježek im Regenwald",
          be: "Bugatti Step van Jaroslav Ježek in het regenwoud",
          tr: "Yağmur Ormanında Jaroslav Ježek'in Bugatti Step'i",
          pt: "Bugatti Step de Jaroslav Ježek na Floresta Tropical",
          no: "Bugatti Step av Jaroslav Ježek i regnskogen",
          cy: "Бугати степ Јарослава Јежека у прашуми",
          ee: "Jaroslav Ježeki Bugatti Step vihmametsas",
          th: "บูกัตติ สเต็ป โดยยาโรสลาฟ เยเช็ค ในป่าฝน",
          ar: "بوغاتي ستيب لياروسلاف يجيك في الغابة المطيرة",
          gr: "Bugatti Step του Γίαροσλαβ Γιέζεκ στο τροπικό δάσος",
          es: "Bugatti Step de Jaroslav Ježek en la selva tropical",
          it: "Bugatti Step di Jaroslav Ježek nella foresta pluviale",
          id: "Bugatti Step oleh Jaroslav Ježek di Hutan Hujan",
          si: "Bugatti korak Jaroslava Ježeka v deževnem gozdu",
          pl: "Bugatti Step Jaroslava Ježka w lesie deszczowym",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Music/BugattiStepbyJaroslavJez%CC%8CekintheRainforest.png",
        desc: {
          en: "Experience Jaroslav Ježek’s lively Bugatti Step set against the lush sounds and scenery of a rainforest.",
          fr: "Découvrez le vif Bugatti Step de Jaroslav Ježek sur fond de sons et de paysages luxuriants d'une forêt tropicale.",
          de: "Erleben Sie Jaroslav Ježeks lebhaften Bugatti Step vor den üppigen Klängen und Landschaften eines Regenwaldes.",
          be: "Beleef Jaroslav Ježeks levendige Bugatti Step tegen de weelderige klanken en het landschap van een regenwoud.",
          tr: "Jaroslav Ježek'in canlı Bugatti Step'ini bir yağmur ormanının bereketli sesleri ve manzarası eşliğinde deneyimleyin.",
          pt: "Viva o animado Bugatti Step de Jaroslav Ježek com os sons exuberantes e a paisagem de uma floresta tropical.",
          no: "Opplev Jaroslav Ježeks livlige Bugatti Step mot de frodige lydene og landskapet i en regnskog.",
          cy: "Доживите живахни Бугати степ Јарослава Јежека уз богате звуке и пејзаже прашуме.",
          ee: "Kogege Jaroslav Ježeki elavat Bugatti Stepi vihmametsa lopsakate helide ja maastiku taustal.",
          th: "สัมผัสบูกัตติ สเต็ป อันมีชีวิตชีวาของยาโรสลาฟ เยเช็ค ท่ามกลางเสียงและทิวทัศน์อันอุดมสมบูรณ์ของป่าฝน",
          ar: "اختبر بوغاتي ستيب الحيوي لياروسلاف يجيك وسط أصوات ومناظر الغابة المطيرة الغنية.",
          gr: "Ζήστε το ζωηρό Bugatti Step του Γίαροσλαβ Γιέζεκ πάνω στους πλούσιους ήχους και το τοπίο ενός τροπικού δάσους.",
          es: "Vive el animado Bugatti Step de Jaroslav Ježek junto a los exuberantes sonidos y paisajes de una selva tropical.",
          it: "Vivi il vivace Bugatti Step di Jaroslav Ježek tra i suoni rigogliosi e i paesaggi di una foresta pluviale.",
          id: "Rasakan Bugatti Step yang enerjik karya Jaroslav Ježek dengan latar suara dan pemandangan hutan hujan yang rimbun.",
          si: "Doživite živahni Bugatti korak Jaroslava Ježeka ob bogatih zvokih in pokrajini deževnega gozda.",
          pl: "Przeżyj żywiołowy Bugatti Step Jaroslava Ježka na tle bujnych dźwięków i krajobrazu lasu deszczowego.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Music/Rainforest-JaroslavJez%CC%8Cek-Bugattistep.mp4",
      },
      {
        duration: 21334,
        id: 203,
        name: {
          en: "Rondo Alla Turca by Wolfgang Amadeus Mozart on a Rainy Day",
          fr: "Rondo Alla Turca de Wolfgang Amadeus Mozart par un jour de pluie",
          de: "Rondo Alla Turca von Wolfgang Amadeus Mozart an einem Regentag",
          be: "Rondo Alla Turca van Wolfgang Amadeus Mozart op een regenachtige dag",
          tr: "Yağmurlu Bir Günde Wolfgang Amadeus Mozart'ın Rondo Alla Turca'sı",
          pt: "Rondo Alla Turca de Wolfgang Amadeus Mozart num Dia Chuvoso",
          no: "Rondo Alla Turca av Wolfgang Amadeus Mozart på en regnfull dag",
          cy: "Рондо Алла Турка Волфганга Амадеуса Моцарта на кишовит дан",
          ee: "Wolfgang Amadeus Mozarti Rondo Alla Turca vihmasel päeval",
          th: "รอนโดอัลลาเติร์กา โดยวอล์ฟกัง อมาเดอุส โมซาร์ท ในวันฝนตก",
          ar: "روندو ألا توركا لفولفغانغ أماديوس موتسارت في يوم ممطر",
          gr: "Rondo Alla Turca του Βόλφγκανγκ Αμαντέους Μότσαρτ σε μια βροχερή μέρα",
          es: "Rondó a la Turca de Wolfgang Amadeus Mozart en un día lluvioso",
          it: "Rondò alla Turca di Wolfgang Amadeus Mozart in un giorno di pioggia",
          id: "Rondo Alla Turca oleh Wolfgang Amadeus Mozart di Hari Hujan",
          si: "Rondo Alla Turca Wolfganga Amadeusa Mozarta v deževnem dnevu",
          pl: "Rondo Alla Turca Wolfganga Amadeusza Mozarta w deszczowy dzień",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Music/RondoAllaTurcabyWolfgangAmadeusMozartonaRainyDay.png",
        desc: {
          en: "Listen to Mozart’s energetic Rondo Alla Turca while relaxing in the atmosphere of a rainy day.",
          fr: "Écoutez l'énergique Rondo Alla Turca de Mozart en vous détendant dans l'atmosphère d'un jour de pluie.",
          de: "Hören Sie Mozarts energiegeladenes Rondo Alla Turca und entspannen Sie in der Atmosphäre eines Regentages.",
          be: "Luister naar Mozarts energieke Rondo Alla Turca terwijl je ontspant in de sfeer van een regenachtige dag.",
          tr: "Yağmurlu bir günün atmosferinde dinlenirken Mozart'ın enerjik Rondo Alla Turca'sını dinleyin.",
          pt: "Ouça o enérgico Rondo Alla Turca de Mozart enquanto relaxa na atmosfera de um dia chuvoso.",
          no: "Hør på Mozarts energiske Rondo Alla Turca mens du slapper av i atmosfæren til en regnfull dag.",
          cy: "Слушајте енергично Рондо Алла Турка Моцарта док се опуштате у атмосфери кишовитог дана.",
          ee: "Kuulake Mozarti energilist Rondo Alla Turcat, lõõgastudes vihmase päeva atmosfääris.",
          th: "ฟังรอนโดอัลลาเติร์กาอันเปี่ยมพลังของโมซาร์ท พร้อมผ่อนคลายในบรรยากาศวันฝนตก",
          ar: "استمع إلى روندو ألا توركا النشيط لموتسارت بينما تسترخي في أجواء يوم ممطر.",
          gr: "Ακούστε το ενεργητικό Rondo Alla Turca του Μότσαρτ ενώ χαλαρώνετε στην ατμόσφαιρα μιας βροχερής μέρας.",
          es: "Escucha el enérgico Rondó a la Turca de Mozart mientras te relajas en la atmósfera de un día lluvioso.",
          it: "Ascolta l'energico Rondò alla Turca di Mozart rilassandoti nell'atmosfera di una giornata di pioggia.",
          id: "Dengarkan Rondo Alla Turca karya Mozart yang penuh energi sambil bersantai dalam suasana hari hujan.",
          si: "Poslušajte energičen Rondo Alla Turca Mozarta ob sproščanju v vzdušju deževnega dne.",
          pl: "Posłuchaj energicznego Ronda Alla Turca Mozarta, relaksując się w atmosferze deszczowego dnia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Music/Rainy-RondoAllaTurca-Mozart.mp4",
      },
      {
        duration: 21334,
        id: 204,
        name: {
          en: "Storm by Antonio Vivaldi on a Windy Day",
          fr: "Storm d'Antonio Vivaldi par un jour de vent",
          de: "Storm von Antonio Vivaldi an einem windigen Tag",
          be: "Storm van Antonio Vivaldi op een winderige dag",
          tr: "Rüzgarlı Bir Günde Antonio Vivaldi'nin Storm'u",
          pt: "Storm de Antonio Vivaldi num Dia de Vento",
          no: "Storm av Antonio Vivaldi på en vindfull dag",
          cy: "Олуја Антонија Вивалдија на ветровит дан",
          ee: "Antonio Vivaldi Storm tuulisel päeval",
          th: "สตอร์ม โดยอันโตนิโอ วิวัลดี ในวันที่มีลมแรง",
          ar: "ستورم لأنطونيو فيفالدي في يوم عاصف",
          gr: "Storm του Αντόνιο Βιβάλντι σε μια ανεμώδη μέρα",
          es: "Tormenta de Antonio Vivaldi en un día ventoso",
          it: "Storm di Antonio Vivaldi in una giornata ventosa",
          id: "Storm oleh Antonio Vivaldi di Hari Berangin",
          si: "Nevihta Antonia Vivaldija na vetrovni dan",
          pl: "Burza Antonia Vivaldiego w wietrzny dzień",
        },
        preview: "https://cdn.mobio360.com/new+videos/Music/StormbyAntonioVivaldionaWindyDay.png",
        desc: {
          en: "Feel the intensity of Vivaldi’s Storm paired with dramatic windswept scenery.",
          fr: "Ressentez l'intensité du Storm de Vivaldi associée à un paysage spectaculaire balayé par le vent.",
          de: "Spüren Sie die Intensität von Vivaldis Storm gepaart mit dramatischer, windgepeitschter Landschaft.",
          be: "Voel de intensiteit van Vivaldi's Storm gecombineerd met dramatisch, door de wind geteisterd landschap.",
          tr: "Vivaldi'nin Storm'unun yoğunluğunu, rüzgarın dövdüğü çarpıcı manzarayla birlikte hissedin.",
          pt: "Sinta a intensidade do Storm de Vivaldi aliada a uma paisagem dramática varrida pelo vento.",
          no: "Kjenn intensiteten i Vivaldis Storm kombinert med dramatisk, vindpisket landskap.",
          cy: "Осетите интензитет Олује Антонија Вивалдија у комбинацији са драматичним пејзажом шибаним ветром.",
          ee: "Tundke Vivaldi Stormi intensiivsust koos dramaatilise tuulise maastikuga.",
          th: "สัมผัสความเข้มข้นของสตอร์มของวิวัลดี ควบคู่กับทิวทัศน์อันตระการตาที่ถูกลมพัดกระหน่ำ",
          ar: "اشعر بشدة ستورم لفيفالدي إلى جانب مناظر طبيعية مذهلة تجتاحها الرياح.",
          gr: "Νιώστε την ένταση του Storm του Βιβάλντι σε συνδυασμό με ένα εντυπωσιακό ανεμοδαρμένο τοπίο.",
          es: "Siente la intensidad de la Tormenta de Vivaldi junto a un dramático paisaje azotado por el viento.",
          it: "Senti l'intensità dello Storm di Vivaldi accanto a un drammatico paesaggio spazzato dal vento.",
          id: "Rasakan intensitas Storm karya Vivaldi yang dipadukan dengan pemandangan dramatis yang diterpa angin.",
          si: "Občutite intenzivnost Nevihte Vivaldija v kombinaciji z dramatično pokrajino, ki jo pustoši veter.",
          pl: "Poczuj intensywność Burzy Vivaldiego w połączeniu z dramatycznym, smaganym wiatrem krajobrazem.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Music/Windy-AntonioVivaldi-Storm.mp4",
      },
    ],
  },
  {
    id: 3,
    contents: 10,
    categoryName: {
      en: "Documentary",
      fr: "Documentaire",
      de: "Dokumentarfilm",
      be: "Documentaire",
      tr: "Belgesel",
      pt: "Documentário",
      no: "Dokumentar",
      cy: "Документарни",
      ee: "Dokumentaalfilm",
      th: "สารคดี",
      ar: "وثائقي",
      gr: "Ντοκιμαντέρ",
      es: "Documental",
      it: "Documentario",
      id: "Dokumenter",
      si: "Dokumentarec",
      pl: "Dokument",
    },
    videos: [
      {
        duration: 279,
        id: 301,
        name: {
          en: "Why Do We Yawn?",
          fr: "Pourquoi bâillons-nous ?",
          de: "Warum gähnen wir?",
          be: "Waarom geeuwen we?",
          tr: "Neden Esneriz?",
          pt: "Por que Bocejamos?",
          no: "Hvorfor gjesper vi?",
          cy: "Зашто зевамо?",
          ee: "Miks me haigutame?",
          th: "ทำไมเราถึงหาว?",
          ar: "لماذا نتثاءب؟",
          gr: "Γιατί χασμουριόμαστε;",
          es: "¿Por qué bostezamos?",
          it: "Perché sbadigliamo?",
          id: "Mengapa Kita Menguap?",
          si: "Zakaj zehamo?",
          pl: "Dlaczego ziewamy?",
        },
        preview: "https://cdn.mobio360.com/new+videos/Documentary/WhyDoWeYawn.png",
        desc: {
          en: "Discover why we yawn and what this familiar reflex reveals about the human body.",
          fr: "Découvrez pourquoi nous bâillons et ce que ce réflexe familier révèle sur le corps humain.",
          de: "Entdecken Sie, warum wir gähnen und was dieser vertraute Reflex über den menschlichen Körper verrät.",
          be: "Ontdek waarom we geeuwen en wat deze vertrouwde reflex onthult over het menselijk lichaam.",
          tr: "Neden esnediğimizi ve bu tanıdık refleksin insan vücudu hakkında neler ortaya koyduğunu keşfedin.",
          pt: "Descubra por que bocejamos e o que este reflexo familiar revela sobre o corpo humano.",
          no: "Oppdag hvorfor vi gjesper og hva denne kjente refleksen avslører om menneskekroppen.",
          cy: "Откријте зашто зевамо и шта тај познати рефлекс открива о људском телу.",
          ee: "Avastage, miks me haigutame ja mida see tuttav refleks inimkeha kohta paljastab.",
          th: "ค้นพบว่าทำไมเราถึงหาว และรีเฟล็กซ์ที่คุ้นเคยนี้เผยอะไรเกี่ยวกับร่างกายมนุษย์",
          ar: "اكتشف لماذا نتثاءب وما الذي يكشفه هذا المنعكس المألوف عن جسم الإنسان.",
          gr: "Ανακαλύψτε γιατί χασμουριόμαστε και τι αποκαλύπτει αυτό το οικείο αντανακλαστικό για το ανθρώπινο σώμα.",
          es: "Descubre por qué bostezamos y qué revela este reflejo tan familiar sobre el cuerpo humano.",
          it: "Scopri perché sbadigliamo e cosa rivela questo riflesso familiare sul corpo umano.",
          id: "Temukan mengapa kita menguap dan apa yang diungkapkan refleks umum ini tentang tubuh manusia.",
          si: "Odkrijte, zakaj zehamo in kaj ta znani refleks razkriva o človeškem telesu.",
          pl: "Odkryj, dlaczego ziewamy i co ten znajomy odruch mówi o ludzkim ciele.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Documentary/WhyDoWeYawn.mp4",
      },
      {
        duration: 21334,
        id: 302,
        name: {
          en: "The Secret Life of Bananas",
          fr: "La vie secrète des bananes",
          de: "Das geheime Leben der Bananen",
          be: "Het geheime leven van bananen",
          tr: "Muzların Gizli Hayatı",
          pt: "A Vida Secreta das Bananas",
          no: "Bananenes hemmelige liv",
          cy: "Тајни живот банана",
          ee: "Banaanide salaelu",
          th: "ชีวิตลับของกล้วย",
          ar: "الحياة السرية للموز",
          gr: "Η μυστική ζωή των μπανανών",
          es: "La vida secreta de los plátanos",
          it: "La vita segreta delle banane",
          id: "Kehidupan Rahasia Pisang",
          si: "Skrivno življenje banan",
          pl: "Tajemnicze życie bananów",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/TheSecretLifeofBananas.png",
        desc: {
          en: "Explore the surprising journey of bananas, from tropical plants to one of the world’s favourite fruits.",
          fr: "Explorez le parcours surprenant des bananes, des plantes tropicales à l'un des fruits préférés au monde.",
          de: "Erkunden Sie die überraschende Reise der Banane, von tropischen Pflanzen zu einer der beliebtesten Früchte der Welt.",
          be: "Verken de verrassende reis van bananen, van tropische planten tot een van de favoriete fruitsoorten ter wereld.",
          tr: "Muzların tropikal bitkilerden dünyanın en sevilen meyvelerinden birine uzanan şaşırtıcı yolculuğunu keşfedin.",
          pt: "Explore a surpreendente jornada das bananas, de plantas tropicais a uma das frutas favoritas do mundo.",
          no: "Utforsk bananens overraskende reise, fra tropiske planter til en av verdens mest elskede frukter.",
          cy: "Истражите изненађујуће путовање банана, од тропских биљака до једног од најомиљенијих воћа на свету.",
          ee: "Uurige banaanide üllatavat teekonda troopilistest taimedest üheks maailma lemmikuviljaks.",
          th: "สำรวจการเดินทางอันน่าประหลาดใจของกล้วย จากพืชเมืองร้อนสู่หนึ่งในผลไม้โปรดของโลก",
          ar: "استكشف الرحلة المدهشة للموز، من نبات استوائي إلى واحدة من أكثر الفواكه المحبوبة في العالم.",
          gr: "Εξερευνήστε το εκπληκτικό ταξίδι της μπανάνας, από τροπικά φυτά έως ένα από τα αγαπημένα φρούτα του κόσμου.",
          es: "Explora el sorprendente viaje del plátano, desde plantas tropicales hasta una de las frutas favoritas del mundo.",
          it: "Esplora il sorprendente viaggio delle banane, da piante tropicali a uno dei frutti preferiti al mondo.",
          id: "Jelajahi perjalanan mengejutkan pisang, dari tanaman tropis hingga menjadi salah satu buah favorit dunia.",
          si: "Raziščite presenetljivo pot banan, od tropskih rastlin do enega najbolj priljubljenih sadežev na svetu.",
          pl: "Poznaj zaskakującą podróż bananów, od tropikalnych roślin po jedno z ulubionych owoców świata.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/TheSecretLifeofBananas.mp4",
      },
      {
        duration: 21334,
        id: 303,
        name: {
          en: "Why Cats Knock Things Over",
          fr: "Pourquoi les chats font tomber des objets",
          de: "Warum Katzen Dinge herunterwerfen",
          be: "Waarom katten dingen omgooien",
          tr: "Kediler Neden Eşyaları Devirir",
          pt: "Por que os Gatos Derrubam Coisas",
          no: "Hvorfor katter dytter ting ned",
          cy: "Зашто мачке обарају ствари",
          ee: "Miks kassid asju maha lükkavad",
          th: "ทำไมแมวถึงทำของหล่น",
          ar: "لماذا تُسقط القطط الأشياء",
          gr: "Γιατί οι γάτες ρίχνουν αντικείμενα",
          es: "Por qué los gatos tiran cosas",
          it: "Perché i gatti fanno cadere le cose",
          id: "Mengapa Kucing Menjatuhkan Barang",
          si: "Zakaj mačke podirajo predmete",
          pl: "Dlaczego koty strącają przedmioty",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyCatsKnockThingsOver.png",
        desc: {
          en: "Find out why cats push objects from surfaces and what this curious behaviour may reveal.",
          fr: "Découvrez pourquoi les chats poussent des objets des surfaces et ce que ce comportement curieux peut révéler.",
          de: "Finden Sie heraus, warum Katzen Gegenstände von Oberflächen stoßen und was dieses merkwürdige Verhalten verraten könnte.",
          be: "Ontdek waarom katten voorwerpen van oppervlakken duwen en wat dit merkwaardige gedrag kan onthullen.",
          tr: "Kedilerin neden eşyaları yüzeylerden ittiğini ve bu ilginç davranışın neyi ortaya çıkarabileceğini öğrenin.",
          pt: "Descubra por que os gatos empurram objetos das superfícies e o que este curioso comportamento pode revelar.",
          no: "Finn ut hvorfor katter dytter gjenstander ned fra overflater, og hva denne merkelige atferden kan avsløre.",
          cy: "Сазнајте зашто мачке гурају предмете са површина и шта то радознало понашање може открити.",
          ee: "Uurige, miks kassid lükkavad esemeid pindadelt maha ja mida see uudishimulik käitumine võib paljastada.",
          th: "ค้นหาว่าทำไมแมวถึงผลักสิ่งของตกจากพื้นผิว และพฤติกรรมแปลกนี้อาจเผยอะไร",
          ar: "اكتشف لماذا تدفع القطط الأشياء من على الأسطح وما قد يكشفه هذا السلوك الغريب.",
          gr: "Μάθετε γιατί οι γάτες σπρώχνουν αντικείμενα από επιφάνειες και τι μπορεί να αποκαλύπτει αυτή η περίεργη συμπεριφορά.",
          es: "Descubre por qué los gatos empujan objetos de las superficies y qué puede revelar este curioso comportamiento.",
          it: "Scopri perché i gatti spingono gli oggetti dalle superfici e cosa può rivelare questo curioso comportamento.",
          id: "Cari tahu mengapa kucing mendorong benda dari permukaan dan apa yang mungkin diungkapkan perilaku unik ini.",
          si: "Ugotovite, zakaj mačke potiskajo predmete s površin in kaj lahko to zanimivo vedenje razkriva.",
          pl: "Dowiedz się, dlaczego koty strącają przedmioty z powierzchni i co może zdradzać to ciekawe zachowanie.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyCatsKnockThingsOver.mp4",
      },
      {
        duration: 21334,
        id: 304,
        name: {
          en: "How Wi-Fi Travels Through Walls",
          fr: "Comment le Wi-Fi traverse les murs",
          de: "Wie WLAN durch Wände dringt",
          be: "Hoe wifi door muren reist",
          tr: "Wi-Fi Duvarlardan Nasıl Geçer",
          pt: "Como o Wi-Fi Atravessa Paredes",
          no: "Hvordan Wi-Fi beveger seg gjennom vegger",
          cy: "Како Wi-Fi пролази кроз зидове",
          ee: "Kuidas WiFi seintest läbi liigub",
          th: "ไวไฟเดินทางผ่านกำแพงได้อย่างไร",
          ar: "كيف تنتقل شبكة الواي فاي عبر الجدران",
          gr: "Πώς το Wi-Fi περνάει μέσα από τοίχους",
          es: "Cómo viaja el Wi-Fi a través de las paredes",
          it: "Come il Wi-Fi attraversa i muri",
          id: "Bagaimana Wi-Fi Menembus Dinding",
          si: "Kako Wi-Fi potuje skozi stene",
          pl: "Jak Wi-Fi przenika przez ściany",
        },
        preview: "https://cdn.mobio360.com/new+videos/Documentary/HowWiFiTravelsThroughWalls.png",
        desc: {
          en: "See how Wi-Fi signals move through walls to keep our devices connected.",
          fr: "Découvrez comment les signaux Wi-Fi traversent les murs pour garder nos appareils connectés.",
          de: "Sehen Sie, wie WLAN-Signale durch Wände dringen, um unsere Geräte verbunden zu halten.",
          be: "Bekijk hoe wifi-signalen door muren bewegen om onze apparaten verbonden te houden.",
          tr: "Wi-Fi sinyallerinin cihazlarımızı bağlı tutmak için duvarlardan nasıl geçtiğini görün.",
          pt: "Veja como os sinais de Wi-Fi atravessam paredes para manter os nossos dispositivos ligados.",
          no: "Se hvordan Wi-Fi-signaler beveger seg gjennom vegger for å holde enhetene våre tilkoblet.",
          cy: "Погледајте како Wi-Fi сигнали пролазе кроз зидове како би наши уређаји остали повезани.",
          ee: "Vaadake, kuidas WiFi signaalid liiguvad läbi seinte, et hoida meie seadmed ühendatuna.",
          th: "ดูว่าสัญญาณไวไฟเดินทางผ่านกำแพงอย่างไรเพื่อให้อุปกรณ์ของเรายังคงเชื่อมต่อ",
          ar: "شاهد كيف تنتقل إشارات الواي فاي عبر الجدران للحفاظ على اتصال أجهزتنا.",
          gr: "Δείτε πώς τα σήματα Wi-Fi περνούν μέσα από τοίχους για να κρατούν τις συσκευές μας συνδεδεμένες.",
          es: "Observa cómo las señales de Wi-Fi atraviesan las paredes para mantener conectados nuestros dispositivos.",
          it: "Guarda come i segnali Wi-Fi attraversano i muri per mantenere connessi i nostri dispositivi.",
          id: "Lihat bagaimana sinyal Wi-Fi bergerak menembus dinding untuk menjaga perangkat kita tetap terhubung.",
          si: "Oglejte si, kako signali Wi-Fi potujejo skozi stene, da ohranjajo naše naprave povezane.",
          pl: "Zobacz, jak sygnały Wi-Fi przenikają przez ściany, utrzymując nasze urządzenia w łączności.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Documentary/HowWi-FiTravelsThroughWalls.mp4",
      },
      {
        duration: 21334,
        id: 305,
        name: {
          en: "The Day Plastic Took Over the World",
          fr: "Le jour où le plastique a envahi le monde",
          de: "Der Tag, an dem Plastik die Welt eroberte",
          be: "De dag dat plastic de wereld overnam",
          tr: "Plastiğin Dünyayı Ele Geçirdiği Gün",
          pt: "O Dia em que o Plástico Dominou o Mundo",
          no: "Dagen plast tok over verden",
          cy: "Дан када је пластика освојила свет",
          ee: "Päev, mil plast vallutas maailma",
          th: "วันที่พลาสติกครองโลก",
          ar: "اليوم الذي سيطر فيه البلاستيك على العالم",
          gr: "Η μέρα που το πλαστικό κατέκτησε τον κόσμο",
          es: "El día en que el plástico conquistó el mundo",
          it: "Il giorno in cui la plastica conquistò il mondo",
          id: "Hari Ketika Plastik Menguasai Dunia",
          si: "Dan, ko je plastika prevzela svet",
          pl: "Dzień, w którym plastik zawładnął światem",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/TheDayPlasticTookOvertheWorld.png",
        desc: {
          en: "Explore how plastic transformed everyday life and created one of the world’s biggest environmental challenges.",
          fr: "Explorez comment le plastique a transformé la vie quotidienne et créé l'un des plus grands défis environnementaux au monde.",
          de: "Erkunden Sie, wie Plastik den Alltag veränderte und zu einer der größten Umweltherausforderungen der Welt wurde.",
          be: "Verken hoe plastic het dagelijks leven veranderde en een van 's werelds grootste milieu-uitdagingen creëerde.",
          tr: "Plastiğin günlük yaşamı nasıl dönüştürdüğünü ve dünyanın en büyük çevresel sorunlarından birini nasıl yarattığını keşfedin.",
          pt: "Explore como o plástico transformou a vida quotidiana e criou um dos maiores desafios ambientais do mundo.",
          no: "Utforsk hvordan plast forvandlet hverdagslivet og skapte en av verdens største miljøutfordringer.",
          cy: "Истражите како је пластика преобразила свакодневни живот и створила један од највећих еколошких изазова на свету.",
          ee: "Uurige, kuidas plast muutis igapäevaelu ja lõi ühe maailma suurima keskkonnaprobleemi.",
          th: "สำรวจว่าพลาสติกเปลี่ยนแปลงชีวิตประจำวันอย่างไรและสร้างหนึ่งในความท้าทายด้านสิ่งแวดล้อมที่ใหญ่ที่สุดของโลก",
          ar: "استكشف كيف غيّر البلاستيك الحياة اليومية وخلق أحد أكبر التحديات البيئية في العالم.",
          gr: "Εξερευνήστε πώς το πλαστικό μεταμόρφωσε την καθημερινή ζωή και δημιούργησε μία από τις μεγαλύτερες περιβαλλοντικές προκλήσεις του κόσμου.",
          es: "Explora cómo el plástico transformó la vida cotidiana y creó uno de los mayores desafíos ambientales del mundo.",
          it: "Esplora come la plastica ha trasformato la vita quotidiana creando una delle più grandi sfide ambientali al mondo.",
          id: "Jelajahi bagaimana plastik mengubah kehidupan sehari-hari dan menciptakan salah satu tantangan lingkungan terbesar dunia.",
          si: "Raziščite, kako je plastika preoblikovala vsakdanje življenje in ustvarila enega največjih okoljskih izzivov na svetu.",
          pl: "Poznaj, jak plastik zmienił codzienne życie i stał się jednym z największych wyzwań środowiskowych świata.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/TheDayPlasticTookOverTheWorld.mp4",
      },
      {
        duration: 21335,
        id: 306,
        name: {
          en: "Why Do We Dream?",
          fr: "Pourquoi rêvons-nous ?",
          de: "Warum träumen wir?",
          be: "Waarom dromen we?",
          tr: "Neden Rüya Görürüz?",
          pt: "Por que Sonhamos?",
          no: "Hvorfor drømmer vi?",
          cy: "Зашто сањамо?",
          ee: "Miks me unistame?",
          th: "ทำไมเราถึงฝัน?",
          ar: "لماذا نحلم؟",
          gr: "Γιατί ονειρευόμαστε;",
          es: "¿Por qué soñamos?",
          it: "Perché sogniamo?",
          id: "Mengapa Kita Bermimpi?",
          si: "Zakaj sanjamo?",
          pl: "Dlaczego śnimy?",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyDoWeDream.png",
        desc: {
          en: "Discover what happens while we dream and why the sleeping mind creates such vivid experiences.",
          fr: "Découvrez ce qui se passe pendant que nous rêvons et pourquoi l'esprit endormi crée des expériences aussi vives.",
          de: "Entdecken Sie, was während des Träumens geschieht und warum der schlafende Geist so lebhafte Erlebnisse erschafft.",
          be: "Ontdek wat er gebeurt terwijl we dromen en waarom de slapende geest zulke levendige ervaringen creëert.",
          tr: "Rüya görürken neler olduğunu ve uyuyan zihnin neden bu kadar canlı deneyimler yarattığını keşfedin.",
          pt: "Descubra o que acontece enquanto sonhamos e por que a mente adormecida cria experiências tão vívidas.",
          no: "Oppdag hva som skjer mens vi drømmer, og hvorfor det sovende sinnet skaper så levende opplevelser.",
          cy: "Откријте шта се дешава док сањамо и зашто успавани ум ствара тако живописна искуства.",
          ee: "Avastage, mis toimub une ajal ja miks magav meel loob nii elavaid kogemusi.",
          th: "ค้นพบสิ่งที่เกิดขึ้นขณะที่เราฝันและทำไมจิตใจที่หลับใหลจึงสร้างประสบการณ์ที่สมจริงเช่นนี้",
          ar: "اكتشف ما يحدث بينما نحلم ولماذا يخلق العقل النائم تجارب حية إلى هذا الحد.",
          gr: "Ανακαλύψτε τι συμβαίνει όσο ονειρευόμαστε και γιατί το κοιμισμένο μυαλό δημιουργεί τόσο ζωντανές εμπειρίες.",
          es: "Descubre qué ocurre mientras soñamos y por qué la mente dormida crea experiencias tan vívidas.",
          it: "Scopri cosa accade mentre sogniamo e perché la mente addormentata crea esperienze così vivide.",
          id: "Temukan apa yang terjadi saat kita bermimpi dan mengapa pikiran yang tertidur menciptakan pengalaman yang begitu jelas.",
          si: "Odkrijte, kaj se dogaja, ko sanjamo, in zakaj speči um ustvarja tako žive izkušnje.",
          pl: "Odkryj, co dzieje się, gdy śnimy, i dlaczego śpiący umysł tworzy tak żywe doświadczenia.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyDoWeDream.mp4",
      },
      {
        duration: 21336,
        id: 307,
        name: {
          en: "The Weird History of Toothpaste",
          fr: "L'histoire étrange du dentifrice",
          de: "Die seltsame Geschichte der Zahnpasta",
          be: "De vreemde geschiedenis van tandpasta",
          tr: "Diş Macununun Tuhaf Tarihi",
          pt: "A Estranha História da Pasta de Dentes",
          no: "Tannkremens merkelige historie",
          cy: "Чудна историја пасте за зубе",
          ee: "Hambapasta kummaline ajalugu",
          th: "ประวัติศาสตร์แปลกของยาสีฟัน",
          ar: "التاريخ الغريب لمعجون الأسنان",
          gr: "Η περίεργη ιστορία της οδοντόκρεμας",
          es: "La extraña historia de la pasta de dientes",
          it: "La strana storia del dentifricio",
          id: "Sejarah Aneh Pasta Gigi",
          si: "Čudna zgodovina zobne paste",
          pl: "Dziwna historia pasty do zębów",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/TheWeirdHistoryofToothpaste.png",
        desc: {
          en: "Trace the strange and fascinating evolution of toothpaste through history.",
          fr: "Retracez l'histoire étrange et fascinante de l'évolution du dentifrice.",
          de: "Verfolgen Sie die seltsame und faszinierende Entwicklung der Zahnpasta durch die Geschichte.",
          be: "Volg de vreemde en fascinerende evolutie van tandpasta door de geschiedenis heen.",
          tr: "Diş macununun tarih boyunca geçirdiği tuhaf ve büyüleyici evrimi izleyin.",
          pt: "Acompanhe a estranha e fascinante evolução da pasta de dentes ao longo da história.",
          no: "Følg tannkremens merkelige og fascinerende utvikling gjennom historien.",
          cy: "Пратите чудну и фасцинантну еволуцију пасте за зубе кроз историју.",
          ee: "Jälgige hambapasta kummalist ja põnevat arengut läbi ajaloo.",
          th: "ติดตามวิวัฒนาการอันแปลกประหลาดและน่าทึ่งของยาสีฟันตลอดประวัติศาสตร์",
          ar: "تتبع التطور الغريب والمثير لمعجون الأسنان عبر التاريخ.",
          gr: "Ανιχνεύστε την περίεργη και συναρπαστική εξέλιξη της οδοντόκρεμας στην ιστορία.",
          es: "Sigue la extraña y fascinante evolución de la pasta de dientes a lo largo de la historia.",
          it: "Ripercorri la strana e affascinante evoluzione del dentifricio nella storia.",
          id: "Telusuri evolusi pasta gigi yang aneh dan menarik sepanjang sejarah.",
          si: "Sledite čudnemu in fascinantnemu razvoju zobne paste skozi zgodovino.",
          pl: "Prześledź dziwną i fascynującą ewolucję pasty do zębów na przestrzeni dziejów.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/TheWeirdHistoryofToothpaste.mp4",
      },
      {
        duration: 21336,
        id: 308,
        name: {
          en: "How Ants Run a Tiny Empire",
          fr: "Comment les fourmis dirigent un petit empire",
          de: "Wie Ameisen ein winziges Imperium führen",
          be: "Hoe mieren een klein rijk runnen",
          tr: "Karıncalar Küçük Bir İmparatorluğu Nasıl Yönetir",
          pt: "Como as Formigas Gerem um Pequeno Império",
          no: "Hvordan maur driver et lite imperium",
          cy: "Како мрави воде мало царство",
          ee: "Kuidas sipelgad juhivad väikest impeeriumi",
          th: "มดบริหารอาณาจักรเล็กๆ ได้อย่างไร",
          ar: "كيف تدير النمل إمبراطورية صغيرة",
          gr: "Πώς τα μυρμήγκια διοικούν μια μικρή αυτοκρατορία",
          es: "Cómo las hormigas dirigen un pequeño imperio",
          it: "Come le formiche gestiscono un piccolo impero",
          id: "Bagaimana Semut Menjalankan Kerajaan Kecil",
          si: "Kako mravlje vodijo majhno cesarstvo",
          pl: "Jak mrówki zarządzają małym imperium",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/HowAntsRunaTinyEmpire.png",
        desc: {
          en: "Step inside the organised world of ants and discover how their tiny colonies function.",
          fr: "Plongez dans le monde organisé des fourmis et découvrez comment fonctionnent leurs minuscules colonies.",
          de: "Tauchen Sie ein in die organisierte Welt der Ameisen und entdecken Sie, wie ihre winzigen Kolonien funktionieren.",
          be: "Stap in de georganiseerde wereld van mieren en ontdek hoe hun kleine kolonies functioneren.",
          tr: "Karıncaların düzenli dünyasına adım atın ve minik kolonilerinin nasıl işlediğini keşfedin.",
          pt: "Entre no mundo organizado das formigas e descubra como as suas pequenas colónias funcionam.",
          no: "Tre inn i maurenes organiserte verden og oppdag hvordan deres små kolonier fungerer.",
          cy: "Уђите у организовани свет мрава и откријте како функционишу њихове мале колоније.",
          ee: "Astuge sipelgate korrastatud maailma ja avastage, kuidas nende väikesed kolooniad toimivad.",
          th: "ก้าวเข้าสู่โลกอันเป็นระเบียบของมดและค้นพบว่าอาณาจักรเล็กๆ ของพวกมันทำงานอย่างไร",
          ar: "ادخل إلى عالم النمل المنظم واكتشف كيف تعمل مستعمراتها الصغيرة.",
          gr: "Μπείτε στον οργανωμένο κόσμο των μυρμηγκιών και ανακαλύψτε πώς λειτουργούν οι μικροσκοπικές αποικίες τους.",
          es: "Adéntrate en el mundo organizado de las hormigas y descubre cómo funcionan sus diminutas colonias.",
          it: "Entra nel mondo organizzato delle formiche e scopri come funzionano le loro minuscole colonie.",
          id: "Masuki dunia semut yang terorganisir dan temukan bagaimana koloni kecil mereka berfungsi.",
          si: "Vstopite v organizirani svet mravelj in odkrijte, kako delujejo njihove majhne kolonije.",
          pl: "Wejdź do zorganizowanego świata mrówek i odkryj, jak funkcjonują ich maleńkie kolonie.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/HowAntsRunaTinyEmpire.mp4",
      },
      {
        duration: 21336,
        id: 309,
        name: {
          en: "Why Popcorn Pops",
          fr: "Pourquoi le pop-corn éclate",
          de: "Warum Popcorn knallt",
          be: "Waarom popcorn knalt",
          tr: "Patlamış Mısır Neden Patlar",
          pt: "Por que a Pipoca Estoura",
          no: "Hvorfor popcorn popper",
          cy: "Зашто кокице пуцају",
          ee: "Miks popkorn pauguga avaneb",
          th: "ทำไมป๊อปคอร์นถึงแตก",
          ar: "لماذا ينفجر الفشار",
          gr: "Γιατί σκάει το ποπ κορν",
          es: "Por qué revientan las palomitas",
          it: "Perché scoppiano i popcorn",
          id: "Mengapa Popcorn Meletus",
          si: "Zakaj pokovka poka",
          pl: "Dlaczego popcorn strzela",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyPopcornPops.png",
        desc: {
          en: "Discover the simple science that turns a hard corn kernel into fluffy popcorn.",
          fr: "Découvrez la science simple qui transforme un grain de maïs dur en pop-corn moelleux.",
          de: "Entdecken Sie die einfache Wissenschaft, die aus einem harten Maiskorn flauschiges Popcorn macht.",
          be: "Ontdek de eenvoudige wetenschap die een harde maïskorrel verandert in luchtige popcorn.",
          tr: "Sert bir mısır tanesini kabarık patlamış mısıra dönüştüren basit bilimi keşfedin.",
          pt: "Descubra a ciência simples que transforma um grão de milho duro em pipoca fofa.",
          no: "Oppdag den enkle vitenskapen som gjør et hardt maiskorn om til luftig popcorn.",
          cy: "Откријте једноставну науку која тврдо зрно кукуруза претвара у пахуљасти кокице.",
          ee: "Avastage lihtne teadus, mis muudab kõva maisitera õhuliseks popkorniks.",
          th: "ค้นพบวิทยาศาสตร์ง่ายๆ ที่เปลี่ยนเมล็ดข้าวโพดแข็งให้กลายเป็นป๊อปคอร์นฟู",
          ar: "اكتشف العلم البسيط الذي يحوّل حبة ذرة صلبة إلى فشار هش.",
          gr: "Ανακαλύψτε την απλή επιστήμη που μετατρέπει έναν σκληρό κόκκο καλαμποκιού σε αφράτο ποπ κορν.",
          es: "Descubre la sencilla ciencia que convierte un duro grano de maíz en esponjosas palomitas.",
          it: "Scopri la semplice scienza che trasforma un duro chicco di mais in soffici popcorn.",
          id: "Temukan ilmu sederhana yang mengubah biji jagung keras menjadi popcorn yang mengembang.",
          si: "Odkrijte preprosto znanost, ki trdo koruzno zrno spremeni v puhasto pokovko.",
          pl: "Poznaj prostą naukę, dzięki której twarde ziarno kukurydzy zamienia się w puszysty popcorn.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/WhyPopcornPops.mp4",
      },
      {
        duration: 21336,
        id: 310,
        name: {
          en: "The Mystery of the Bermuda Triangle",
          fr: "Le mystère du triangle des Bermudes",
          de: "Das Geheimnis des Bermudadreiecks",
          be: "Het mysterie van de Bermudadriehoek",
          tr: "Bermuda Şeytan Üçgeni'nin Gizemi",
          pt: "O Mistério do Triângulo das Bermudas",
          no: "Mysteriet om Bermudatriangelet",
          cy: "Мистерија Бермудског троугла",
          ee: "Bermuda kolmnurga mõistatus",
          th: "ปริศนาสามเหลี่ยมเบอร์มิวดา",
          ar: "لغز مثلث برمودا",
          gr: "Το μυστήριο του Τριγώνου των Βερμούδων",
          es: "El misterio del Triángulo de las Bermudas",
          it: "Il mistero del Triangolo delle Bermuda",
          id: "Misteri Segitiga Bermuda",
          si: "Skrivnost Bermudskega trikotnika",
          pl: "Tajemnica Trójkąta Bermudzkiego",
        },
        preview:
          "https://cdn.mobio360.com/new+videos/Documentary/TheMysteryoftheBermudaTriangle.png",
        desc: {
          en: "Explore the stories, theories, and enduring mystery surrounding the Bermuda Triangle.",
          fr: "Explorez les histoires, théories et le mystère persistant entourant le triangle des Bermudes.",
          de: "Erkunden Sie die Geschichten, Theorien und das anhaltende Rätsel rund um das Bermudadreieck.",
          be: "Verken de verhalen, theorieën en het aanhoudende mysterie rond de Bermudadriehoek.",
          tr: "Bermuda Şeytan Üçgeni'ni çevreleyen hikayeleri, teorileri ve süregelen gizemi keşfedin.",
          pt: "Explore as histórias, teorias e o mistério persistente que envolve o Triângulo das Bermudas.",
          no: "Utforsk historiene, teoriene og det vedvarende mysteriet rundt Bermudatriangelet.",
          cy: "Истражите приче, теорије и трајну мистерију која окружује Бермудски троугао.",
          ee: "Uurige Bermuda kolmnurka ümbritsevaid lugusid, teooriaid ja püsivat mõistatust.",
          th: "สำรวจเรื่องราว ทฤษฎี และปริศนาที่ยังคงอยู่รอบสามเหลี่ยมเบอร์มิวดา",
          ar: "استكشف القصص والنظريات واللغز المستمر المحيط بمثلث برمودا.",
          gr: "Εξερευνήστε τις ιστορίες, τις θεωρίες και το διαρκές μυστήριο γύρω από το Τρίγωνο των Βερμούδων.",
          es: "Explora las historias, teorías y el persistente misterio que rodea al Triángulo de las Bermudas.",
          it: "Esplora le storie, le teorie e il persistente mistero che circonda il Triangolo delle Bermuda.",
          id: "Jelajahi kisah, teori, dan misteri abadi seputar Segitiga Bermuda.",
          si: "Raziščite zgodbe, teorije in vztrajno skrivnost okoli Bermudskega trikotnika.",
          pl: "Poznaj historie, teorie i trwałą zagadkę otaczającą Trójkąt Bermudzki.",
        },
        videoUrl:
          "https://cdn.mobio360.com/new+videos/Documentary/TheMysteryoftheBermudaTriangle.mp4",
      },
    ],
  },
  {
    id: 4,
    contents: 10,
    categoryName: {
      en: "Meditation",
      fr: "Méditation",
      de: "Meditation",
      be: "Meditatie",
      tr: "Meditasyon",
      pt: "Meditação",
      no: "Meditasjon",
      cy: "Медитација",
      ee: "Meditatsioon",
      th: "การทำสมาธิ",
      ar: "تأمل",
      gr: "Διαλογισμός",
      es: "Meditación",
      it: "Meditazione",
      id: "Meditasi",
      si: "Meditacija",
      pl: "Medytacja",
    },
    videos: [
      {
        duration: 279,
        id: 401,
        name: {
          en: "Abundance in Nature",
          fr: "Abondance dans la nature",
          de: "Fülle in der Natur",
          be: "Overvloed in de natuur",
          tr: "Doğada Bolluk",
          pt: "Abundância na Natureza",
          no: "Overflod i naturen",
          cy: "Изобиље у природи",
          ee: "Külluslikkus looduses",
          th: "ความอุดมสมบูรณ์ในธรรมชาติ",
          ar: "الوفرة في الطبيعة",
          gr: "Αφθονία στη Φύση",
          es: "Abundancia en la Naturaleza",
          it: "Abbondanza nella Natura",
          id: "Kelimpahan dalam Alam",
          si: "Obilje v naravi",
          pl: "Obfitość w naturze",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AbundanceinNature.png",
        desc: {
          en: "Reflect on nature’s abundance and develop a deeper sense of gratitude and possibility.",
          fr: "Réfléchissez à l'abondance de la nature et développez un sens plus profond de la gratitude et des possibilités.",
          de: "Denken Sie über die Fülle der Natur nach und entwickeln Sie ein tieferes Gefühl von Dankbarkeit und Möglichkeit.",
          be: "Denk na over de overvloed van de natuur en ontwikkel een dieper gevoel van dankbaarheid en mogelijkheid.",
          tr: "Doğanın bolluğu üzerine düşünün ve daha derin bir minnettarlık ve olasılık duygusu geliştirin.",
          pt: "Reflita sobre a abundância da natureza e desenvolva um sentido mais profundo de gratidão e possibilidade.",
          no: "Reflekter over naturens overflod og utvikle en dypere følelse av takknemlighet og mulighet.",
          cy: "Размислите о изобиљу природе и развијте дубљи осећај захвалности и могућности.",
          ee: "Mõtisklege looduse rikkalikkuse üle ja arendage sügavamat tänulikkuse ja võimaluste tunnetust.",
          th: "ใคร่ครวญถึงความอุดมสมบูรณ์ของธรรมชาติและพัฒนาความรู้สึกขอบคุณและความเป็นไปได้ที่ลึกซึ้งยิ่งขึ้น",
          ar: "تأمل في وفرة الطبيعة ونمِّ إحساسًا أعمق بالامتنان والإمكانية.",
          gr: "Στοχαστείτε πάνω στην αφθονία της φύσης και καλλιεργήστε μια βαθύτερη αίσθηση ευγνωμοσύνης και δυνατοτήτων.",
          es: "Reflexiona sobre la abundancia de la naturaleza y desarrolla un sentido más profundo de gratitud y posibilidad.",
          it: "Rifletti sull'abbondanza della natura e sviluppa un senso più profondo di gratitudine e possibilità.",
          id: "Renungkan kelimpahan alam dan kembangkan rasa syukur serta kemungkinan yang lebih dalam.",
          si: "Razmislite o obilju narave in razvijte globlji občutek hvaležnosti in možnosti.",
          pl: "Zastanów się nad obfitością natury i rozwiń głębsze poczucie wdzięczności oraz możliwości.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AbundanceInNature.mp4",
      },
      {
        duration: 279,
        id: 402,
        name: {
          en: "Invite Nature Into Your Life",
          fr: "Invitez la nature dans votre vie",
          de: "Laden Sie die Natur in Ihr Leben ein",
          be: "Nodig de natuur uit in je leven",
          tr: "Doğayı Hayatınıza Davet Edin",
          pt: "Convide a Natureza para a Sua Vida",
          no: "Inviter naturen inn i livet ditt",
          cy: "Позовите природу у свој живот",
          ee: "Kutsuge loodus oma ellu",
          th: "เชิญธรรมชาติเข้าสู่ชีวิตของคุณ",
          ar: "ادعُ الطبيعة إلى حياتك",
          gr: "Καλέστε τη Φύση στη Ζωή σας",
          es: "Invita a la Naturaleza a Tu Vida",
          it: "Invita la Natura nella Tua Vita",
          id: "Undang Alam ke dalam Hidup Anda",
          si: "Povabite naravo v svoje življenje",
          pl: "Zaproś naturę do swojego życia",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/InviteNatureIntoYourLife.png",
        desc: {
          en: "Open yourself to the calming presence of nature and welcome it into everyday life.",
          fr: "Ouvrez-vous à la présence apaisante de la nature et accueillez-la dans votre vie quotidienne.",
          de: "Öffnen Sie sich der beruhigenden Präsenz der Natur und heißen Sie sie im Alltag willkommen.",
          be: "Stel jezelf open voor de kalmerende aanwezigheid van de natuur en verwelkom haar in het dagelijks leven.",
          tr: "Doğanın huzur veren varlığına açılın ve onu günlük yaşamınıza davet edin.",
          pt: "Abra-se à presença calmante da natureza e acolha-a no seu dia a dia.",
          no: "Åpne deg for naturens beroligende nærvær og ønsk den velkommen inn i hverdagen.",
          cy: "Отворите се смирујућем присуству природе и дочекајте га у свакодневном животу.",
          ee: "Avage end looduse rahustava kohaloleku ees ja tervitage seda igapäevaelus.",
          th: "เปิดใจรับการประทับอยู่อันสงบของธรรมชาติและต้อนรับมันเข้าสู่ชีวิตประจำวัน",
          ar: "افتح نفسك لحضور الطبيعة المهدئ ورحّب به في حياتك اليومية.",
          gr: "Ανοιχτείτε στην ηρεμιστική παρουσία της φύσης και καλωσορίστε την στην καθημερινή ζωή.",
          es: "Ábrete a la presencia calmante de la naturaleza y dale la bienvenida a tu vida cotidiana.",
          it: "Apriti alla presenza rassicurante della natura e accoglila nella vita di tutti i giorni.",
          id: "Bukalah dirimu pada kehadiran alam yang menenangkan dan sambut ia dalam kehidupan sehari-hari.",
          si: "Odprite se pomirjujoči prisotnosti narave in jo povabite v vsakdanje življenje.",
          pl: "Otwórz się na kojącą obecność natury i przywitaj ją w codziennym życiu.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/InviteNatureIntoYourLife.mp4",
      },
      {
        duration: 279,
        id: 403,
        name: {
          en: "Being in the Moment",
          fr: "Être présent à l'instant",
          de: "Im Moment sein",
          be: "In het moment zijn",
          tr: "Anda Olmak",
          pt: "Estar no Momento",
          no: "Å være til stede i øyeblikket",
          cy: "Бити у тренутку",
          ee: "Olemine hetkes",
          th: "การอยู่กับปัจจุบัน",
          ar: "العيش في اللحظة الحاضرة",
          gr: "Να Είσαι στη Στιγμή",
          es: "Estar en el Momento",
          it: "Essere nel Momento",
          id: "Hadir di Saat Ini",
          si: "Biti v trenutku",
          pl: "Bycie w chwili obecnej",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/BeingintheMoment.png",
        desc: {
          en: "Slow down, release distractions, and bring your attention fully into the present moment.",
          fr: "Ralentissez, libérez-vous des distractions et portez pleinement votre attention sur le moment présent.",
          de: "Verlangsamen Sie, lösen Sie sich von Ablenkungen und richten Sie Ihre Aufmerksamkeit ganz auf den gegenwärtigen Moment.",
          be: "Vertraag, laat afleidingen los en breng je aandacht volledig naar het huidige moment.",
          tr: "Yavaşlayın, dikkat dağıtıcı unsurlardan kurtulun ve dikkatinizi tamamen şimdiki ana verin.",
          pt: "Abrande, liberte-se das distrações e traga a sua atenção totalmente para o momento presente.",
          no: "Senk tempoet, slipp distraksjoner og rett oppmerksomheten fullt og helt mot øyeblikket.",
          cy: "Успорите, ослободите се ометања и потпуно усмерите пажњу на садашњи тренутак.",
          ee: "Aeglustage, vabanege segavatest teguritest ja suunake tähelepanu täielikult käesolevale hetkele.",
          th: "ชะลอลง ปล่อยวางสิ่งรบกวน และนำความสนใจของคุณมาอยู่ที่ปัจจุบันขณะอย่างเต็มที่",
          ar: "تمهّل، تخلَّ عن المشتتات، ووجّه انتباهك بالكامل نحو اللحظة الحاضرة.",
          gr: "Επιβραδύνετε, απελευθερωθείτε από τους περισπασμούς και φέρτε την προσοχή σας πλήρως στην παρούσα στιγμή.",
          es: "Reduce el ritmo, libérate de las distracciones y lleva tu atención plenamente al momento presente.",
          it: "Rallenta, liberati dalle distrazioni e porta la tua attenzione pienamente nel momento presente.",
          id: "Perlambat, lepaskan gangguan, dan bawa perhatianmu sepenuhnya ke momen saat ini.",
          si: "Upočasnite se, sprostite motnje in svojo pozornost v celoti usmerite v sedanji trenutek.",
          pl: "Zwolnij, uwolnij się od rozpraszaczy i skieruj uwagę w pełni na chwilę obecną.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/BeingInTheMoment.mp4",
      },
      {
        duration: 279,
        id: 404,
        name: {
          en: "Cultivate Presence and Awareness",
          fr: "Cultiver la présence et la conscience",
          de: "Präsenz und Bewusstsein kultivieren",
          be: "Aanwezigheid en bewustzijn cultiveren",
          tr: "Farkındalık ve Bilinç Geliştirmek",
          pt: "Cultivar a Presença e a Consciência",
          no: "Dyrk tilstedeværelse og bevissthet",
          cy: "Неговање присутности и свесности",
          ee: "Kohaloleku ja teadlikkuse arendamine",
          th: "การปลูกฝังการมีสติและความตระหนักรู้",
          ar: "تنمية الحضور والوعي",
          gr: "Καλλιεργήστε την Παρουσία και την Επίγνωση",
          es: "Cultivar la Presencia y la Conciencia",
          it: "Coltivare Presenza e Consapevolezza",
          id: "Menumbuhkan Kehadiran dan Kesadaran",
          si: "Gojenje prisotnosti in zavedanja",
          pl: "Rozwijanie obecności i świadomości",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/CultivatePresenceandAwareness.png",
        desc: {
          en: "Strengthen your awareness and learn to meet each moment with calm, focused attention.",
          fr: "Renforcez votre conscience et apprenez à accueillir chaque instant avec une attention calme et concentrée.",
          de: "Stärken Sie Ihr Bewusstsein und lernen Sie, jedem Moment mit ruhiger, fokussierter Aufmerksamkeit zu begegnen.",
          be: "Versterk je bewustzijn en leer elk moment tegemoet te treden met kalme, gerichte aandacht.",
          tr: "Farkındalığınızı güçlendirin ve her anı sakin, odaklanmış bir dikkatle karşılamayı öğrenin.",
          pt: "Fortaleça a sua consciência e aprenda a receber cada momento com atenção calma e focada.",
          no: "Styrk bevisstheten din og lær å møte hvert øyeblikk med rolig, fokusert oppmerksomhet.",
          cy: "Ојачајте своју свесност и научите да сваки тренутак дочекате смиреном, усредсређеном пажњом.",
          ee: "Tugevdage oma teadlikkust ja õppige kohtama iga hetke rahuliku, keskendunud tähelepanuga.",
          th: "เสริมสร้างการตระหนักรู้ของคุณและเรียนรู้ที่จะต้อนรับแต่ละช่วงเวลาด้วยความใส่ใจที่สงบและมุ่งมั่น",
          ar: "عزز وعيك وتعلّم استقبال كل لحظة باهتمام هادئ ومركّز.",
          gr: "Ενισχύστε την επίγνωσή σας και μάθετε να υποδέχεστε κάθε στιγμή με ήρεμη, εστιασμένη προσοχή.",
          es: "Fortalece tu conciencia y aprende a recibir cada momento con atención calmada y enfocada.",
          it: "Rafforza la tua consapevolezza e impara ad accogliere ogni momento con un'attenzione calma e concentrata.",
          id: "Perkuat kesadaranmu dan belajarlah menyambut setiap momen dengan perhatian yang tenang dan fokus.",
          si: "Okrepite svoje zavedanje in se naučite vsak trenutek sprejeti z mirno, osredotočeno pozornostjo.",
          pl: "Wzmocnij swoją świadomość i naucz się witać każdą chwilę spokojną, skupioną uwagą.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/CultivatePresenceAndAwareness.mp4",
      },
      {
        duration: 279,
        id: 405,
        name: {
          en: "Opening Our Hearts to the Natural World",
          fr: "Ouvrir nos cœurs au monde naturel",
          de: "Unsere Herzen der Natur öffnen",
          be: "Ons hart openen voor de natuurlijke wereld",
          tr: "Kalplerimizi Doğal Dünyaya Açmak",
          pt: "Abrir os Nossos Corações ao Mundo Natural",
          no: "Åpne hjertene våre for naturen",
          cy: "Отварање наших срца природном свету",
          ee: "Südame avamine loodusmaailmale",
          th: "เปิดใจสู่โลกธรรมชาติ",
          ar: "فتح قلوبنا للعالم الطبيعي",
          gr: "Ανοίγοντας τις Καρδιές μας στον Φυσικό Κόσμο",
          es: "Abrir Nuestros Corazones al Mundo Natural",
          it: "Aprire i Nostri Cuori al Mondo Naturale",
          id: "Membuka Hati Kita pada Dunia Alam",
          si: "Odpiranje src naravnemu svetu",
          pl: "Otwieranie serc na naturalny świat",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/OpeningOurHeartstotheNaturalWorld.png",
        desc: {
          en: "Cultivate compassion and deepen your emotional connection with the natural world.",
          fr: "Cultivez la compassion et approfondissez votre connexion émotionnelle avec le monde naturel.",
          de: "Kultivieren Sie Mitgefühl und vertiefen Sie Ihre emotionale Verbindung zur natürlichen Welt.",
          be: "Cultiveer mededogen en verdiep je emotionele band met de natuurlijke wereld.",
          tr: "Şefkati geliştirin ve doğal dünyayla duygusal bağınızı derinleştirin.",
          pt: "Cultive a compaixão e aprofunde a sua ligação emocional com o mundo natural.",
          no: "Dyrk medfølelse og fordyp den følelsesmessige forbindelsen din med naturen.",
          cy: "Неговајте саосећање и продубите своју емоционалну везу са природним светом.",
          ee: "Arendage kaastunnet ja süvendage oma emotsionaalset sidet loodusmaailmaga.",
          th: "ปลูกฝังความเมตตาและกระชับความผูกพันทางอารมณ์กับโลกธรรมชาติให้ลึกซึ้งยิ่งขึ้น",
          ar: "نمِّ التعاطف وعمّق ارتباطك العاطفي بالعالم الطبيعي.",
          gr: "Καλλιεργήστε τη συμπόνια και εμβαθύνετε τη συναισθηματική σας σύνδεση με τον φυσικό κόσμο.",
          es: "Cultiva la compasión y profundiza tu conexión emocional con el mundo natural.",
          it: "Coltiva la compassione e approfondisci il tuo legame emotivo con il mondo naturale.",
          id: "Tumbuhkan welas asih dan perdalam hubungan emosionalmu dengan dunia alam.",
          si: "Gojite sočutje in poglobite svojo čustveno povezanost z naravnim svetom.",
          pl: "Rozwijaj współczucie i pogłęb swoją emocjonalną więź ze światem natury.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/OpeningOurHeartstotheNaturalWorld.mp4",
      },
      {
        duration: 279,
        id: 406,
        name: {
          en: "Connect with Your Senses",
          fr: "Se connecter à ses sens",
          de: "Verbindung mit Ihren Sinnen",
          be: "Verbinding maken met je zintuigen",
          tr: "Duyularınızla Bağlantı Kurun",
          pt: "Conecte-se com os Seus Sentidos",
          no: "Kom i kontakt med sansene dine",
          cy: "Повежите се са својим чулима",
          ee: "Looge ühendus oma meeltega",
          th: "เชื่อมโยงกับประสาทสัมผัสของคุณ",
          ar: "تواصل مع حواسك",
          gr: "Συνδεθείτε με τις Αισθήσεις σας",
          es: "Conecta con Tus Sentidos",
          it: "Connettiti con i Tuoi Sensi",
          id: "Terhubung dengan Indra Anda",
          si: "Poveži se s svojimi čutili",
          pl: "Połącz się ze swoimi zmysłami",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/ConnectwithYourSenses.png",
        desc: {
          en: "Awaken your senses and reconnect with the sights, sounds, and sensations around you.",
          fr: "Éveillez vos sens et reconnectez-vous aux images, aux sons et aux sensations qui vous entourent.",
          de: "Erwecken Sie Ihre Sinne und verbinden Sie sich neu mit den Bildern, Klängen und Empfindungen um Sie herum.",
          be: "Wek je zintuigen en herverbind je met de beelden, geluiden en gewaarwordingen om je heen.",
          tr: "Duyularınızı uyandırın ve çevrenizdeki görüntüler, sesler ve hislerle yeniden bağlantı kurun.",
          pt: "Desperte os seus sentidos e reconecte-se com as imagens, sons e sensações à sua volta.",
          no: "Vekk sansene dine og gjenopprett kontakten med synsinntrykk, lyder og fornemmelser rundt deg.",
          cy: "Пробудите своја чула и поново се повежите са призорима, звуковима и осећајима око себе.",
          ee: "Äratage oma meeled ja looge taas ühendus enda ümber olevate vaatepiltide, helide ja aistingutega.",
          th: "ปลุกประสาทสัมผัสของคุณและเชื่อมโยงกับภาพ เสียง และความรู้สึกรอบตัวคุณอีกครั้ง",
          ar: "أيقظ حواسك وأعد الاتصال بالمشاهد والأصوات والأحاسيس من حولك.",
          gr: "Ξυπνήστε τις αισθήσεις σας και επανασυνδεθείτε με τις εικόνες, τους ήχους και τις αισθήσεις γύρω σας.",
          es: "Despierta tus sentidos y reconéctate con las imágenes, sonidos y sensaciones que te rodean.",
          it: "Risveglia i tuoi sensi e riconnettiti con le immagini, i suoni e le sensazioni che ti circondano.",
          id: "Bangkitkan inderamu dan terhubung kembali dengan pemandangan, suara, dan sensasi di sekitarmu.",
          si: "Prebudite svoja čutila in se ponovno povežite s podobami, zvoki in občutki okoli sebe.",
          pl: "Obudź swoje zmysły i na nowo połącz się z widokami, dźwiękami i doznaniami wokół siebie.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/ConnectwithYourSenses.mp4",
      },
      {
        duration: 279,
        id: 407,
        name: {
          en: "Savor the Day",
          fr: "Savourer la journée",
          de: "Den Tag genießen",
          be: "Geniet van de dag",
          tr: "Günün Tadını Çıkarın",
          pt: "Saboreie o Dia",
          no: "Nyt dagen",
          cy: "Уживајте у дану",
          ee: "Nautige päeva",
          th: "ลิ้มรสวันเวลา",
          ar: "استمتع باليوم",
          gr: "Απολαύστε τη Μέρα",
          es: "Saborea el Día",
          it: "Assapora la Giornata",
          id: "Nikmati Hari Ini",
          si: "Uživajte v dnevu",
          pl: "Delektuj się dniem",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/SavortheDay.png",
        desc: {
          en: "Pause, appreciate the present, and learn to enjoy the small moments of your day.",
          fr: "Faites une pause, appréciez le présent et apprenez à savourer les petits moments de votre journée.",
          de: "Halten Sie inne, schätzen Sie die Gegenwart und lernen Sie, die kleinen Momente Ihres Tages zu genießen.",
          be: "Pauzeer, waardeer het heden en leer genieten van de kleine momenten van je dag.",
          tr: "Durun, şimdiki anı takdir edin ve gününüzün küçük anlarının tadını çıkarmayı öğrenin.",
          pt: "Faça uma pausa, aprecie o presente e aprenda a desfrutar dos pequenos momentos do seu dia.",
          no: "Ta en pause, sett pris på nåtiden og lær å nyte de små øyeblikkene i dagen din.",
          cy: "Застаните, ценили садашњост и научите да уживате у малим тренуцима свог дана.",
          ee: "Peatuge, hinnake olevikku ja õppige nautima oma päeva väikseid hetki.",
          th: "หยุดพัก ชื่นชมปัจจุบัน และเรียนรู้ที่จะเพลิดเพลินกับช่วงเวลาเล็กๆ ในแต่ละวันของคุณ",
          ar: "توقف قليلاً، قدّر الحاضر، وتعلّم الاستمتاع باللحظات الصغيرة من يومك.",
          gr: "Σταματήστε, εκτιμήστε το παρόν και μάθετε να απολαμβάνετε τις μικρές στιγμές της ημέρας σας.",
          es: "Haz una pausa, aprecia el presente y aprende a disfrutar los pequeños momentos de tu día.",
          it: "Fermati, apprezza il presente e impara a goderti i piccoli momenti della tua giornata.",
          id: "Berhentilah sejenak, hargai masa kini, dan pelajari cara menikmati momen-momen kecil dalam harimu.",
          si: "Ustavite se, cenite sedanjost in se naučite uživati v majhnih trenutkih svojega dneva.",
          pl: "Zatrzymaj się, doceń teraźniejszość i naucz się cieszyć małymi chwilami swojego dnia.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/SavortheDay.mp4",
      },
      {
        duration: 279,
        id: 408,
        name: {
          en: "Mindfulness Practice that Connects Kids to Nature",
          fr: "Pratique de pleine conscience pour connecter les enfants à la nature",
          de: "Achtsamkeitsübung, die Kinder mit der Natur verbindet",
          be: "Mindfulness-oefening die kinderen verbindt met de natuur",
          tr: "Çocukları Doğayla Buluşturan Farkındalık Uygulaması",
          pt: "Prática de Mindfulness que Liga as Crianças à Natureza",
          no: "Mindfulness-praksis som knytter barn til naturen",
          cy: "Пракса свесности која повезује децу са природом",
          ee: "Teadveloleku praktika, mis ühendab lapsi loodusega",
          th: "การฝึกสติที่เชื่อมโยงเด็กๆ กับธรรมชาติ",
          ar: "ممارسة اليقظة الذهنية التي تربط الأطفال بالطبيعة",
          gr: "Πρακτική Ενσυνειδητότητας που Συνδέει τα Παιδιά με τη Φύση",
          es: "Práctica de Atención Plena que Conecta a los Niños con la Naturaleza",
          it: "Pratica di Mindfulness che Collega i Bambini alla Natura",
          id: "Praktik Kesadaran Penuh yang Menghubungkan Anak-anak dengan Alam",
          si: "Vaja čuječnosti, ki otroke povezuje z naravo",
          pl: "Praktyka uważności łącząca dzieci z naturą",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/MindfulnessPracticethatConnectsKidstoNature.png",
        desc: {
          en: "Guide children through a gentle mindfulness practice that builds curiosity and connection with nature.",
          fr: "Guidez les enfants à travers une douce pratique de pleine conscience qui cultive la curiosité et le lien avec la nature.",
          de: "Führen Sie Kinder durch eine sanfte Achtsamkeitsübung, die Neugier und Verbindung zur Natur aufbaut.",
          be: "Begeleid kinderen door een zachte mindfulness-oefening die nieuwsgierigheid en verbondenheid met de natuur opbouwt.",
          tr: "Çocuklara, merak ve doğayla bağ kurmayı geliştiren nazik bir farkındalık uygulaması boyunca rehberlik edin.",
          pt: "Guie as crianças através de uma suave prática de mindfulness que constrói curiosidade e ligação com a natureza.",
          no: "Veiled barn gjennom en mild mindfulness-øvelse som bygger nysgjerrighet og tilknytning til naturen.",
          cy: "Водите децу кроз благу вежбу свесности која гради радозналост и повезаност са природом.",
          ee: "Juhatage lapsi läbi õrna teadveloleku praktika, mis kasvatab uudishimu ja sidet loodusega.",
          th: "นำเด็กๆ ผ่านการฝึกสติอย่างอ่อนโยนที่สร้างความอยากรู้อยากเห็นและความผูกพันกับธรรมชาติ",
          ar: "أرشد الأطفال عبر ممارسة يقظة ذهنية لطيفة تبني الفضول والارتباط بالطبيعة.",
          gr: "Καθοδηγήστε τα παιδιά μέσα από μια ήπια πρακτική ενσυνειδητότητας που καλλιεργεί περιέργεια και σύνδεση με τη φύση.",
          es: "Guía a los niños a través de una suave práctica de atención plena que cultiva la curiosidad y la conexión con la naturaleza.",
          it: "Guida i bambini attraverso una delicata pratica di mindfulness che coltiva curiosità e connessione con la natura.",
          id: "Bimbing anak-anak melalui praktik kesadaran penuh yang lembut yang membangun rasa ingin tahu dan hubungan dengan alam.",
          si: "Vodite otroke skozi nežno vajo čuječnosti, ki gradi radovednost in povezanost z naravo.",
          pl: "Poprowadź dzieci przez łagodną praktykę uważności, która buduje ciekawość i więź z naturą.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/MindfulnessPracticethatConnectsKidstoNature.mp4",
      },
      {
        duration: 279,
        id: 409,
        name: {
          en: "A Meditation for Deep Relaxation",
          fr: "Une méditation pour une relaxation profonde",
          de: "Eine Meditation für tiefe Entspannung",
          be: "Een meditatie voor diepe ontspanning",
          tr: "Derin Rahatlama için Bir Meditasyon",
          pt: "Uma Meditação para Relaxamento Profundo",
          no: "En meditasjon for dyp avslapning",
          cy: "Медитација за дубоку релаксацију",
          ee: "Meditatsioon sügavaks lõõgastumiseks",
          th: "การทำสมาธิเพื่อการผ่อนคลายอย่างล้ำลึก",
          ar: "تأمل للاسترخاء العميق",
          gr: "Ένας Διαλογισμός για Βαθιά Χαλάρωση",
          es: "Una Meditación para la Relajación Profunda",
          it: "Una Meditazione per un Rilassamento Profondo",
          id: "Meditasi untuk Relaksasi Mendalam",
          si: "Meditacija za globoko sprostitev",
          pl: "Medytacja na głęboki relaks",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AMeditationforDeepRelaxation.png",
        desc: {
          en: "Release tension, quiet the mind, and settle into a state of deep relaxation.",
          fr: "Libérez les tensions, apaisez l'esprit et installez-vous dans un état de relaxation profonde.",
          de: "Lösen Sie Spannungen, beruhigen Sie den Geist und lassen Sie sich in einen Zustand tiefer Entspannung sinken.",
          be: "Laat spanning los, kalmeer de geest en zak weg in een staat van diepe ontspanning.",
          tr: "Gerginliği bırakın, zihni sakinleştirin ve derin bir rahatlama haline geçin.",
          pt: "Liberte a tensão, acalme a mente e instale-se num estado de relaxamento profundo.",
          no: "Slipp spenninger, roe sinnet og gli inn i en tilstand av dyp avslapning.",
          cy: "Ослободите напетост, смирите ум и уроните у стање дубоке опуштености.",
          ee: "Vabastage pinged, rahustage meelt ja laske end sügavasse lõõgastusseisundisse.",
          th: "ปลดปล่อยความตึงเครียด ทำให้จิตใจสงบ และเข้าสู่สภาวะผ่อนคลายอย่างล้ำลึก",
          ar: "تخلَّ عن التوتر، هدّئ العقل، واستقر في حالة من الاسترخاء العميق.",
          gr: "Απελευθερώστε την ένταση, ηρεμήστε το μυαλό και εγκατασταθείτε σε μια κατάσταση βαθιάς χαλάρωσης.",
          es: "Libera la tensión, calma la mente y instálate en un estado de relajación profunda.",
          it: "Libera la tensione, calma la mente e lasciati andare in uno stato di profondo rilassamento.",
          id: "Lepaskan ketegangan, tenangkan pikiran, dan masuklah ke dalam keadaan relaksasi yang mendalam.",
          si: "Sprostite napetost, umirite um in se prepustite stanju globoke sprostitve.",
          pl: "Uwolnij napięcie, uspokój umysł i zanurz się w stanie głębokiego relaksu.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AMeditationforDeepRelaxation.mp4",
      },
      {
        duration: 279,
        id: 410,
        name: {
          en: "A Meditation to Reconnect with Yourself",
          fr: "Une méditation pour se reconnecter à soi-même",
          de: "Eine Meditation, um sich wieder mit sich selbst zu verbinden",
          be: "Een meditatie om weer verbinding te maken met jezelf",
          tr: "Kendinizle Yeniden Bağlantı Kurmak için Bir Meditasyon",
          pt: "Uma Meditação para se Reconectar Consigo Mesmo",
          no: "En meditasjon for å komme i kontakt med deg selv igjen",
          cy: "Медитација за поновно повезивање са собом",
          ee: "Meditatsioon, et taasühineda iseendaga",
          th: "การทำสมาธิเพื่อเชื่อมโยงกับตัวเองอีกครั้ง",
          ar: "تأمل لإعادة التواصل مع نفسك",
          gr: "Ένας Διαλογισμός για Επανασύνδεση με τον Εαυτό σας",
          es: "Una Meditación para Reconectar Contigo Mismo",
          it: "Una Meditazione per Riconnettersi con Se Stessi",
          id: "Meditasi untuk Terhubung Kembali dengan Diri Sendiri",
          si: "Meditacija za ponovno povezavo s seboj",
          pl: "Medytacja, by na nowo połączyć się ze sobą",
        },
        preview: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AMeditationtoReconnectwithYourself.png",
        desc: {
          en: "Turn inward, restore your sense of balance, and reconnect with your authentic self.",
          fr: "Tournez-vous vers l'intérieur, retrouvez votre équilibre et reconnectez-vous à votre moi authentique.",
          de: "Wenden Sie sich nach innen, stellen Sie Ihr Gleichgewicht wieder her und verbinden Sie sich erneut mit Ihrem authentischen Selbst.",
          be: "Keer naar binnen, herstel je gevoel van balans en herverbind je met je authentieke zelf.",
          tr: "İçe dönün, denge duygunuzu yeniden kazanın ve gerçek benliğinizle yeniden bağlantı kurun.",
          pt: "Volte-se para dentro, restaure o seu sentido de equilíbrio e reconecte-se com o seu eu autêntico.",
          no: "Vend deg innover, gjenopprett balansen din og gjenoppkoble deg med ditt autentiske selv.",
          cy: "Окрените се ка себи, обновите осећај равнотеже и поново се повежите са својим правим ја.",
          ee: "Pöörduge sissepoole, taastage oma tasakaalutunnet ja looge taas ühendus oma tõelise minaga.",
          th: "หันเข้าสู่ภายใน ฟื้นฟูความรู้สึกสมดุล และเชื่อมโยงกับตัวตนที่แท้จริงของคุณอีกครั้ง",
          ar: "اتجه نحو الداخل، استعد إحساسك بالتوازن، وأعد الاتصال بذاتك الحقيقية.",
          gr: "Στραφείτε προς τα μέσα, αποκαταστήστε την αίσθηση ισορροπίας σας και επανασυνδεθείτε με τον αυθεντικό σας εαυτό.",
          es: "Vuélvete hacia tu interior, restaura tu sentido de equilibrio y reconéctate con tu ser auténtico.",
          it: "Volgiti verso l'interno, ripristina il tuo senso di equilibrio e riconnettiti con il tuo vero io.",
          id: "Berpalinglah ke dalam diri, pulihkan rasa keseimbanganmu, dan terhubung kembali dengan dirimu yang sejati.",
          si: "Obrnite se vase, obnovite občutek ravnovesja in se ponovno povežite s svojim pristnim jazom.",
          pl: "Zwróć się do wewnątrz, przywróć poczucie równowagi i połącz się na nowo ze swoim autentycznym ja.",
        },
        videoUrl: "https://cdn.mobio360.com/new+videos/Guided+Meditation/AMeditationtoReconnectwithYourself.mp4",
      },
    ],
  },
  {
    id: 16,
    contents: 6,
    categoryName: {
      en: "Fitness",
      fr: "Fitness",
      de: "Fitness",
      be: "Fitness",
      tr: "Fitness",
      pt: "Fitness",
      no: "Trening",
      cy: "Фитнес",
      ee: "Fitness",
      th: "ฟิตเนส",
      ar: "لياقة بدنية",
      gr: "Γυμναστική",
      es: "Aptitud",
      it: "Fitness",
      id: "Kebugaran",
      si: "Fitnes",
      pl: "Fitness",
    },
    videos: [
      {
        duration: 21334,
        id: 900,
        name: {
          en: "HIIT Back",
          fr: "HIIT Dos",
          de: "HIIT Rücken",
          be: "HIIT Rug",
          tr: "HIIT Sırt",
          pt: "HIIT Costas",
          no: "HIIT Rygg",
          cy: "HIIT за леђа",
          ee: "HIIT Selg",
          th: "HIIT หลัง",
          ar: "HIIT الظهر",
          gr: "HIIT Πλάτη",
          es: "HIIT Espalda",
          it: "HIIT Schiena",
          id: "HIIT Back",
          si: "HIIT za hrbet",
          pl: "HIIT na plecy",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITBack.png",
        desc: {
          en: "Follow a high-intensity workout that targets the back for a quick, effective strength session.",
          fr: "Suivez un entraînement à haute intensité ciblant le dos pour une séance de renforcement rapide et efficace.",
          de: "Absolvieren Sie ein hochintensives Training für den Rücken für eine schnelle, effektive Kräftigungseinheit.",
          be: "Volg een intensieve training gericht op de rug voor een snelle, effectieve krachtsessie.",
          tr: "Hızlı ve etkili bir güçlendirme seansı için sırtı hedefleyen yüksek yoğunluklu bir antrenman yapın.",
          pt: "Siga um treino de alta intensidade que trabalha as costas para uma sessão de força rápida e eficaz.",
          no: "Følg en høyintensiv treningsøkt som fokuserer på ryggen for en rask og effektiv styrkeøkt.",
          cy: "Пратите тренинг високог интензитета усмерен на леђа за брзу и ефикасну сесију снаге.",
          ee: "Tehke kõrge intensiivsusega treening, mis on suunatud seljale kiire ja tõhusa jõutreeningu jaoks.",
          th: "ทำการออกกำลังกายความเข้มข้นสูงที่เน้นกล้ามเนื้อหลังเพื่อเซสชันเสริมความแข็งแรงที่รวดเร็วและมีประสิทธิภาพ",
          ar: "اتبع تمرينًا عالي الكثافة يستهدف الظهر لجلسة تقوية سريعة وفعالة.",
          gr: "Ακολουθήστε μια προπόνηση υψηλής έντασης που στοχεύει στην πλάτη για μια γρήγορη και αποτελεσματική συνεδρία ενδυνάμωσης.",
          es: "Sigue un entrenamiento de alta intensidad centrado en la espalda para una sesión de fuerza rápida y eficaz.",
          it: "Segui un allenamento ad alta intensità mirato alla schiena per una sessione di forza rapida ed efficace.",
          id: "Ikuti latihan intensitas tinggi yang menargetkan punggung untuk sesi penguatan yang cepat dan efektif.",
          si: "Sledite visoko intenzivni vadbi, osredotočeni na hrbet, za hitro in učinkovito krepitev.",
          pl: "Wykonaj trening o wysokiej intensywności skupiony na plecach dla szybkiej i skutecznej sesji siłowej.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Back.mp4",
      },
      {
        duration: 21334,
        id: 901,
        name: {
          en: "HIIT Cardio and Planks",
          fr: "HIIT Cardio et Planches",
          de: "HIIT Cardio und Planks",
          be: "HIIT Cardio en Planken",
          tr: "HIIT Kardiyo ve Plank",
          pt: "HIIT Cardio e Pranchas",
          no: "HIIT Cardio og Planke",
          cy: "HIIT кардио и планкови",
          ee: "HIIT Kardio ja plangud",
          th: "HIIT คาร์ดิโอและแพลงก์",
          ar: "HIIT كارديو وبلانك",
          gr: "HIIT Καρδιο και Plank",
          es: "HIIT Cardio y Planchas",
          it: "HIIT Cardio e Plank",
          id: "HIIT Cardio and Planks",
          si: "HIIT kardio in deske",
          pl: "HIIT cardio i deski",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITCardio+and+Planks.png",
        desc: {
          en: "Combine fast-paced cardio with core-strengthening planks in this high-intensity session.",
          fr: "Combinez un cardio rythmé avec des planches pour renforcer les abdominaux dans cette séance à haute intensité.",
          de: "Kombinieren Sie schnelles Cardio mit rumpfstärkenden Planks in dieser hochintensiven Einheit.",
          be: "Combineer snel cardio met core-versterkende planken in deze intensieve sessie.",
          tr: "Bu yüksek yoğunluklu seansta hızlı tempolu kardiyoyu karın bölgesini güçlendiren plank hareketleriyle birleştirin.",
          pt: "Combine cardio acelerado com pranchas de fortalecimento do núcleo nesta sessão de alta intensidade.",
          no: "Kombiner rask cardio med kjernestyrkende planker i denne høyintensive økten.",
          cy: "Комбинујте брзи кардио са плановима за јачање кора у овој сесији високог интензитета.",
          ee: "Kombineerige kiire kardio kehatuuma tugevdavate plankidega selles kõrge intensiivsusega treeningus.",
          th: "ผสมผสานคาร์ดิโอจังหวะเร็วกับท่าแพลงก์เสริมสร้างกล้ามเนื้อแกนกลางในเซสชันความเข้มข้นสูงนี้",
          ar: "ادمج الكارديو السريع مع تمارين البلانك المقوية لعضلات البطن في هذه الجلسة عالية الكثافة.",
          gr: "Συνδυάστε γρήγορο καρδιο με ασκήσεις πλάγκ για ενδυνάμωση κορμού σε αυτή τη συνεδρία υψηλής έντασης.",
          es: "Combina cardio a ritmo rápido con planchas que fortalecen el core en esta sesión de alta intensidad.",
          it: "Combina cardio ad alto ritmo con plank per rafforzare il core in questa sessione ad alta intensità.",
          id: "Gabungkan kardio berirama cepat dengan plank penguat inti dalam sesi intensitas tinggi ini.",
          si: "Združite hiter kardio z deskami za krepitev jedra v tej visoko intenzivni seji.",
          pl: "Połącz szybkie cardio z deskami wzmacniającymi mięśnie brzucha w tej intensywnej sesji.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Plank+%26+Cardio.mp4",
      },
      {
        duration: 21334,
        id: 902,
        name: {
          en: "HIIT Glutes",
          fr: "HIIT Fessiers",
          de: "HIIT Gesäß",
          be: "HIIT Bilspieren",
          tr: "HIIT Kalça",
          pt: "HIIT Glúteos",
          no: "HIIT Setemuskler",
          cy: "HIIT за глутеусе",
          ee: "HIIT Tuharad",
          th: "HIIT กล้ามเนื้อสะโพก",
          ar: "HIIT الأرداف",
          gr: "HIIT Γλουτοί",
          es: "HIIT Glúteos",
          it: "HIIT Glutei",
          id: "HIIT Glutes",
          si: "HIIT za zadnjico",
          pl: "HIIT na pośladki",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITGlutes.png",
        desc: {
          en: "Target and tone your glutes with this high-intensity interval workout.",
          fr: "Ciblez et tonifiez vos fessiers avec cet entraînement fractionné à haute intensité.",
          de: "Trainieren und straffen Sie Ihr Gesäß mit diesem hochintensiven Intervalltraining.",
          be: "Train en tonify je bilspieren met deze hoogintensieve intervaltraining.",
          tr: "Bu yüksek yoğunluklu interval antrenmanla kalçalarınızı hedefleyin ve sıkılaştırın.",
          pt: "Trabalhe e tonifique os seus glúteos com este treino intervalado de alta intensidade.",
          no: "Tren og tonifiser setemusklene dine med denne høyintensive intervalltreningen.",
          cy: "Циљајте и тонизирајте своје глутеусе овим интервалним тренингом високог интензитета.",
          ee: "Treenige ja vormige oma tuharaid selle kõrge intensiivsusega intervalltreeninguga.",
          th: "เน้นและกระชับกล้ามเนื้อสะโพกด้วยการออกกำลังกายแบบช่วงความเข้มข้นสูงนี้",
          ar: "استهدف وشدّ عضلات الأرداف بهذا التمرين المتقطع عالي الكثافة.",
          gr: "Στοχεύστε και σφίξτε τους γλουτούς σας με αυτή τη διαλειμματική προπόνηση υψηλής έντασης.",
          es: "Trabaja y tonifica tus glúteos con este entrenamiento interválico de alta intensidad.",
          it: "Allena e tonifica i glutei con questo allenamento a intervalli ad alta intensità.",
          id: "Targetkan dan kencangkan otot bokong Anda dengan latihan interval intensitas tinggi ini.",
          si: "Ciljajte in tonizirajte zadnjico s to visoko intenzivno intervalno vadbo.",
          pl: "Wyrzeźb i ujędrnij pośladki dzięki temu treningowi interwałowemu o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Glutes.mp4",
      },
      {
        duration: 21334,
        id: 903,
        name: {
          en: "HIIT Core",
          fr: "HIIT Abdominaux",
          de: "HIIT Rumpf",
          be: "HIIT Core",
          tr: "HIIT Karın Bölgesi",
          pt: "HIIT Núcleo",
          no: "HIIT Kjerne",
          cy: "HIIT за језгро тела",
          ee: "HIIT Kehatuum",
          th: "HIIT กล้ามท้อง",
          ar: "HIIT عضلات البطن",
          gr: "HIIT Κορμός",
          es: "HIIT Núcleo",
          it: "HIIT Core",
          id: "HIIT Core",
          si: "HIIT za jedro",
          pl: "HIIT na mięśnie brzucha",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITCore.png",
        desc: {
          en: "Strengthen your core with a fast-paced, high-intensity workout.",
          fr: "Renforcez vos abdominaux avec un entraînement rythmé et à haute intensité.",
          de: "Stärken Sie Ihren Rumpf mit einem schnellen, hochintensiven Training.",
          be: "Versterk je core met een snelle, hoogintensieve training.",
          tr: "Hızlı tempolu, yüksek yoğunluklu bir antrenmanla karın bölgenizi güçlendirin.",
          pt: "Fortaleça o seu núcleo com um treino acelerado e de alta intensidade.",
          no: "Styrk kjernen din med en rask, høyintensiv treningsøkt.",
          cy: "Ојачајте свој кор брзим тренингом високог интензитета.",
          ee: "Tugevdage oma kehatuuma kiire, kõrge intensiivsusega treeninguga.",
          th: "เสริมสร้างกล้ามเนื้อแกนกลางด้วยการออกกำลังกายจังหวะเร็วความเข้มข้นสูง",
          ar: "قوِّ عضلات بطنك بتمرين سريع وعالي الكثافة.",
          gr: "Ενδυναμώστε τον κορμό σας με μια γρήγορη προπόνηση υψηλής έντασης.",
          es: "Fortalece tu core con un entrenamiento rápido y de alta intensidad.",
          it: "Rafforza il tuo core con un allenamento rapido e ad alta intensità.",
          id: "Perkuat inti tubuh Anda dengan latihan cepat berintensitas tinggi.",
          si: "Okrepite jedro s hitro, visoko intenzivno vadbo.",
          pl: "Wzmocnij mięśnie brzucha szybkim treningiem o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Core.mp4",
      },
      {
        duration: 21334,
        id: 904,
        name: {
          en: "HIIT Triceps",
          fr: "HIIT Triceps",
          de: "HIIT Trizeps",
          be: "HIIT Triceps",
          tr: "HIIT Triseps",
          pt: "HIIT Tríceps",
          no: "HIIT Triceps",
          cy: "HIIT за трицепсе",
          ee: "HIIT Triitseps",
          th: "HIIT ไตรเซ็ปส์",
          ar: "HIIT العضلة ثلاثية الرؤوس",
          gr: "HIIT Τρικέφαλοι",
          es: "HIIT Tríceps",
          it: "HIIT Tricipiti",
          id: "HIIT Triceps",
          si: "HIIT za tricepse",
          pl: "HIIT na tricepsy",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITTriceps+.png",
        desc: {
          en: "Sculpt and strengthen your triceps with this high-intensity workout.",
          fr: "Sculptez et renforcez vos triceps avec cet entraînement à haute intensité.",
          de: "Formen und stärken Sie Ihren Trizeps mit diesem hochintensiven Training.",
          be: "Vorm en versterk je triceps met deze hoogintensieve training.",
          tr: "Bu yüksek yoğunluklu antrenmanla triseps kaslarınızı şekillendirin ve güçlendirin.",
          pt: "Modele e fortaleça os seus tríceps com este treino de alta intensidade.",
          no: "Form og styrk triceps med denne høyintensive treningsøkten.",
          cy: "Обликујте и ојачајте своје трицепсе овим тренингом високог интензитета.",
          ee: "Vormige ja tugevdage oma triitsepseid selle kõrge intensiivsusega treeninguga.",
          th: "ปั้นและเสริมสร้างกล้ามเนื้อไตรเซ็ปส์ด้วยการออกกำลังกายความเข้มข้นสูงนี้",
          ar: "انحت وقوِّ عضلة الترايسبس بهذا التمرين عالي الكثافة.",
          gr: "Σμιλέψτε και ενδυναμώστε τους τρικέφαλούς σας με αυτή την προπόνηση υψηλής έντασης.",
          es: "Esculpe y fortalece tus tríceps con este entrenamiento de alta intensidad.",
          it: "Scolpisci e rafforza i tricipiti con questo allenamento ad alta intensità.",
          id: "Bentuk dan perkuat trisep Anda dengan latihan intensitas tinggi ini.",
          si: "Oblikujte in okrepite triceps s to visoko intenzivno vadbo.",
          pl: "Wyrzeźb i wzmocnij tricepsy dzięki temu treningowi o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Triceps.mp4",
      },
      {
        duration: 21334,
        id: 905,
        name: {
          en: "HIIT Shoulders",
          fr: "HIIT Épaules",
          de: "HIIT Schultern",
          be: "HIIT Schouders",
          tr: "HIIT Omuz",
          pt: "HIIT Ombros",
          no: "HIIT Skuldre",
          cy: "HIIT за рамена",
          ee: "HIIT Õlad",
          th: "HIIT ไหล่",
          ar: "HIIT الأكتاف",
          gr: "HIIT Ώμοι",
          es: "HIIT Hombros",
          it: "HIIT Spalle",
          id: "HIIT Shoulders",
          si: "HIIT za ramena",
          pl: "HIIT na barki",
        },
        preview: "https://cdn.mobio360.com/Fitness/HIITShoulders.png",
        desc: {
          en: "Build strength and definition in your shoulders with this high-intensity workout.",
          fr: "Développez force et définition de vos épaules avec cet entraînement à haute intensité.",
          de: "Bauen Sie Kraft und Definition in Ihren Schultern mit diesem hochintensiven Training auf.",
          be: "Bouw kracht en definitie op in je schouders met deze hoogintensieve training.",
          tr: "Bu yüksek yoğunluklu antrenmanla omuzlarınızda güç ve tanım oluşturun.",
          pt: "Desenvolva força e definição nos ombros com este treino de alta intensidade.",
          no: "Bygg styrke og definisjon i skuldrene med denne høyintensive treningsøkten.",
          cy: "Изградите снагу и дефиницију рамена овим тренингом високог интензитета.",
          ee: "Arendage jõudu ja määratlust õlgades selle kõrge intensiivsusega treeninguga.",
          th: "สร้างความแข็งแรงและความกระชับให้ไหล่ด้วยการออกกำลังกายความเข้มข้นสูงนี้",
          ar: "ابنِ القوة والتحديد في أكتافك بهذا التمرين عالي الكثافة.",
          gr: "Χτίστε δύναμη και σαφήνεια στους ώμους σας με αυτή την προπόνηση υψηλής έντασης.",
          es: "Desarrolla fuerza y definición en tus hombros con este entrenamiento de alta intensidad.",
          it: "Sviluppa forza e definizione nelle spalle con questo allenamento ad alta intensità.",
          id: "Bangun kekuatan dan definisi pada bahu Anda dengan latihan intensitas tinggi ini.",
          si: "Zgradite moč in definicijo ramen s to visoko intenzivno vadbo.",
          pl: "Zbuduj siłę i definicję barków dzięki temu treningowi o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/HIIT+Shoulders.mp4",
      },
      {
        duration: 21334,
        id: 906,
        name: {
          en: "Outdoor HIIT Cardio and Planks",
          fr: "HIIT Cardio et Planches en Extérieur",
          de: "Outdoor HIIT Cardio und Planks",
          be: "Buiten HIIT Cardio en Planken",
          tr: "Açık Havada HIIT Kardiyo ve Plank",
          pt: "HIIT Cardio e Pranchas ao Ar Livre",
          no: "Utendørs HIIT Cardio og Planke",
          cy: "HIIT кардио и планкови на отвореном",
          ee: "Õues HIIT Kardio ja plangud",
          th: "HIIT กลางแจ้ง คาร์ดิโอและแพลงก์",
          ar: "HIIT كارديو وبلانك في الهواء الطلق",
          gr: "Υπαίθρια HIIT Καρδιο και Plank",
          es: "HIIT al aire libre Cardio y Planchas",
          it: "HIIT Cardio e Plank all'Aperto",
          id: "Outdoor HIIT Cardio and Planks",
          si: "Zunanji HIIT kardio in deske",
          pl: "Outdoor HIIT cardio i deski",
        },

        preview: "https://cdn.mobio360.com/Fitness/OutdoorHIITCardio.png",
        desc: {
          en: "Combine cardio and planks in the fresh air with this outdoor high-intensity workout.",
          fr: "Combinez cardio et planches au grand air avec cet entraînement extérieur à haute intensité.",
          de: "Kombinieren Sie Cardio und Planks an der frischen Luft mit diesem hochintensiven Outdoor-Training.",
          be: "Combineer cardio en planken in de frisse lucht met deze hoogintensieve buitentraining.",
          tr: "Bu açık hava yüksek yoğunluklu antrenmanla temiz havada kardiyo ve plank hareketlerini birleştirin.",
          pt: "Combine cardio e pranchas ao ar livre com este treino de alta intensidade.",
          no: "Kombiner cardio og planker i frisk luft med denne høyintensive utendørsøkten.",
          cy: "Комбинујте кардио и планкове на свежем ваздуху уз овај тренинг високог интензитета на отвореном.",
          ee: "Kombineerige kardio ja plangud värskes õhus selle õuetreeninguga.",
          th: "ผสมผสานคาร์ดิโอและแพลงก์ท่ามกลางอากาศบริสุทธิ์ด้วยการออกกำลังกายกลางแจ้งความเข้มข้นสูงนี้",
          ar: "ادمج الكارديو وتمارين البلانك في الهواء الطلق بهذا التمرين الخارجي عالي الكثافة.",
          gr: "Συνδυάστε καρδιο και πλάγκ στον καθαρό αέρα με αυτή την υπαίθρια προπόνηση υψηλής έντασης.",
          es: "Combina cardio y planchas al aire libre con este entrenamiento de alta intensidad.",
          it: "Combina cardio e plank all'aria aperta con questo allenamento outdoor ad alta intensità.",
          id: "Gabungkan kardio dan plank di udara segar dengan latihan luar ruangan intensitas tinggi ini.",
          si: "Združite kardio in deske na svežem zraku s to visoko intenzivno vadbo na prostem.",
          pl: "Połącz cardio i deski na świeżym powietrzu dzięki temu treningowi outdoorowemu o wysokiej intensywności.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Cardio+and+Planks.mp4",
      },
      {
        duration: 21334,
        id: 907,
        name: {
          en: "Outdoor HIIT Shoulders",
          fr: "HIIT Épaules en Extérieur",
          de: "Outdoor HIIT Schultern",
          be: "Buiten HIIT Schouders",
          tr: "Açık Havada HIIT Omuz",
          pt: "HIIT Ombros ao Ar Livre",
          no: "Utendørs HIIT Skuldre",
          cy: "HIIT за рамена на отвореном",
          ee: "Õues HIIT Õlad",
          th: "HIIT ไหล่กลางแจ้ง",
          ar: "HIIT الأكتاف في الهواء الطلق",
          gr: "Υπαίθρια HIIT Ώμοι",
          es: "HIIT al aire libre Hombros",
          it: "HIIT Spalle all'Aperto",
          id: "Outdoor HIIT Shoulders",
          si: "Zunanji HIIT za ramena",
          pl: "Outdoor HIIT na barki",
        },
        preview: "https://cdn.mobio360.com/Fitness/OutdoorHIITShoulders.png",
        desc: {
          en: "Strengthen your shoulders outdoors with this high-intensity interval workout.",
          fr: "Renforcez vos épaules en extérieur avec cet entraînement fractionné à haute intensité.",
          de: "Stärken Sie Ihre Schultern im Freien mit diesem hochintensiven Intervalltraining.",
          be: "Versterk je schouders buiten met deze hoogintensieve intervaltraining.",
          tr: "Bu yüksek yoğunluklu interval antrenmanla omuzlarınızı açık havada güçlendirin.",
          pt: "Fortaleça os seus ombros ao ar livre com este treino intervalado de alta intensidade.",
          no: "Styrk skuldrene utendørs med denne høyintensive intervalltreningen.",
          cy: "Ојачајте рамена на отвореном овим интервалним тренингом високог интензитета.",
          ee: "Tugevdage õlgu õues selle kõrge intensiivsusega intervalltreeninguga.",
          th: "เสริมสร้างไหล่กลางแจ้งด้วยการออกกำลังกายแบบช่วงความเข้มข้นสูงนี้",
          ar: "قوِّ أكتافك في الهواء الطلق بهذا التمرين المتقطع عالي الكثافة.",
          gr: "Ενδυναμώστε τους ώμους σας υπαίθρια με αυτή τη διαλειμματική προπόνηση υψηλής έντασης.",
          es: "Fortalece tus hombros al aire libre con este entrenamiento interválico de alta intensidad.",
          it: "Rafforza le spalle all'aperto con questo allenamento a intervalli ad alta intensità.",
          id: "Perkuat bahu Anda di luar ruangan dengan latihan interval intensitas tinggi ini.",
          si: "Okrepite ramena na prostem s to visoko intenzivno intervalno vadbo.",
          pl: "Wzmocnij barki na świeżym powietrzu dzięki temu treningowi interwałowemu o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Shoulders.mp4",
      },
      {
        duration: 21334,
        id: 908,
        name: {
          en: "Outdoor HIIT Legs",
          fr: "HIIT Jambes en Extérieur",
          de: "Outdoor HIIT Beine",
          be: "Buiten HIIT Benen",
          tr: "Açık Havada HIIT Bacak",
          pt: "HIIT Pernas ao Ar Livre",
          no: "Utendørs HIIT Ben",
          cy: "HIIT за ноге на отвореном",
          ee: "Õues HIIT Jalad",
          th: "HIIT ขากลางแจ้ง",
          ar: "HIIT الساقين في الهواء الطلق",
          gr: "Υπαίθρια HIIT Πόδια",
          es: "HIIT al aire libre Piernas",
          it: "HIIT Gambe all'Aperto",
          id: "Outdoor HIIT Legs",
          si: "Zunanji HIIT za noge",
          pl: "Outdoor HIIT na nogi",
        },
        preview: "https://cdn.mobio360.com/Fitness/OutdoorHIITLegs.png",
        desc: {
          en: "Build strength and endurance in your legs with this outdoor high-intensity workout.",
          fr: "Développez force et endurance de vos jambes avec cet entraînement extérieur à haute intensité.",
          de: "Bauen Sie Kraft und Ausdauer in Ihren Beinen mit diesem hochintensiven Outdoor-Training auf.",
          be: "Bouw kracht en uithoudingsvermogen op in je benen met deze hoogintensieve buitentraining.",
          tr: "Bu açık hava yüksek yoğunluklu antrenmanla bacaklarınızda güç ve dayanıklılık oluşturun.",
          pt: "Desenvolva força e resistência nas pernas com este treino de alta intensidade ao ar livre.",
          no: "Bygg styrke og utholdenhet i beina med denne høyintensive utendørsøkten.",
          cy: "Изградите снагу и издржљивост ногу овим тренингом високог интензитета на отвореном.",
          ee: "Arendage jõudu ja vastupidavust jalgades selle õuetreeninguga.",
          th: "สร้างความแข็งแรงและความอดทนของขาด้วยการออกกำลังกายกลางแจ้งความเข้มข้นสูงนี้",
          ar: "ابنِ القوة والتحمل في ساقيك بهذا التمرين الخارجي عالي الكثافة.",
          gr: "Χτίστε δύναμη και αντοχή στα πόδια σας με αυτή την υπαίθρια προπόνηση υψηλής έντασης.",
          es: "Desarrolla fuerza y resistencia en tus piernas con este entrenamiento de alta intensidad al aire libre.",
          it: "Sviluppa forza e resistenza nelle gambe con questo allenamento outdoor ad alta intensità.",
          id: "Bangun kekuatan dan daya tahan kaki Anda dengan latihan luar ruangan intensitas tinggi ini.",
          si: "Zgradite moč in vzdržljivost nog s to visoko intenzivno vadbo na prostem.",
          pl: "Zbuduj siłę i wytrzymałość nóg dzięki temu treningowi outdoorowemu o wysokiej intensywności.",
        },
        videoUrl: "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Legs.mp4",
      },
      {
        duration: 21334,
        id: 909,
        name: {
          en: "Outdoor HIIT Butts and Guts",
          fr: "HIIT Fessiers et Abdominaux en Extérieur",
          de: "Outdoor HIIT Po und Bauch",
          be: "Buiten HIIT Billen en Buik",
          tr: "Açık Havada HIIT Kalça ve Karın",
          pt: "HIIT Glúteos e Abdômen ao Ar Livre",
          no: "Utendørs HIIT Sete og Mage",
          cy: "HIIT за глутеусе и трбушњаке на отвореном",
          ee: "Õues HIIT Tuharad ja kõht",
          th: "HIIT กลางแจ้ง สะโพกและหน้าท้อง",
          ar: "HIIT الأرداف والبطن في الهواء الطلق",
          gr: "Υπαίθρια HIIT Γλουτοί και Κοιλιακοί",
          es: "HIIT al aire libre Glúteos y Abdomen",
          it: "HIIT Glutei e Addominali all'Aperto",
          id: "Outdoor HIIT Butts and Guts",
          si: "Zunanji HIIT za zadnjico in trebuh",
          pl: "Outdoor HIIT na pośladki i brzuch",
        },
        preview: "https://cdn.mobio360.com/Fitness/OutdoorHIITButtsandGuts.png",
        desc: {
          en: "Tone your glutes and core outdoors with this high-intensity interval workout.",
          fr: "Tonifiez vos fessiers et vos abdominaux en extérieur avec cet entraînement fractionné à haute intensité.",
          de: "Straffen Sie Gesäß und Rumpf im Freien mit diesem hochintensiven Intervalltraining.",
          be: "Tonify je bilspieren en core buiten met deze hoogintensieve intervaltraining.",
          tr: "Bu yüksek yoğunluklu interval antrenmanla kalçalarınızı ve karın bölgenizi açık havada sıkılaştırın.",
          pt: "Tonifique os seus glúteos e núcleo ao ar livre com este treino intervalado de alta intensidade.",
          no: "Tonifiser setemuskler og kjerne utendørs med denne høyintensive intervalltreningen.",
          cy: "Тонизирајте глутеусе и кор на отвореном овим интервалним тренингом високог интензитета.",
          ee: "Vormige tuharaid ja kehatuuma õues selle kõrge intensiivsusega intervalltreeninguga.",
          th: "กระชับสะโพกและแกนกลางกลางแจ้งด้วยการออกกำลังกายแบบช่วงความเข้มข้นสูงนี้",
          ar: "شدّ أردافك وعضلات بطنك في الهواء الطلق بهذا التمرين المتقطع عالي الكثافة.",
          gr: "Σφίξτε γλουτούς και κορμό υπαίθρια με αυτή τη διαλειμματική προπόνηση υψηλής έντασης.",
          es: "Tonifica tus glúteos y core al aire libre con este entrenamiento interválico de alta intensidad.",
          it: "Tonifica glutei e core all'aperto con questo allenamento a intervalli ad alta intensità.",
          id: "Kencangkan bokong dan inti tubuh Anda di luar ruangan dengan latihan interval intensitas tinggi ini.",
          si: "Tonizirajte zadnjico in jedro na prostem s to visoko intenzivno intervalno vadbo.",
          pl: "Ujędrnij pośladki i mięśnie brzucha na świeżym powietrzu dzięki temu treningowi interwałowemu.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Butts+and+Guts.mp4",
      },
      {
        duration: 21334,
        id: 910,
        name: {
          en: "Outdoor HIIT Back and Cardio",
          fr: "HIIT Dos et Cardio en Extérieur",
          de: "Outdoor HIIT Rücken und Cardio",
          be: "Buiten HIIT Rug en Cardio",
          tr: "Açık Havada HIIT Sırt ve Kardiyo",
          pt: "HIIT Costas e Cardio ao Ar Livre",
          no: "Utendørs HIIT Rygg og Cardio",
          cy: "HIIT за леђа и кардио на отвореном",
          ee: "Õues HIIT Selg ja kardio",
          th: "HIIT กลางแจ้ง หลังและคาร์ดิโอ",
          ar: "HIIT الظهر والكارديو في الهواء الطلق",
          gr: "Υπαίθρια HIIT Πλάτη και Καρδιο",
          es: "HIIT al aire libre Espalda y Cardio",
          it: "HIIT Schiena e Cardio all'Aperto",
          id: "Outdoor HIIT Back and Cardio",
          si: "Zunanji HIIT za hrbet in kardio",
          pl: "Outdoor HIIT na plecy i cardio",
        },
        preview:
          "https://cdn.mobio360.com/Fitness/OutdoorHIITBackandCardio.png",
        desc: {
          en: "Combine back strengthening and cardio in the open air with this outdoor workout.",
          fr: "Combinez renforcement du dos et cardio au grand air avec cet entraînement extérieur.",
          de: "Kombinieren Sie Rückenstärkung und Cardio an der frischen Luft mit diesem Outdoor-Training.",
          be: "Combineer rugversterking en cardio in de buitenlucht met deze buitentraining.",
          tr: "Bu açık hava antrenmanıyla sırt güçlendirmeyi ve kardiyoyu açık havada birleştirin.",
          pt: "Combine o fortalecimento das costas com cardio ao ar livre neste treino.",
          no: "Kombiner ryggstyrking og cardio i friluft med denne utendørsøkten.",
          cy: "Комбинујте јачање леђа и кардио на свежем ваздуху уз овај тренинг на отвореном.",
          ee: "Kombineerige selja tugevdamine ja kardio värskes õhus selle õuetreeninguga.",
          th: "ผสมผสานการเสริมสร้างหลังและคาร์ดิโอท่ามกลางอากาศบริสุทธิ์ด้วยการออกกำลังกายกลางแจ้งนี้",
          ar: "ادمج تقوية الظهر والكارديو في الهواء الطلق بهذا التمرين الخارجي.",
          gr: "Συνδυάστε ενδυνάμωση πλάτης και καρδιο στον καθαρό αέρα με αυτή την υπαίθρια προπόνηση.",
          es: "Combina el fortalecimiento de espalda y el cardio al aire libre en este entrenamiento.",
          it: "Combina il rafforzamento della schiena e il cardio all'aria aperta con questo allenamento outdoor.",
          id: "Gabungkan penguatan punggung dan kardio di udara terbuka dengan latihan luar ruangan ini.",
          si: "Združite krepitev hrbta in kardio na svežem zraku s to vadbo na prostem.",
          pl: "Połącz wzmacnianie pleców i cardio na świeżym powietrzu dzięki temu treningowi outdoorowemu.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Back+and+Cardio.mp4",
      },
      {
        duration: 21334,
        id: 911,
        name: {
          en: "Outdoor HIIT Biceps and Triceps",
          fr: "HIIT Biceps et Triceps en Extérieur",
          de: "Outdoor HIIT Bizeps und Trizeps",
          be: "Buiten HIIT Biceps en Triceps",
          tr: "Açık Havada HIIT Biceps ve Triceps",
          pt: "HIIT Bíceps e Tríceps ao Ar Livre",
          no: "Utendørs HIIT Biceps og Triceps",
          cy: "HIIT за бицепсе и трицепсе на отвореном",
          ee: "Õues HIIT Biitseps ja triitseps",
          th: "HIIT กลางแจ้ง ไบเซ็ปส์และไตรเซ็ปส์",
          ar: "HIIT العضلة ذات الرأسين وثلاثية الرؤوس في الهواء الطلق",
          gr: "Υπαίθρια HIIT Δικέφαλοι και Τρικέφαλοι",
          es: "HIIT al aire libre Bíceps y Tríceps",
          it: "HIIT Bicipiti e Tricipiti all'Aperto",
          id: "Outdoor HIIT Biceps and Triceps",
          si: "Zunanji HIIT za bicepse in tricepse",
          pl: "Outdoor HIIT na bicepsy i tricepsy",
        },
        preview:
          "https://cdn.mobio360.com/Fitness/OutdoorHIITBicepsandTriceps.png",
        desc: {
          en: "Sculpt your biceps and triceps outdoors with this high-intensity workout.",
          fr: "Sculptez vos biceps et triceps en extérieur avec cet entraînement à haute intensité.",
          de: "Formen Sie Bizeps und Trizeps im Freien mit diesem hochintensiven Training.",
          be: "Vorm je biceps en triceps buiten met deze hoogintensieve training.",
          tr: "Bu yüksek yoğunluklu antrenmanla biceps ve triseps kaslarınızı açık havada şekillendirin.",
          pt: "Modele os seus bíceps e tríceps ao ar livre com este treino de alta intensidade.",
          no: "Form biceps og triceps utendørs med denne høyintensive treningsøkten.",
          cy: "Обликујте бицепсе и трицепсе на отвореном овим тренингом високог интензитета.",
          ee: "Vormige biitsepseid ja triitsepseid õues selle kõrge intensiivsusega treeninguga.",
          th: "ปั้นกล้ามเนื้อไบเซ็ปส์และไตรเซ็ปส์กลางแจ้งด้วยการออกกำลังกายความเข้มข้นสูงนี้",
          ar: "انحت عضلتي البايسبس والترايسبس في الهواء الطلق بهذا التمرين عالي الكثافة.",
          gr: "Σμιλέψτε δικέφαλους και τρικέφαλους υπαίθρια με αυτή την προπόνηση υψηλής έντασης.",
          es: "Esculpe tus bíceps y tríceps al aire libre con este entrenamiento de alta intensidad.",
          it: "Scolpisci bicipiti e tricipiti all'aperto con questo allenamento ad alta intensità.",
          id: "Bentuk bisep dan trisep Anda di luar ruangan dengan latihan intensitas tinggi ini.",
          si: "Oblikujte bicepse in tricepse na prostem s to visoko intenzivno vadbo.",
          pl: "Wyrzeźb bicepsy i tricepsy na świeżym powietrzu dzięki temu treningowi o wysokiej intensywności.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Fitness/Outdoor+HIIT+Biceps+and+Triceps.mp4",
      },
    ],
  },
  {
    id: 17,
    contents: 7,
    categoryName: {
      en: "Yoga",
      fr: "Yoga",
      de: "Yoga",
      be: "Yoga",
      tr: "Yoga",
      pt: "Yoga",
      no: "Yoga",
      cy: "Јога",
      ee: "Jooga",
      th: "โยคะ",
      ar: "يوغا",
      gr: "Γιόγκα",
      es: "Yoga",
      it: "Yoga",
      id: "Yoga",
      si: "Joga",
      pl: "Joga",
    },
    videos: [
      {
        duration: 21334,
        id: 912,
        name: {
          en: "Sun Salutation",
          fr: "Salutation au Soleil",
          de: "Sonnengruß",
          be: "Zonnegroet",
          tr: "Güneşe Selam",
          pt: "Saudação ao Sol",
          no: "Solhilsen",
          cy: "Поздрав Сунцу",
          ee: "Päikesetervitus",
          th: "ท่าไหว้พระอาทิตย์",
          ar: "تحية الشمس",
          gr: "Χαιρετισμός στον Ήλιο",
          es: "Saludo al Sol",
          it: "Saluto al Sole",
          id: "Sun Salutation",
          si: "Pozdrav soncu",
          pl: "Powitanie słońca",
        },
        preview: "https://cdn.mobio360.com/Yoga/SunSalutation.png",
        desc: {
          en: "Move through a gentle Sun Salutation sequence to build strength and flexibility.",
          fr: "Enchaînez une douce séquence de Salutation au Soleil pour développer force et souplesse.",
          de: "Bewegen Sie sich durch eine sanfte Sonnengruß-Sequenz, um Kraft und Flexibilität aufzubauen.",
          be: "Beweeg door een zachte Zonnegroet-reeks om kracht en flexibiliteit op te bouwen.",
          tr: "Güç ve esneklik oluşturmak için nazik bir Güneşe Selam dizisi boyunca hareket edin.",
          pt: "Mova-se através de uma suave sequência de Saudação ao Sol para desenvolver força e flexibilidade.",
          no: "Beveg deg gjennom en mild Solhilsen-sekvens for å bygge styrke og fleksibilitet.",
          cy: "Крећите се кроз благи низ Поздрава Сунцу да бисте изградили снагу и флексибилност.",
          ee: "Liikuge läbi õrna Päikesetervituse jada, et arendada jõudu ja painduvust.",
          th: "เคลื่อนไหวผ่านลำดับท่าไหว้พระอาทิตย์อย่างอ่อนโยนเพื่อสร้างความแข็งแรงและความยืดหยุ่น",
          ar: "تحرك عبر سلسلة لطيفة من تحية الشمس لبناء القوة والمرونة.",
          gr: "Κινηθείτε μέσα από μια ήπια ακολουθία Χαιρετισμού στον Ήλιο για να χτίσετε δύναμη και ευλυγισία.",
          es: "Muévete a través de una suave secuencia de Saludo al Sol para desarrollar fuerza y flexibilidad.",
          it: "Muoviti attraverso una dolce sequenza di Saluto al Sole per sviluppare forza e flessibilità.",
          id: "Bergeraklah melalui rangkaian Salam Matahari yang lembut untuk membangun kekuatan dan fleksibilitas.",
          si: "Premikajte se skozi nežno zaporedje Pozdrava soncu, da zgradite moč in prožnost.",
          pl: "Przejdź przez łagodną sekwencję Powitania Słońca, aby zbudować siłę i elastyczność.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Sun+Salutation.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        duration: 21334,
        id: 913,
        name: {
          en: "Sommelier and Triangle Yoga Postures",
          fr: "Postures de Yoga Sommelier et Triangle",
          de: "Sommelier- und Dreieck-Yoga-Posen",
          be: "Sommelier- en Driehoek Yogahoudingen",
          tr: "Sommelier ve Üçgen Yoga Duruşları",
          pt: "Posturas de Yoga Sommelier e Triângulo",
          no: "Sommelier- og Trekant Yogastillinger",
          cy: "Положаји сомелијера и троугла у јоги",
          ee: "Sommelier' ja kolmnurga jooga asendid",
          th: "ท่าโซเมอลิเยร์และท่าสามเหลี่ยม",
          ar: "أوضاع يوغا السوميلييه والمثلث",
          gr: "Στάσεις Γιόγκα Sommelier και Τριγώνου",
          es: "Posturas de Yoga Sommelier y Triángulo",
          it: "Posizioni Yoga Sommelier e Triangolo",
          id: "Sommelier and Triangle Yoga Postures",
          si: "Sommeler in trikotne joga drže",
          pl: "Sommelier i postawy jogi w kształcie trójkąta",
        },
        preview: "https://cdn.mobio360.com/Yoga/SommelierandTriangle.png",
        desc: {
          en: "Explore the Sommelier and Triangle poses to improve balance and open the hips.",
          fr: "Explorez les postures Sommelier et Triangle pour améliorer l'équilibre et ouvrir les hanches.",
          de: "Entdecken Sie die Sommelier- und Dreieck-Posen, um Balance zu verbessern und die Hüften zu öffnen.",
          be: "Verken de Sommelier- en Driehoekhoudingen om balans te verbeteren en de heupen te openen.",
          tr: "Denge geliştirmek ve kalçaları açmak için Sommelier ve Üçgen duruşlarını keşfedin.",
          pt: "Explore as posturas Sommelier e Triângulo para melhorar o equilíbrio e abrir os quadris.",
          no: "Utforsk Sommelier- og Trekant-stillingene for å forbedre balansen og åpne hoftene.",
          cy: "Истражите положаје Сомелијера и Троугла да бисте побољшали равнотежу и отворили кукове.",
          ee: "Uurige Sommelier' ja kolmnurga asendeid, et parandada tasakaalu ja avada puusi.",
          th: "สำรวจท่าโซเมอลิเยร์และท่าสามเหลี่ยมเพื่อพัฒนาความสมดุลและเปิดสะโพก",
          ar: "استكشف وضعيتي السوميلييه والمثلث لتحسين التوازن وفتح الوركين.",
          gr: "Εξερευνήστε τις στάσεις Sommelier και Τριγώνου για να βελτιώσετε την ισορροπία και να ανοίξετε τους γοφούς.",
          es: "Explora las posturas Sommelier y Triángulo para mejorar el equilibrio y abrir las caderas.",
          it: "Esplora le posizioni Sommelier e Triangolo per migliorare l'equilibrio e aprire le anche.",
          id: "Jelajahi pose Sommelier dan Segitiga untuk meningkatkan keseimbangan dan membuka pinggul.",
          si: "Raziščite drže Sommelier in Trikotnik, da izboljšate ravnotežje in odprete kolke.",
          pl: "Poznaj pozycje Sommelier i Trójkąta, aby poprawić równowagę i otworzyć biodra.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Yoga/Sommelier+and+Triangle+Yoga+Postures.mp4",
      },
      {
        duration: 21334,
        id: 914,
        name: {
          en: "Sun Salutation and chrysalis",
          fr: "Salutation au Soleil et chrysalide",
          de: "Sonnengruß und Chrysalis",
          be: "Zonnegroet en cocon",
          tr: "Güneşe Selam ve Krizalit",
          pt: "Saudação ao Sol e Crisálida",
          no: "Solhilsen og puppe",
          cy: "Поздрав Сунцу и хризалис",
          ee: "Päikesetervitus ja nukk",
          th: "ท่าไหว้พระอาทิตย์และท่าดักแด้",
          ar: "تحية الشمس والشرنقة",
          gr: "Χαιρετισμός στον Ήλιο και Χρυσαλλίδα",
          es: "Saludo al Sol y Crisálida",
          it: "Saluto al Sole e crisalide",
          id: "Sun Salutation and chrysalis",
          si: "Pozdrav soncu in hrošč",
          pl: "Powitanie słońca i poczwarka",
        },
        preview: "https://cdn.mobio360.com/Yoga/SunSalutationandchrysalis.png",
        desc: {
          en: "Flow through Sun Salutation and the chrysalis pose to awaken the body and mind.",
          fr: "Enchaînez la Salutation au Soleil et la posture de la chrysalide pour éveiller le corps et l'esprit.",
          de: "Fließen Sie durch den Sonnengruß und die Chrysalis-Pose, um Körper und Geist zu wecken.",
          be: "Vloei door de Zonnegroet en de coconhouding om lichaam en geest te wekken.",
          tr: "Vücudu ve zihni uyandırmak için Güneşe Selam ve krizalit duruşu arasında akış sağlayın.",
          pt: "Flua pela Saudação ao Sol e pela postura da crisálida para despertar o corpo e a mente.",
          no: "Flyt gjennom Solhilsen og puppestillingen for å vekke kropp og sinn.",
          cy: "Прелазите између Поздрава Сунцу и положаја хризалиса да бисте пробудили тело и ум.",
          ee: "Liikuge Päikesetervituse ja nukuasendi vahel, et äratada keha ja meel.",
          th: "เคลื่อนไหวผ่านท่าไหว้พระอาทิตย์และท่าดักแด้เพื่อปลุกร่างกายและจิตใจ",
          ar: "انتقل بين تحية الشمس ووضعية الشرنقة لإيقاظ الجسد والعقل.",
          gr: "Ρέστε μέσα από τον Χαιρετισμό στον Ήλιο και τη στάση της χρυσαλλίδας για να ξυπνήσετε το σώμα και το μυαλό.",
          es: "Fluye entre el Saludo al Sol y la postura de la crisálida para despertar el cuerpo y la mente.",
          it: "Fluisci tra il Saluto al Sole e la posizione della crisalide per risvegliare corpo e mente.",
          id: "Mengalirlah melalui Salam Matahari dan pose kepompong untuk membangkitkan tubuh dan pikiran.",
          si: "Prehajajte med Pozdravom soncu in držo hrošča, da prebudite telo in um.",
          pl: "Przepłyń między Powitaniem Słońca a pozycją poczwarki, aby obudzić ciało i umysł.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Yoga/Sun+Salutation+and+chrysalis+yoga.mp4",
      },
      {
        duration: 21334,
        id: 915,
        name: {
          en: "Kneeling Postures",
          fr: "Postures à genoux",
          de: "Kniende Posen",
          be: "Knielende houdingen",
          tr: "Diz Çökme Duruşları",
          pt: "Posturas Ajoelhadas",
          no: "Knestillinger",
          cy: "Клечећи положаји",
          ee: "Põlvitavad asendid",
          th: "ท่าคุกเข่า",
          ar: "أوضاع الركوع",
          gr: "Στάσεις Γονατιστές",
          es: "Posturas de Rodillas",
          it: "Posizioni in ginocchio",
          id: "Kneeling Postures",
          si: "Kolena drže",
          pl: "Postawy klęczące",
        },
        preview: "https://cdn.mobio360.com/Yoga/KneelingPostures.png",
        desc: {
          en: "Practice a series of kneeling postures to build stability and ease tension.",
          fr: "Pratiquez une série de postures à genoux pour renforcer la stabilité et relâcher les tensions.",
          de: "Üben Sie eine Reihe kniender Posen, um Stabilität aufzubauen und Verspannungen zu lösen.",
          be: "Oefen een reeks knielende houdingen om stabiliteit op te bouwen en spanning te verlichten.",
          tr: "İstikrar oluşturmak ve gerginliği azaltmak için bir dizi diz çökme duruşu uygulayın.",
          pt: "Pratique uma série de posturas ajoelhadas para desenvolver estabilidade e aliviar a tensão.",
          no: "Øv på en serie knestillinger for å bygge stabilitet og lindre spenninger.",
          cy: "Вежбајте низ клечећих положаја да бисте изградили стабилност и ублажили напетост.",
          ee: "Harjutage rida põlvitavaid asendeid, et arendada stabiilsust ja leevendada pinget.",
          th: "ฝึกชุดท่าคุกเข่าเพื่อสร้างความมั่นคงและบรรเทาความตึงเครียด",
          ar: "مارس سلسلة من أوضاع الركوع لبناء الثبات وتخفيف التوتر.",
          gr: "Εξασκηθείτε σε μια σειρά γονατιστών στάσεων για να χτίσετε σταθερότητα και να ανακουφίσετε την ένταση.",
          es: "Practica una serie de posturas de rodillas para desarrollar estabilidad y aliviar la tensión.",
          it: "Pratica una serie di posizioni in ginocchio per sviluppare stabilità e alleviare la tensione.",
          id: "Latih serangkaian postur berlutut untuk membangun stabilitas dan meredakan ketegangan.",
          si: "Vadite niz klečečih drž za gradnjo stabilnosti in lajšanje napetosti.",
          pl: "Ćwicz serię pozycji klęczących, aby zbudować stabilność i złagodzić napięcie.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Kneeling+Postures+Yoga.mp4",
      },
      {
        duration: 21334,
        id: 916,
        name: {
          en: "Neck and Shoulder",
          fr: "Cou et épaules",
          de: "Nacken und Schultern",
          be: "Nek en schouders",
          tr: "Boyun ve Omuz",
          pt: "Pescoço e Ombro",
          no: "Nakke og skulder",
          cy: "Врат и рамена",
          ee: "Kael ja õlg",
          th: "คอและไหล่",
          ar: "الرقبة والكتف",
          gr: "Αυχένας και Ώμος",
          es: "Cuello y Hombro",
          it: "Collo e Spalla",
          id: "Neck and Shoulder",
          si: "Vrat in ramena",
          pl: "Szyja i barki",
        },
        preview: "https://cdn.mobio360.com/Yoga/NeckandShoulder.png",
        desc: {
          en: "Release tension in the neck and shoulders with this gentle, restorative practice.",
          fr: "Relâchez les tensions du cou et des épaules avec cette pratique douce et régénératrice.",
          de: "Lösen Sie Verspannungen in Nacken und Schultern mit dieser sanften, regenerativen Übung.",
          be: "Laat spanning in nek en schouders los met deze zachte, herstellende oefening.",
          tr: "Bu nazik, onarıcı pratikle boyun ve omuzlardaki gerginliği giderin.",
          pt: "Liberte a tensão no pescoço e nos ombros com esta prática suave e restauradora.",
          no: "Løs opp spenninger i nakke og skuldre med denne milde, gjenoppbyggende praksisen.",
          cy: "Ослободите напетост у врату и раменима овом благом, обнављајућом праксом.",
          ee: "Vabastage pinge kaelas ja õlgades selle õrna, taastava praktikaga.",
          th: "ปลดปล่อยความตึงเครียดที่คอและไหล่ด้วยการฝึกที่อ่อนโยนและฟื้นฟูนี้",
          ar: "تخلَّص من التوتر في الرقبة والكتفين بهذه الممارسة اللطيفة والمجددة.",
          gr: "Απελευθερώστε την ένταση στον αυχένα και τους ώμους με αυτή την ήπια, αναζωογονητική πρακτική.",
          es: "Libera la tensión del cuello y los hombros con esta práctica suave y restauradora.",
          it: "Rilascia la tensione nel collo e nelle spalle con questa pratica delicata e rigenerante.",
          id: "Lepaskan ketegangan di leher dan bahu dengan latihan yang lembut dan memulihkan ini.",
          si: "Sprostite napetost v vratu in ramenih s to nežno, obnovitveno vadbo.",
          pl: "Uwolnij napięcie w szyi i barkach dzięki tej łagodnej, regenerującej praktyce.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Neck+and+Shoulder+Yoga.mp4",
      },
      {
        duration: 21334,
        id: 917,
        name: {
          en: "Open-hip seated Yoga postures",
          fr: "Postures de Yoga assises hanches ouvertes",
          de: "Sitzende Yoga-Posen mit offenen Hüften",
          be: "Zittende yogahoudingen met open heupen",
          tr: "Açık Kalçalı Oturarak Yoga Duruşları",
          pt: "Posturas de Yoga Sentado com Quadris Abertos",
          no: "Sittende yogastillinger med åpne hofter",
          cy: "Седећи јога положаји за отварање кукова",
          ee: "Istuvad avatud puusaga jooga asendid",
          th: "ท่าโยคะนั่งเปิดสะโพก",
          ar: "أوضاع يوغا جالسة بمفصل ورك مفتوح",
          gr: "Καθιστές Στάσεις Γιόγκα με Ανοιχτούς Γοφούς",
          es: "Posturas de Yoga Sentado con Caderas Abiertas",
          it: "Posizioni Yoga sedute a anche aperte",
          id: "Open-hip seated Yoga postures",
          si: "Joga drže s odprtimi kolki",
          pl: "Postawy jogi w siadzie z otwartymi biodrami",
        },
        preview: "https://cdn.mobio360.com/Yoga/Open-hip.png",
        desc: {
          en: "Practice seated postures that open the hips for greater comfort and mobility.",
          fr: "Pratiquez des postures assises qui ouvrent les hanches pour plus de confort et de mobilité.",
          de: "Üben Sie sitzende Posen, die die Hüften öffnen, für mehr Komfort und Beweglichkeit.",
          be: "Oefen zittende houdingen die de heupen openen voor meer comfort en mobiliteit.",
          tr: "Daha fazla konfor ve hareketlilik için kalçaları açan oturarak duruşları uygulayın.",
          pt: "Pratique posturas sentadas que abrem os quadris para maior conforto e mobilidade.",
          no: "Øv på sittende stillinger som åpner hoftene for større komfort og bevegelighet.",
          cy: "Вежбајте седеће положаје који отварају кукове за већу удобност и покретљивост.",
          ee: "Harjutage istuvaid asendeid, mis avavad puusi suurema mugavuse ja liikuvuse jaoks.",
          th: "ฝึกท่านั่งที่เปิดสะโพกเพื่อความสบายและการเคลื่อนไหวที่ดีขึ้น",
          ar: "مارس الأوضاع الجالسة التي تفتح الوركين لمزيد من الراحة والحركة.",
          gr: "Εξασκηθείτε σε καθιστές στάσεις που ανοίγουν τους γοφούς για μεγαλύτερη άνεση και κινητικότητα.",
          es: "Practica posturas sentadas que abren las caderas para mayor comodidad y movilidad.",
          it: "Pratica posizioni sedute che aprono le anche per maggiore comfort e mobilità.",
          id: "Latih postur duduk yang membuka pinggul untuk kenyamanan dan mobilitas yang lebih baik.",
          si: "Vadite sedeče drže, ki odpirajo kolke za večje udobje in gibljivost.",
          pl: "Ćwicz pozycje siedzące, które otwierają biodra dla większego komfortu i ruchomości.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Yoga/Open-hip+seated+Yoga+postures.mp4",
      },
      {
        duration: 21334,
        id: 918,
        name: {
          en: "Outdoor The sun series yoga",
          fr: "Série du soleil en plein air",
          de: "Outdoor Sonnenserie Yoga",
          be: "Buiten zonneserie yoga",
          tr: "Açık Havada Güneş Serisi Yoga",
          pt: "Série do Sol ao Ar Livre",
          no: "Utendørs solserie yoga",
          cy: "Јога серија Сунца на отвореном",
          ee: "Õues päikeseseeria jooga",
          th: "โยคะชุดท่าพระอาทิตย์กลางแจ้ง",
          ar: "يوغا سلسلة الشمس في الهواء الطلق",
          gr: "Υπαίθρια Σειρά Ήλιου Γιόγκα",
          es: "Yoga al aire libre La serie del sol",
          it: "Serie del sole all'aperto",
          id: "Outdoor The sun series yoga",
          si: "Zunanja joga serija sonca",
          pl: "Joga na świeżym powietrzu – seria słońca",
        },
        preview: "https://cdn.mobio360.com/Yoga/Outdoorsunseries+.png",
        desc: {
          en: "Move through an outdoor sun series to energize the body and connect with nature.",
          fr: "Enchaînez une série solaire en plein air pour dynamiser le corps et vous reconnecter à la nature.",
          de: "Bewegen Sie sich durch eine Outdoor-Sonnenserie, um den Körper zu beleben und sich mit der Natur zu verbinden.",
          be: "Beweeg door een buiten zonneserie om het lichaam te energiseren en verbinding te maken met de natuur.",
          tr: "Vücudu canlandırmak ve doğayla bağlantı kurmak için açık havada bir güneş serisi boyunca hareket edin.",
          pt: "Mova-se por uma série solar ao ar livre para energizar o corpo e conectar-se com a natureza.",
          no: "Beveg deg gjennom en utendørs solserie for å gi kroppen energi og komme i kontakt med naturen.",
          cy: "Крећите се кроз соларну серију на отвореном да бисте наелектрисали тело и повезали се са природом.",
          ee: "Liikuge läbi õuese päikeseseeria, et anda kehale energiat ja luua ühendus loodusega.",
          th: "เคลื่อนไหวผ่านชุดท่าพระอาทิตย์กลางแจ้งเพื่อเสริมพลังงานให้ร่างกายและเชื่อมโยงกับธรรมชาติ",
          ar: "تحرك عبر سلسلة شمسية في الهواء الطلق لتنشيط الجسد والتواصل مع الطبيعة.",
          gr: "Κινηθείτε μέσα από μια υπαίθρια σειρά ήλιου για να ενεργοποιήσετε το σώμα και να συνδεθείτε με τη φύση.",
          es: "Muévete a través de una serie solar al aire libre para energizar el cuerpo y conectar con la naturaleza.",
          it: "Muoviti attraverso una serie solare all'aperto per energizzare il corpo e connetterti con la natura.",
          id: "Bergeraklah melalui rangkaian matahari luar ruangan untuk memberi energi pada tubuh dan terhubung dengan alam.",
          si: "Premikajte se skozi zunanjo sončno serijo, da telesu daste energijo in se povežete z naravo.",
          pl: "Przejdź przez plenerową serię słoneczną, aby dodać ciału energii i połączyć się z naturą.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Sun+Series+Yoga.mp4",
      },
      {
        duration: 21334,
        id: 919,
        name: {
          en: "Outdoor Vinyasa Flow",
          fr: "Flux Vinyasa en plein air",
          de: "Outdoor Vinyasa Flow",
          be: "Buiten Vinyasa Flow",
          tr: "Açık Havada Vinyasa Akışı",
          pt: "Fluxo Vinyasa ao Ar Livre",
          no: "Utendørs Vinyasa Flow",
          cy: "Вињаса флоу на отвореном",
          ee: "Õues Vinyasa vool",
          th: "วินยาสะโฟลว์กลางแจ้ง",
          ar: "تدفق فينياسا في الهواء الطلق",
          gr: "Υπαίθρια Ροή Vinyasa",
          es: "Flujo de Vinyasa al aire libre",
          it: "Vinyasa Flow all'aperto",
          id: "Outdoor Vinyasa Flow",
          si: "Zunanja Vinyasa Flow",
          pl: "Outdoor Vinyasa Flow",
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorVinyasa.png",
        desc: {
          en: "Flow through an outdoor Vinyasa sequence that links breath and movement in nature.",
          fr: "Enchaînez un flux Vinyasa en plein air reliant le souffle et le mouvement dans la nature.",
          de: "Fließen Sie durch eine Outdoor-Vinyasa-Sequenz, die Atem und Bewegung in der Natur verbindet.",
          be: "Vloei door een buiten Vinyasa-reeks die adem en beweging verbindt in de natuur.",
          tr: "Doğada nefes ve hareketi birbirine bağlayan açık hava Vinyasa dizisi boyunca akış sağlayın.",
          pt: "Flua por uma sequência Vinyasa ao ar livre que liga a respiração e o movimento na natureza.",
          no: "Flyt gjennom en utendørs Vinyasa-sekvens som knytter pust og bevegelse sammen i naturen.",
          cy: "Прелазите кроз Вињаса низ на отвореном који повезује дах и покрет у природи.",
          ee: "Liikuge läbi õuese Vinyasa jada, mis ühendab hingamise ja liikumise looduses.",
          th: "เคลื่อนไหวผ่านลำดับวินยาสะกลางแจ้งที่เชื่อมโยงลมหายใจและการเคลื่อนไหวในธรรมชาติ",
          ar: "انتقل عبر سلسلة فينياسا في الهواء الطلق تربط بين التنفس والحركة في الطبيعة.",
          gr: "Ρέστε μέσα από μια υπαίθρια ακολουθία Vinyasa που συνδέει την αναπνοή και την κίνηση στη φύση.",
          es: "Fluye a través de una secuencia Vinyasa al aire libre que conecta la respiración y el movimiento en la naturaleza.",
          it: "Fluisci attraverso una sequenza Vinyasa all'aperto che collega respiro e movimento nella natura.",
          id: "Mengalirlah melalui rangkaian Vinyasa luar ruangan yang menghubungkan napas dan gerakan di alam.",
          si: "Prehajajte skozi zunanje zaporedje Vinyasa, ki povezuje dih in gibanje v naravi.",
          pl: "Przepłyń przez plenerową sekwencję Vinyasa, która łączy oddech i ruch w naturze.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Vinyasa+flow.mp4",
      },
      {
        duration: 21334,
        id: 920,
        name: {
          en: "Outdoor Hip-Opener Yoga",
          fr: "Yoga ouverture des hanches en plein air",
          de: "Outdoor Hüftöffner-Yoga",
          be: "Buiten heupopener yoga",
          tr: "Açık Havada Kalça Açıcı Yoga",
          pt: "Yoga de Abertura de Quadril ao Ar Livre",
          no: "Utendørs hofteåpner-yoga",
          cy: "Јога за отварање кукова на отвореном",
          ee: "Õues puusaavaja jooga",
          th: "โยคะเปิดสะโพกกลางแจ้ง",
          ar: "يوغا فتح الورك في الهواء الطلق",
          gr: "Υπαίθρια Γιόγκα Ανοίγματος Γοφών",
          es: "Yoga al aire libre para abrir las caderas",
          it: "Yoga apertura anche all'aperto",
          id: "Outdoor Hip-Opener Yoga",
          si: "Zunanja joga za odpiranje kolkov",
          pl: "Outdoor joga otwierająca biodra",
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorHip-Opener+.png",
        desc: {
          en: "Open your hips outdoors with this restorative yoga practice.",
          fr: "Ouvrez vos hanches en plein air avec cette pratique de yoga régénératrice.",
          de: "Öffnen Sie Ihre Hüften im Freien mit dieser regenerativen Yoga-Übung.",
          be: "Open je heupen buiten met deze herstellende yogaoefening.",
          tr: "Bu onarıcı yoga pratiğiyle kalçalarınızı açık havada açın.",
          pt: "Abra os seus quadris ao ar livre com esta prática de yoga restauradora.",
          no: "Åpne hoftene dine utendørs med denne gjenoppbyggende yogapraksisen.",
          cy: "Отворите своје кукове на отвореном овом обнављајућом јога праксом.",
          ee: "Avage puusad õues selle taastava joogapraktikaga.",
          th: "เปิดสะโพกของคุณกลางแจ้งด้วยการฝึกโยคะฟื้นฟูนี้",
          ar: "افتح وركيك في الهواء الطلق بهذه الممارسة اليوغية المجددة.",
          gr: "Ανοίξτε τους γοφούς σας υπαίθρια με αυτή την αναζωογονητική πρακτική γιόγκα.",
          es: "Abre tus caderas al aire libre con esta práctica de yoga restauradora.",
          it: "Apri le tue anche all'aperto con questa pratica yoga rigenerante.",
          id: "Buka pinggul Anda di luar ruangan dengan latihan yoga pemulihan ini.",
          si: "Odprite kolke na prostem s to obnovitveno jogo.",
          pl: "Otwórz biodra na świeżym powietrzu dzięki tej regenerującej praktyce jogi.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Hip+Opener+Yoga.mp4",
      },
      {
        duration: 21334,
        id: 921,
        name: {
          en: "Outdoor Neck and Shoulders Yoga",
          fr: "Yoga cou et épaules en plein air",
          de: "Outdoor Nacken- und Schulter-Yoga",
          be: "Buiten nek- en schouderyoga",
          tr: "Açık Havada Boyun ve Omuz Yogası",
          pt: "Yoga de Pescoço e Ombros ao Ar Livre",
          no: "Utendørs nakke- og skulderyoga",
          cy: "Јога за врат и рамена на отвореном",
          ee: "Õues kaela ja õlgade jooga",
          th: "โยคะคอและไหล่กลางแจ้ง",
          ar: "يوغا الرقبة والكتفين في الهواء الطلق",
          gr: "Υπαίθρια Γιόγκα Αυχένα και Ώμων",
          es: "Yoga al aire libre para cuello y hombros",
          it: "Yoga collo e spalle all'aperto",
          id: "Outdoor Neck and Shoulders Yoga",
          si: "Zunanja joga za vrat in ramena",
          pl: "Outdoor joga otwierająca biodra",
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorNeckandShoulders.png",
        desc: {
          en: "Release tension in the neck and shoulders outdoors with this calming practice.",
          fr: "Relâchez les tensions du cou et des épaules en plein air avec cette pratique apaisante.",
          de: "Lösen Sie Verspannungen in Nacken und Schultern im Freien mit dieser beruhigenden Übung.",
          be: "Laat spanning in nek en schouders buiten los met deze kalmerende oefening.",
          tr: "Bu sakinleştirici pratikle boyun ve omuzlardaki gerginliği açık havada giderin.",
          pt: "Liberte a tensão no pescoço e nos ombros ao ar livre com esta prática calmante.",
          no: "Løs opp spenninger i nakke og skuldre utendørs med denne beroligende praksisen.",
          cy: "Ослободите напетост у врату и раменима на отвореном овом смирујућом праксом.",
          ee: "Vabastage pinge kaelas ja õlgades õues selle rahustava praktikaga.",
          th: "ปลดปล่อยความตึงเครียดที่คอและไหล่กลางแจ้งด้วยการฝึกที่ผ่อนคลายนี้",
          ar: "تخلَّص من التوتر في الرقبة والكتفين في الهواء الطلق بهذه الممارسة المهدئة.",
          gr: "Απελευθερώστε την ένταση στον αυχένα και τους ώμους υπαίθρια με αυτή την ηρεμιστική πρακτική.",
          es: "Libera la tensión del cuello y los hombros al aire libre con esta práctica calmante.",
          it: "Rilascia la tensione nel collo e nelle spalle all'aperto con questa pratica rilassante.",
          id: "Lepaskan ketegangan di leher dan bahu di luar ruangan dengan latihan menenangkan ini.",
          si: "Sprostite napetost v vratu in ramenih na prostem s to pomirjujočo vadbo.",
          pl: "Uwolnij napięcie w szyi i barkach na świeżym powietrzu dzięki tej uspokajającej praktyce.",
        },
        videoUrl:
          "https://cdn.mobio360.com/Yoga/Outdoor+Neck+and+Shoulders+Yoga.mp4",
      },
      {
        duration: 21334,
        id: 922,
        name: {
          en: "Outdoor Leg Yoga",
          fr: "Yoga jambes en plein air",
          de: "Outdoor Bein-Yoga",
          be: "Buiten beenyoga",
          tr: "Açık Havada Bacak Yogası",
          pt: "Yoga de Pernas ao Ar Livre",
          no: "Utendørs beinyoga",
          cy: "Јога за ноге на отвореном",
          ee: "Õues jalgade jooga",
          th: "โยคะขากลางแจ้ง",
          ar: "يوغا الساقين في الهواء الطلق",
          gr: "Υπαίθρια Γιόγκα Ποδιών",
          es: "Yoga de piernas al aire libre",
          it: "Yoga gambe all'aperto",
          id: "Outdoor Leg Yoga",
          si: "Zunanja joga za noge",
          pl: "Outdoor joga na nogi",
        },
        preview: "https://cdn.mobio360.com/Yoga/OutdoorLegYoga.png",
        desc: {
          en: "Build strength and flexibility in your legs with this outdoor yoga practice.",
          fr: "Développez force et souplesse de vos jambes avec cette pratique de yoga en plein air.",
          de: "Bauen Sie Kraft und Flexibilität in Ihren Beinen mit dieser Outdoor-Yoga-Übung auf.",
          be: "Bouw kracht en flexibiliteit in je benen op met deze buiten yogaoefening.",
          tr: "Bu açık hava yoga pratiğiyle bacaklarınızda güç ve esneklik oluşturun.",
          pt: "Desenvolva força e flexibilidade nas pernas com esta prática de yoga ao ar livre.",
          no: "Bygg styrke og fleksibilitet i beina med denne utendørs yogapraksisen.",
          cy: "Изградите снагу и флексибилност ногу овом јога праксом на отвореном.",
          ee: "Arendage jalgade jõudu ja painduvust selle õuese joogapraktikaga.",
          th: "สร้างความแข็งแรงและความยืดหยุ่นของขาด้วยการฝึกโยคะกลางแจ้งนี้",
          ar: "ابنِ القوة والمرونة في ساقيك بهذه الممارسة اليوغية في الهواء الطلق.",
          gr: "Χτίστε δύναμη και ευλυγισία στα πόδια σας με αυτή την υπαίθρια πρακτική γιόγκα.",
          es: "Desarrolla fuerza y flexibilidad en tus piernas con esta práctica de yoga al aire libre.",
          it: "Sviluppa forza e flessibilità nelle gambe con questa pratica yoga all'aperto.",
          id: "Bangun kekuatan dan fleksibilitas kaki Anda dengan latihan yoga luar ruangan ini.",
          si: "Zgradite moč in prožnost nog s to zunanjo jogo.",
          pl: "Zbuduj siłę i elastyczność nóg dzięki tej plenerowej praktyce jogi.",
        },
        videoUrl: "https://cdn.mobio360.com/Yoga/Outdoor+Leg+Yoga.mp4",
      },
    ],
  },
];

export let SportsVideos360ZA = [
  {
    id: 75,
    contents: 7,
    categoryName: {
      en: "Cricket",
      id: "Kriket",
      pl: "Krykiet",
      es: "Críquet",
      cy: "Крикет",
    },
    videos: [
      {
        duration: 21334,
        id: 756,
        name: {
          en: "Murdoch University Free-Thinking Virtual Reality Cricket Experience",
          id: "Pengalaman bermain kriket realitas virtual yang membebaskan pikiran di Universitas Murdoch",
          cy: "Murdoch University слободоумно VR искуство крикета",
        },
        preview:
          "https://cdn.mobio360.com/Cricket/Murdoch+University+Free-Thinking+Virtual+Reality+Cricket+Experience.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Cricket/Murdoch+University+Free-Thinking+Virtual+Reality+Cricket+Experience.mp4",
      },
      // {
      //   duration: 21334,
      //   id: 757,
      //   name: {
      //     en: "VRiczat Cricket 360 Video",
      //   },
      //   preview:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.jpeg",
      //   desc: "",
      //   videoUrl:
      //     "https://cdn.mobio360.com/Cricket/VRiczat+Cricket+360+Video.mp4",
      // },
      {
        duration: 21334,
        id: 758,
        name: {
          en: "MU Scorchers VR 2022",
          id: "MU Skorcher VR 2022",
          pl: "MU Scorchers VR 2022",
          cy: "MU Scorchers VR 2022",
        },
        preview: "https://cdn.mobio360.com/Cricket/MU+Scorchers+VR+2022.jpeg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Cricket/MU+Scorchers+VR+2022.mp4",
      },
      {
        duration: 21334,
        id: 759,
        name: {
          en: "Peet Communities Street Cricket sponsorship activation",
          id: "Aktivasi sponsor Peet Communities Street Cricket",
          pl: "Aktywacja sponsorowania Street Cricket przez Peet Communities",
          cy: "Peet Communities спонзорска активација уличног крикета",
        },
        preview:
          "https://cdn.mobio360.com/Cricket/Peet+Communities+Street+Cricket+sponsorship+activation.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Cricket/Peet+Communities+Street+Cricket+sponsorship+activation.mp4",
      },
    ],
  },
  {
    id: 76,
    contents: 6,
    categoryName: {
      en: "Rugby",
      id: "Rugbi",
      pl: "Rugby",
    },
    videos: [
      {
        duration: 21334,
        id: 761,
        name: {
          en: "Experience The Haka In 360!",
          id: "Rasakan The Haka dalam 360!",
          pl: "Doświadcz Haki w 360 stopniach!",
          cy: "Доживите Хаку у 360!",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/Experience+The+Haka+In+360!.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/Experience+The+Haka+In+360!.mp4",
      },
      {
        duration: 21334,
        id: 762,
        name: {
          en: "Lions Rugby Team 360° Virtual Reality Video",
          id: "Video Virtual Reality 360° Tim Rugby Singa",
          pl: "Film w wirtualnej rzeczywistości 360° drużyny rugby Lions",
          cy: "360° видео виртуелне реалности рагби тима Лајонс",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/Lions+Rugby+Team+360%C2%B0+Virtual+Reality+Video.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/Lions+Rugby+Team+360%C2%B0+Virtual+Reality+Video.mp4",
      },
      {
        duration: 21334,
        id: 763,
        name: {
          en: "PLAY RUGBY IN 360° - ER7 Cup",
          id: "Mainkan rugby dalam 360° - Piala ER7",
          pl: "Grajnij w rugby w 360° - Puchar ER7",
          cy: "ИГРАЈ РАГБИ У 360° – ЕР7 куп",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/PLAY+RUGBY+IN+360%C2%B0+-+ER7+Cup.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/PLAY+RUGBY+IN+360%C2%B0+-+ER7+Cup.mp4",
      },
      {
        duration: 21334,
        id: 764,
        name: {
          en: "SAMSUNG SCHOOL OF RUGBY - 360 VIDEO",
          id: "Sekolah Rugby Samsung - Video 360",
          pl: "SAMSUNG SZKOŁA RUGBY - WIDEO 360",
          cy: "САМСУНГ ШКОЛА РАГБИЈА – 360 ВИДЕО",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/SAMSUNG+SCHOOL+OF+RUGBY+-+360+VIDEO.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/SAMSUNG+SCHOOL+OF+RUGBY+-+360+VIDEO.mp4",
      },
      {
        duration: 21334,
        id: 765,
        name: {
          en: "The 360 Tour Ashton Gate On A Bristol Rugby Matchday",
          id: "Tur 360 di Ashton Gate ing hari pertandingan rugby Bristol",
          pl: "360 Tour Ashton Gate podczas meczu rugby Bristol",
          cy: "360 тура стадиона Ештон Гејт на дан утакмице Бристол рагбија",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/The+360+Tour+Ashton+Gate+On+A+Bristol+Rugby+Matchday.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/The+360+Tour+Ashton+Gate+On+A+Bristol+Rugby+Matchday.mp4",
      },
      {
        duration: 21334,
        id: 766,
        name: {
          en: "VIRTUAL REALITY 360° VIDEO RUGBY",
          id: "VIDEO RUGBY 360° REALITAS VIRTUAL",
          pl: "WIRTUALNA RZECZYWISTOŚĆ WIDEO 360° RUGBY",
          cy: "ВИРТУЕЛНА РЕАЛНОСТ 360° ВИДЕО РАГБИ",
        },
        preview:
          "https://cdn.mobio360.com/Rugby/VIRTUAL+REALITY+360%C2%B0+VIDEO+RUGBY.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Rugby/VIRTUAL+REALITY+360%C2%B0+VIDEO+RUGBY.mp4",
      },
    ],
  },
];

export let SportsVideos360CI = [
  {
    id: 91,
    contents: 2,
    categoryName: {
      en: "Football",
      id: "Sepak bola",
    },
    videos: [
      {
        duration: 21334,
        id: 761,
        name: {
          en: "FOOTBALL VR 360° Video",
          id: "Video VR 360° Sepak Bola",
        },
        preview:
          "https://cdn.mobio360.com/Football/FOOTBALL+VR+360%C2%B0+Video.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Football/FOOTBALL+VR+360%C2%B0+Video.mp4",
      },
      {
        duration: 21334,
        id: 762,
        name: {
          en: "LOSC FOOTBALL 360°EXPERIENCE",
          id: "Pengalaman sepak bola LOSC 360°",
        },
        preview:
          "https://cdn.mobio360.com/Football/LOSC+FOOTBALL+360%C2%B0EXPERIENCE.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Football/LOSC+FOOTBALL+360%C2%B0EXPERIENCE.mp4",
      },
    ],
  },
];

export let NewArrivalsVideosSA = [
  {
    id: 24,
    contents: 5,
    categoryName: {
      en: "New Arrivals",
      id: "Kedatangan baru",
    },
    videos: [
      {
        duration: 21334,
        id: 241,
        name: {
          en: "Lemur - Discovery Animal Nature",
          id: "Lemur - Penemuan Hewan Alam",
        },
        preview:
          "https://cdn.mobio360.com/3D+Fun/Lemur+-+Discovery+Animal+Nature.jpg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/3D+Fun/Lemur+-+Discovery+Animal+Nature.mp4",
      },
      {
        duration: 21334,
        id: 242,
        name: {
          en: "Ostriches - Discovery Nature Animal",
          id: "Burung unta - Penemuan Alam Hewan",
        },
        preview:
          "https://cdn.mobio360.com/3D+Fun/Ostriches+-+Discovery+Nature+Animal.jpg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/3D+Fun/Ostriches+-+Discovery+Nature+Animal.mp4",
      },
      {
        duration: 21334,
        id: 243,
        name: {
          en: "360 Rollercoaster",
          id: "Rollercoaster 360",
        },
        preview: "https://cdn.mobio360.com/Adventure/360+Rollercoaster.jpeg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Adventure/360+Rollercoaster.mp4",
      },
      {
        duration: 21334,
        id: 244,
        name: {
          en: "Parrot In Your Hand",
          id: "Burung Beo Di Tanganmu",
        },
        preview: "https://cdn.mobio360.com/Adventure/Parrot+In+Your+Hand.jpeg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/Adventure/Parrot+In+Your+Hand.mp4",
      },
      {
        duration: 21334,
        id: 245,
        name: {
          en: "Elephant - Discovery Animal Nature",
          id: "Gajah - Penemuan Hewan Alam",
        },
        preview:
          "https://cdn.mobio360.com/Amazement/Elephant+-+Discovery+Animal+Nature.jpg",
        desc: "",
        videoUrl:
          "https://cdn.mobio360.com/Amazement/Elephant+-+Discovery+Animal+Nature.mp4",
      },
    ],
  },
];

export let GrandTheftAutoVideosPL = [
  {
    id: 100,
    contents: 9,
    categoryName: {
      en: "Grand Theft Auto",
      pl: "Grand Theft Auto",
    },
    videos: [
      {
        duration: 21334,
        id: 1001,
        name: {
          en: "Driving And Navigation",
          pl: "Jazda i nawigacja",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/driving-and-navigation.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/driving-and-navigation.mp4",
      },
      {
        duration: 21334,
        id: 1002,
        name: {
          en: "How Missions Work",
          pl: "Jak działają misje",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/how-missions-work.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/how-missions-work.mp4",
      },
      {
        duration: 21334,
        id: 1003,
        name: {
          en: "How Open World Games Work",
          pl: "Jak działają gry z otwartym światem",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/how-open-world-games-work.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/how-open-world-games-work.mp4",
      },
      {
        duration: 21334,
        id: 1004,
        name: {
          en: "The Open World Gameplay Loop",
          pl: "Pętla rozgrywki w otwartym świecie",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/the-open-world-gameplay-loop.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/the-open-world-gameplay-loop.mp4",
      },
      {
        duration: 21334,
        id: 1005,
        name: {
          en: "Vice City And Leonida Setting Explained",
          pl: "Vice City i Leonida – wyjaśnienie świata gry",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/vice-city-and-leonida-setting-explained.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/vice-city-and-leonida-setting-explained.mp4",
      },
      {
        duration: 21334,
        id: 1006,
        name: {
          en: "What Is Grand Theft Auto",
          pl: "Czym jest Grand Theft Auto",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/what-is-grand-theft-auto.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/what-is-grand-theft-auto.mp4",
      },
      {
        duration: 21334,
        id: 1007,
        name: {
          en: "What Is Officially Confirmed",
          pl: "Co zostało oficjalnie potwierdzone",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/what-is-officially-confirmed.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/what-is-officially-confirmed.mp4",
      },
      {
        duration: 21334,
        id: 1008,
        name: {
          en: "Who Are Jason And Lucia",
          pl: "Kim są Jason i Lucia",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/who-are-jason-and-lucia.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/who-are-jason-and-lucia.mp4",
      },
      {
        duration: 21334,
        id: 1009,
        name: {
          en: "Why A Major Gaming Event",
          pl: "Dlaczego to ważne wydarzenie w świecie gier",
        },
        preview: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/why-a-major-gaming-event.jpg",
        desc: "",
        videoUrl: "https://cdn.mobio360.com/new+videos/GrandTheftAuto/why-a-major-gaming-event.mp4",
      },
    ],
  },
];

if (config.domain === "za") Videos360 = [...SportsVideos360ZA, ...Videos360];
if (config.domain === "ci") Videos360 = [...SportsVideos360CI, ...Videos360];
if (config.domain === "sa") Videos360 = [...NewArrivalsVideosSA, ...Videos360];
if (config.domain === "pl") Videos360 = [...GrandTheftAutoVideosPL, ...Videos360];



// WEBPACK FOOTER //
// ./src/constants/videos.js